/* eslint-disable */
let componys = [
{
  name: 'XYZ Robotics',
  intro: `星猿哲科技（XYZ Robotics）成立于2018年，总部位于中国上海，在美国波士顿设有研发办公室。XYZ Robotics 的技术团队曾连续三年获 Amazon Robotics Challenge 全球前三。公司凭借全球领先的3D视觉 + 控制器技术，为物流、制造行业提供更高效更准确更易部署的小件分拣、中件拆码垛、工件上下料装配等柔性解决方案。`,
  img: true,
  city: '上海',
  field: '人工智能 机器人',
  scale: '1-50人',
  financing: 'A轮',
  web: 'www.xyzrobotics.ai',
  tags: ['岗位晋升', '弹性工作', '绩效奖金', '带薪年假', '股票期权', '定期体检', '扁平化管理', '午餐补贴'],
  jds: [{
      name: '机器人3D视觉算法工程师',
      city: '上海',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `岗位职责：
        1. 负责机器人操作的2D/3D感知算法的研发

        任职要求：
        1.计算机、自动化、机器人等相关专业，具有良好的图像处理基础和数学基础
        2.熟悉C++，编程、算法基础扎实
        3.熟悉点云处理、ICP、点云聚类等常见点云算法
        4.了解OpenCV、PCL、open3d等常见开源库
        5.有丰富的RGB图像和点云数据处理经验，例如位姿估计、多视几何视觉等

        加分项：
        1.了解并行计算、CUDA、SIMD指令集、算法优化等高性能计算知识者优先
        2.有 SLAM 相关经验
        3.熟悉计算机图形学和3D建模、渲染等
        4.有ACM-ICPC编程比赛、机器人比赛或大型硬件软件集成系统开发的经验
        5.熟悉常见图像算法、点云算法的高性能实现者优先`
    }, {
      name: '机器人3D成像算法工程师',
      city: '上海',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `岗位职责：
        1.负责传感器3D成像的算法开发
        2.负责3D传感器相关驱动编写，对接应用算法开

        任职要求：
        1.计算机、电子信息类相关专业，相关领域的工作经验；
        2.具有良好的数据结构和算法基础，精通python、·C ++编程及maltab数据分析；
        3.熟练Windows/Linux开发环境，具有良好的编程习惯和编写文档的能力；
        4.扎实的线性代数基础，有相机标定、多视几何和点云数据处理经验；
        5.良好的沟通能力和团队协作能力；

        加分项：
        1.了解双目视觉、结构光、ToF3D深度摄像头原理，具有其中至少一种摄像头相关项目经验；如：体积测量、SLAM、3D活体识别、人体支架识别；
        2.基本的光学器件知识；
        3.有大规模软件系统开发经验优先；
        4.有 ACM-ICPC 编程⽐赛、机器⼈⽐赛或⼤型硬件软件集成系统开发的经验；相关行业经验者优先，如机器人公司使用过3D摄像头、AI算法公司3D方向、图像算法公司等`
    }, {
      name: '深度学习工程师',
      city: '上海',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `岗位职责：
        1.开发应用于机器人操作的高精度物体识别与抓取规划模型

        任职要求：
        1.计算机、机器人等相关专业的硕⼠和博士毕业生，或有丰富项⽬经验的本科生
        2.深入了解至少一种主流深度学习框架：PyTorch、TensorFlow、MXNet等
        3.扎实的线性代数和概率论基础
        4.精通基于深度学习的目标识别和分割方法
        5.有GPU编程的项目经验，熟悉CUDA、OpenCL等
        6.自主论文钻研能力

        加分项：
        1.有RGBD网络架构设计经验
        2.熟悉零样本学习(zero-shot learning)、单样本学习(few-shot learning)
        3.熟悉前景背景分割
        4.熟悉点云深度学习架构
        5.了解位姿估计、多视几何
        6.有图形学渲染经验
        7.有ACM-ICPC编程比赛、机器人比赛或大型硬件软件集成系统开发的经验
        8.相关工作或实习经验`
    }, {
      name: '机器人算法工程师',
      city: '上海',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `岗位职责：
        1.负责开发快速稳定的无碰撞且时间最优的机械臂轨迹生成的算法
        2.负责抓取动作规划

        任职要求：
        1.机器人专业、电子电气、计算机等相关专业的硕士或博士毕业生
        2.扎实的线性代数基础
        3.精通刚体和串联机器人动力学
        4.熟悉带约束条件的几何路径规划算法
        5.了解碰撞检测和几何表示

        加分项：
        1.熟悉基于优化的运动规划
        2.熟悉力阻抗控制
        3.了解抓取规划和力学分析`
    }, {
      name: '机械设计工程师（智能末端执行器）',
      city: '上海',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 设计机械手末端的夹具、快换与力传感, 与供应商合作解决抓取多样性问题, 与美国团队协同进行产品开发。
        2. 产品化开发，生产装配工艺、成本、可靠性。
        3. 管理零组件的制造和装配过程。
        4. 零组件的单元测试，并支持系统测试。
        5. BOM维护，采购的进度跟踪、定制部件的协调。

        任职要求：
        1. 机械、电气等相关领域的本科学位。
        2. 有三年以上硬件研发设计相关工作经验，并有强烈兴趣在硬件开发上持续发展。
        3. 扎实的SolidWorks软件能力。
        4. 热爱机械设计。
        5. 有独立的机械设计开发经验。
        6. 熟悉制造流程与工艺，包括3D打印机、钻头、铣床和CNC。
        7. 了解公差配合、机械原理、传动原理。
        8. 广泛调研夹爪（气动软指，电爪气爪，连杆驱动，混合)和手臂工具快换系统。

        加分项：
        1. 有良好的英语读写能力。
        2. 了解力传感、应变片原理。
        3. 深入理解真空元器件原理。
        4. 具有部署机器人自动化系统的经验。
        5. 有丰富的设计和制造机电设备的经验。
        6. 精通机械设计软件，独立负责过硬件产品的开发全过程。`
    }, {
      name: '机器人视觉工程师',
      city: '上海',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 负责2D、3D视觉项目评估，测试。
        2. 在技术经理指导下负责视觉技术方案设计，程序编写。

        任职要求：
        1. 计算机、自动化、机器人等相关专业，了解图像处理基础。
        2. 熟悉C++，熟悉至少一种图像处理软件（Halcon/VisionPro/OpenCV等）。
        3. 负责公司视觉软件功能应用的二次开发与测试。
        4. 负责编写测试报告、软件使用说明文档及培训工作。
        5. 具备较强的学习能力、善于沟通、乐于沟通。

        加分项：
        1. 有视觉算法开发或优化经验者。
        2. 有视觉系统与工业机器人控制软件的集成及调试经验。
        3. 熟悉常见点云算法（点云处理、ICP、点云聚类等）。
        4. 熟悉机器视觉镜头，光源，相机的特点和选型，熟练进行视觉系统的搭建和结构设计。`
    },
    {
      name: 'Python开发工程师（后端开发）​',
      city: '上海',
      salary: '12-14K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 和上下游客户/内部团队沟通通讯需求，定义接口，撰写接口文档，并进行开发和测试工作​
        2. 负责/协助项目现场和上下游客户联调工作​
        3. 搭建客户端与机器人通过socket通信, 并解析/转换通信数据

        任职要求：
        1. 本科及以上学历， 计算机, 通信与数学专业优先​
        2. 熟练掌握python网络编程,了解TCP/IP协议； ​
        3. 具有算法基础​
        4. 强沟通能力和团队协作能力，抗压能力强；​
        5. 思维灵活,对技术保持好奇,乐于专研

        加分项：
        1. 熟悉ROS (Robot Operating System)​
        2. 熟悉仓储管理系统 (WMS, WCS)​
        3. 参与过大型项目开发`
    }, {
      name: '高级嵌入式软件工程师',
      city: '上海',
      salary: '20-40K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1、负责公司工业相机嵌入式产品的程序及接口驱动程序开发；
        2、根据产品功能定义，完成具体的代码实现和调试改进；
        3、根据产品需求，协同系统/算法工程师完成嵌入式平台选型评估、系统方案设计、产品测试方案；
        4、编写软件相关的设计文档和测试要求。

        任职要求：
        1、统招本科及以上学历，电子、通信、自动化等相关专业；5年以上相关经验；
        2、C/C++语言功底扎实，熟悉linux、arm，具有良好的计算机体系结构和算法基础；
        3、有基于TX2、NX、瑞芯微等嵌入式平台的产品开发经验；
        4、熟悉常见通信协议（I2C、SPI、UART等），了解GigE Vision图像传输标准及GenICam编程接口；
        5、具备较好的英语阅读能力、较强的学习能力；

        加分项：
        1、有成熟系统开发经验，熟悉系统从产品规划、产品定义、开发、生产、测试等多个环节，了解各环节的关键工艺流程。`
    }, {
      name: 'C++工程师',
      city: '上海',
      salary: '15-35K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        负责机器人、视觉相关软件的研发、测试、文档编写等工作

        任职要求：
        1. 本科及以上学历，硕士优先；
        2. 编程基本功扎实，熟练掌握C++，实践经验丰富；
        3. 熟悉C++编译链接流程，会使用Git，CMake等工具；
        4. 熟悉Qt或其他GUI框架者优先 ；
        5. 有Linux下开发经验者优先；
        6. 能够顺畅地读写英文论文和文档；
        7. 自我驱动，追求工作的成就感和价值；
        8. 具有良好的团队合作能力和沟通能力。`
    }, {
      name: '高级视觉算法工程师（位姿估计）',
      city: '上海',
      salary: '30-50K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        负责对堆叠物体6D姿态估计算法开发和高性能实现

        任职要求：
        1. 计算机、自动化、机器人等相关专业，具有良好的图像处理基础和数学基础；
        2. 熟悉C++，编程、算法基础扎实；
        3. 熟悉点云处理、ICP、点云聚类等常见点云算法；
        4. 了解OpenCV、PCL、open3d等常见开源库；
        5. 有丰富的RGB图像和点云数据处理经验，例如位姿估计、多视几何视觉等。

        加分项：
        1. 了解并行计算、CUDA、SIMD指令集、算法优化等高性能计算知识者优先；
        2. 有 SLAM 相关经验；
        3. 熟悉计算机图形学和3D建模、渲染等；
        4. 有ACM-ICPC编程比赛、机器人比赛或大型硬件软件集成系统开发的经验；
        5. 熟悉常见图像算法、点云算法的高性能实现者优先。`
    }, {
      name: '深度学习算法专家（几何视觉方向）',
      city: '上海',
      salary: '30-50K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        用深度学习的方法做几何视觉的相关任务（位姿估计、深度估计等）

        任职要求：
        1. 计算机、机器人等相关专业的硕⼠和博士毕业生，或有丰富项⽬经验的本科生；
        2. 深入了解至少一种主流深度学习框架：PyTorch、TensorFlow、MXNet等；
        3. 扎实的线性代数和概率论基础；
        4. 精通基于深度学习的目标识别和分割方法；
        5. 有GPU编程的项目经验，熟悉CUDA、OpenCL等；
        6. 自主论文钻研能力。

        加分项：
        1. 有RGBD网络架构设计经验；
        2. 熟悉零样本学习(zero-shot learning)、单样本学习(few-shot learning)；
        3. 熟悉前景背景分割；
        4. 熟悉点云深度学习架构；
        5. 了解位姿估计、多视几何；
        6. 有图形学渲染经验；
        7. 有ACM-ICPC编程比赛、机器人比赛或大型硬件软件集成系统开发的经验；
        8. 有计算机视觉或机器人领域的顶级会议的论文发表。`
    }, {
      name: '机器人3D视觉算法工程师',
      city: '上海',
      salary: '20-40K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        负责机器人操作的2D/3D感知算法的研发

        任职要求：
        1. 计算机、自动化、机器人等相关专业，具有良好的图像处理基础和数学基础
        2. 熟悉C++，编程、算法基础扎实
        3. 熟悉点云处理、ICP、点云聚类等常见点云算法
        4. 了解OpenCV、PCL、open3d等常见开源库
        5. 有丰富的RGB图像和点云数据处理经验，例如位姿估计、多视几何视觉等

        加分项：
        1. 了解并行计算、CUDA、SIMD指令集、算法优化等高性能计算知识者优先
        2. 有 SLAM 相关经验
        3. 熟悉计算机图形学和3D建模、渲染等
        4. 有ACM-ICPC编程比赛、机器人比赛或大型硬件软件集成系统开发的经验
        5. 熟悉常见图像算法、点云算法的高性能实现者优先`
    }, {
      name: '机器人3D成像算法工程师',
      city: '上海',
      salary: '20-40K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        负责传感器3D成像的算法开发

        任职要求：
        1. 计算机、电子、自动化等相关专业的本科、硕⼠或博⼠毕业⽣
        2. 精通 Python、C++ 编程技巧并有相关软件⼯程项⽬经验
        3. 扎实的线性代数基础
        4. 有相机标定、多视几何和点云数据处理经验
        加分项：
        1. 有 FPGA经验
        2. 有CUDA编程经验
        3. 基本的光学器件知识
        4. 有 ACM-ICPC 编程⽐赛、机器⼈⽐赛或⼤型硬件软件集成系统开发的经验。`
    }, {
      name: '产品测试工程师',
      city: '上海',
      salary: '15-30K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 负责软件产品及工业相机产品发布前的功能，性能，压力测试
        2. 负责编写测试用例，根据项目需求进行测试，编写测试报告反馈给研发团队
        3. 发现问题、提交问题及改进方案、帮助研发人员复现问题、跟踪问题解决进度，复测问题
        4. 跟踪需求方提出的需求，与开发人员共同参与新需求的评估、方案的确定 
        5. 编写操作手册、教学视频，维护产品使用文档
        6. 准备培训材料，负责对公司现场实施工程师进行培训。

        任职要求：
        1. 统招本科及以上学历，机械、自动化等相关专业，1年以上测试工作经验。
        2. 熟悉常用测试方法和工具，熟悉软件件测试规范，熟悉测试常规流程，善于从使用者角度考虑问题，拥有用户思维；
        3.能够在Linux下编写测试脚本完成自动化测试和测试结果分析；了解python/C++等常用编程语言
        4. 良好的团队协作能力、沟通能力和中英文文档撰写能力；`
    }, {
      name: '视觉工程师',
      city: '上海',
      salary: '20-40K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 负责2D、3D视觉项目评估，测试。
        2. 在技术经理指导下负责视觉技术方案设计，程序编写。

        任职要求：
        1. 计算机、自动化、机器人等相关专业，了解图像处理基础。
        2. 熟悉C++，熟悉至少一种图像处理软件（Halcon/VisionPro/OpenCV等）。
        3. 负责公司视觉软件功能应用的二次开发与测试。
        4. 负责编写测试报告、软件使用说明文档及培训工作。
        5. 具备较强的学习能力、善于沟通、乐于沟通。

        加分项：
        1. 有视觉算法开发或优化经验者。
        2. 有视觉系统与工业机器人控制软件的集成及调试经验。`
    }, {
      name: '产品经理',
      city: '上海',
      salary: '20-35K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 快速学习和了解公司软件功能，充分理解其适用范围 
        2. 深度走访客户，产品策略制定、更新以及产品市场机会信息收集、分析、评估；将需求有效转化为研发任务
        3. 产品规划和推广以及产品路线图的制订、更新、实施以及表现跟踪和分析；
        4. 负责参与重点产品系统设计、进度跟踪、成本控制以及市场推广，保证产品的最终成功；
        5. 加强产品的全局性管理，积极组织内部、外部各类资源，推动各环节重要问题的有效解决，全力提升产品整体竞争力和投入产出比；
        6. 负责管理和推进新功能的开发及导入，并制定相关策划方案用于市场推广；

        任职要求：
        1. 本科以上学历，理工科背景，3年以上的工业软件产品工作经验，有工业/物流机器人应用，机器视觉相关产品经理经验尤佳
        2. 具有丰富的产品原型设计能力，完成流程图，概念图，原型图等设计；
        3. 熟悉产品规划过程，包括市场分析、需求分析、产品功能设计、业务流程设计、界面设计、用户研究和可用性测试等；
        4. 强烈的责任心和上进心，具备良好的团队合作精神；
        5. 具有出色的语言、沟通、组织和协调能力。能和非技术背景客户沟通，也能和技术背景研发人员流畅沟通`
    }, {
      name: '机械与方案工程师',
      city: '上海',
      salary: '15-25K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 负责机械机器人系统工作站布局方案设计及项目细化设计
        2. 负责项目方案成本报价
        3. 负责项目工程图纸出图及BOM编制
        4. 与客户沟通相关项目需求
        5.. 配合电气及软件工程师进行项目调试
        6. 解决项目调试中遇到的硬件问题

        任职要求：
        1. 机械及自动化类相关专业，3年以上工作经验；
        2. 熟练使用Solidworks、AutoCAD、办公软件等；
        3. 具有气动夹具，自动化夹具设计能力；
        4. 熟悉气动原理；
        5. 综合能力强，能处理好客户前期方案沟通，善于学习，有团队合作精神；
        6. 熟悉机械臂应用

        加分项：
        熟练运用机器人仿真软件Robotstudio，Robotguide或PDPS`
    }, {
      name: '机械设计工程师（机械手末端夹具）',
      city: '上海',
      salary: '20-30K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 设计机械手末端的夹具、快换与力传感, 与供应商合作解决抓取多样性问题；
        2. 产品化开发，生产装配工艺、成本、可靠性；
        3. 管理零组件的制造和装配过程；
        4. 零组件的单元测试，并支持系统测试；
        5. BOM维护，采购的进度跟踪、定制部件的协调。

        任职要求：
        1. 机械、电气等相关领域的本科学位；
        2. 有三年以上硬件研发设计相关工作经验，并有强烈兴趣在硬件开发上持续发展；
        3. 扎实的SolidWorks软件能力；
        4. 热爱机械设计；
        5. 有独立的机械设计开发经验；
        6. 熟悉制造流程与工艺，包括3D打印机、钻头、铣床和CNC；
        7. 了解公差配合、机械原理、传动原理；
        8. 广泛调研夹爪（气动软指，电爪气爪，连杆驱动，混合)和手臂工具快换系。

        加分项：
        1. 有良好的英语读写能力；
        2. 了解力传感、应变片原理；
        3. 深入理解真空元器件原理；
        4. 具有部署机器人自动化系统的经验；
        5. 有丰富的设计和制造机电设备的经验；
        6. 精通机械设计软件，独立负责过硬件产品的开发全过程。`
    }, {
      name: '机器人应用/调试工程师',
      city: '上海',
      salary: '8-12K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 负责项目现场的机器人视觉分拣产品安装部署，主要为安装标定公司的视觉产品，负责机器人调试, 优化机器人运动轨迹，提升节拍；
        2. 学习公司的产品部署流程，品质控制流程；
        3. 负责推动项目现场的问题解决，协调现场调试的进度，配合项目经理完成项目验收。对客户进行技术培训，使用拣选机器人的操作界面，编写操作手册;
        4. 项目现场调试过程中关注设备的运行状况，提出设备质量改进建议；
        5. 独立诊断并解决常规的技术问题；
        6. 及时与研发工程师沟通，寻求难点支持；
        7. 积极编写项目总结文档；

        任职要求：
        1. 本科及以上学历；
        2. 理工科（自动化、机械、电气、计算机等）相关专业；
        3. 1年以上相关经验；
        4. 可接受出差;
        5. 有ABB、发那科、安川、库卡、UR等机器人调试或3D视觉的调试经验者优先；
        6. 自动化类、电气类调试经验；
        7. 具备较强的学习能力、善于沟通、乐于沟通；
        8. 有Python编程经验优先;
        9. 有plc编程经验优先；`
    }, {
      name: '专利工程师',
      city: '上海',
      salary: '20-30K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 了解公司的核心技术及产品，进行专利的OA答复、复审申请文件准备；
        2. 根据产品技术情况对公司技术进行专利布局挖掘，依据布局策略完成交底书突出方向的修改及完善，并对代理所的技术问题进行答疑；
        3. 完成代理所新申请撰稿审核、校稿；
        4. 其他知识产权相关的管理、记录、统计工作。

        任职要求：
        1. 全日制本科以上学历，机械、自动化、光学、信号处理等相关专业；
        2. 熟悉专利相关法律法规，拥有2年及以上国内外律所或专利代理所的实务处理工作经验；拥有企业知识产权从业经验者及复审无效处理经验者优先；
        3. 会使用主流3D机械设计软件进行工程图查看、并进行简单编辑；
        4. 流利的英语沟通和阅读能力，能够无碍地进行英文论文和英文专利的解读；
        5. 思路清晰、表达严谨、具有较强的书面表达能力，优秀的人际交往和沟通能力；踏实肯干，具有自我驱动、独立解决问题、独立思考、自信恰当表达自己意见和建议等方面的能力。`
    }, {
      name: '销售经理（工业，Base山东）',
      city: '上海',
      salary: '8-15K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1. 负责根据公司发展战略，制定客户销售计划，达成预期销售目标；
        2. 负责对重点行业客户进行开拓和培育，维护与客户的紧密合作关系，达成长期稳定的战略合作；
        3. 负责客户项目需求分析、完成项目投标相关工作；
        4. 负责项目推进、谈判、签约及回款工作，协助团队做好风险控制；
        5. 负责沟通协调各支持部门，保障项目运营，提升交付端客户体验；
        6. 负责收集、分析行业及客户需求，进行工业机器人视觉应用业务的市场宣传推广工作；

        任职要求：
        1. 全日制本科以上学历，自动化、电气工程、机械设计制造及其自动化等工业相关专业；
        2. 具备客户分析和商业谈判能力；
        3. 具有较强的自我驱动力和组织协调能力，善于独立解决问题；
        4. 较强的沟通及商务能力；`
    }, {
      name: '销售经理（物流，Base上海/北京/武汉）',
      city: '上海',
      salary: '8-15K',
      type: '社招/校招',
      edu: '本科及以上',
      content: `岗位职责：
        1.  根据公司发展战略，制定物流行业机器人自动化销售计划，达成预期销售目标；
        2. 重点客户开拓和培育，维护与客户的紧密合作关系，达成长期稳定的战略合作；
        3. 负责客户项目需求分析、完成项目投标相关工作；
        4. 负责项目推进、谈判、签约及回款工作，协助团队做好风险控制；
        5. 负责沟通协调各支持部门，保障项目运营，提升客户体验；

        任职要求：
        1. 2年以上销售或渠道拓展经验；
        2.  有顶级物流集成商从业经验者优先；
        3. 有物流行业资源者优先；`
    }
  ]
},
{
  name: '微创医疗',
  intro: `上海微创医疗机器人（MEDBOT）有限公司由国内知名微创医疗集团投资成立。公司地址在浦东张江高科技园区，主要研发微创医疗机器人系列产品，目前已经形成团队雏形，但是需要各方向研发领头人，需求热爱机器人行业的软件工程师，机械工程师，算法工程师岗位、工艺工程师等。微创起源于1998年成立的上海微创医疗器械（集团）有限公司，公司现有员工来自于30多个国家，近7,000名；已上市产品300余个，已进入全球逾10,000家医院，覆盖亚太、欧洲和美洲等主要地区，平均每6秒就有一个微创产品被用于救治患者生命或改善其生活品质或用于帮助其催生新的生命。现已拥有专利（申请）4,000余项（国外2,000项）；5次获得中国国家科学技术进步奖；18个产品进入国家创新医疗器械注册绿色通道。
  
  微创起源于1998年成立的上海微创医疗器械（集团）有限公司，公司现有员工来自于30多个国家，近7,000名；已上市产品300余个，已进入全球逾10,000家医院，覆盖亚太、欧洲和美洲等主要地区，平均每6秒就有一个微创产品被用于救治患者生命或改善其生活品质或用于帮助其催生新的生命。现已拥有专利（申请）4,000余项（国外2,000项）；5次获得中国国家科学技术进步奖；18个产品进入国家创新医疗器械注册绿色通道`,
  img: true,
  desc: ``,
  city: '上海',
  field: '医疗器械',
  scale: '5000-10000人',
  financing: '无',
  tags: ["五险一金", "带薪休假", "奖励年假", "实习生优享福利", "季度团建", "接驳班车", "住房补贴", "补充公积金", "公租房", "话费补贴", "健身房及健身课程", "健康体检"],
  web: '',
  jds: [
    {
      name: '新医疗机器人负责人',
      salary: '面议',
      type: '社招',
      edu: '硕士及以上',
      city: '上海',
      content: `工作职责：
      职责描述：
      1. 负责手术机器人项目全面技术管理工作，组织并监督项目计划和进度的审核和推进工作；
      2. 负责创新产品的开发，确定产品框架及开发实施计划，确保产品开发节奏及具体需求符合目标要求；
      3. 负责开发过程中相关问题的解决，与其他各部门工作配合和有效沟通，确保项目按计划保质保量地完成；
      4. 负责研发产品优化工作，并成功转移给生产，确保产品质量在生产环节能顺利生产产品，实现产业化
      5. 及时组织解决研发过程中的技术关键和重大技术问题
      6. 重视员工培养及新知识新技术的交流与学习，不断提升员工研发能力并发展研发人才梯队

      任职要求：
      1. 硕士及以上学历，10年以上技术研发管理经验，具有海外工作背景、机器人或大型有源医疗设备生产研发经验优先
      2. 具备国际视野，了解并能引进、应用国际前沿技术，带领研发团队与国际技术接轨
      3. 具有优秀的领导、组织、判断、决策、协调、影响力及出色的团队管理能力；`
    }, {
      name: 'ISP算法工程师',
      salary: '15-30K',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `工作职责：
        1. 负责ISP的算法开发和维护；
        2. 负责3A(AE/AWB/AF)算法的开发和维护，分析解决3A相关问题，能对算法提出创新性的改进方案；
        3. 负责搭建图像质量的调试平台，以验证图像算法的性能和外设接口的功能；
        4. 负责ISP的图像质量与性能调优
        5. 和FPGA设计人员沟通，协助算法在FPGA中实现；
        6. 相关技术成果及资料的查阅、整理及归纳；
        7. 完成领导布置的其他工作。

        任职资格：
        1. 硕士及以上学历
        2. 硕士3年以上（博士1年以上）工作经验
        3. 熟悉sensor感光原理、显示技术、颜色体系和色彩原理
        4. 熟悉摄像机信号采集处理流程，熟悉图像信号处理算法如3A控制、色彩校正、锐化降噪、宽动态等技术5的研究和实现
        5. 具有图像质量测评和tuning经验
        6. 熟悉算法在FPGA实现相关知识
        7. 熟悉matlab/C编程
        8. 较强的人际沟通能力和基本团队管理能力`
    }, {
      name: '医疗图像算法工程师',
      salary: '15-25K 14薪',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `工作职责:
        1. 参与智能医疗项目预研，负责医学图像算法的研究、实现与改进；
        2. 负责算法项目的研发与维护，提供必要的技术支持以及输出技术文档；

        岗位要求:
        1. 工科相关专业、已获得硕士及以上学历，2年以上算法类研发工作经验；
        2. 能熟练使用C++编程，能快速实现常见计算算法；
        3. 具备扎实的数学基础，熟悉常用的图像处理、机器学习算法原理；
        4. 具备良好的英文文献阅读与撰写能力；
        5. 加分项（以下任一经验）：
        a) 有CV领域顶刊论文或相关大赛获奖；
        b) 有ITK、VTK等开发经验；
        c) 有医疗影像处理经验，熟悉成像原理及DICOM数据格式；
        d) 有医疗智能系统研发经验；`
    }, {
      name: '嵌入式研发经理',
      salary: '18-25K 14薪',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `工作职责:
        1. 负责带领嵌入式小组进行用户需求分析，形成解决方案；负责任务的分工与小组成员的考核。
        2. 嵌入式产品软硬件设计开发；
        3. 负责产品样机制作、功能调试、测试等；完成相关技术文件编制；
        4. 分析并解决产品开发过程中遇到的问题；
        5. 完成上级领导交予的其他工作。

        任职资格:
        1. 硕士及以上学历，电子、测控、通信、计算机、自动化、机电一体化等相关专业；
        2. 熟练使用一种单片机或DSP；熟悉linux嵌入式系统；熟练运用PCB绘图工具；有项目管理经验者优先；
        3. 具有良好的沟通能力，执行力出色。`
    }, {
      name: '嵌入式软件工程师',
      salary: '16-24K 14薪',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `工作职责：
        1. 负责康复医疗器械产品研发，具有一定的软件系统构建能力。
        2. 负责嵌入式操作系统的移植和应用开发；负责嵌入式系统图形界面的开发；负责系统及软件设计文档的编写。
        3. 对编码进行调试和确认，完成系统组装及测试工作；对测试结果进行分析研究，给出问题的解决方案。
        4. 处理技术部内部事务，配合其他部门完成相关文档、技术支持、服务支持等活动。
        5. 完成上级交办的其他工作

        任职资格：
        1. 本科或硕士以上学历，自动化或计算机专业。
        2. 5年以上智能设备或有源类医疗设备研发经验。
        3. 熟悉ARM、X86、PLC等硬件知识；熟悉计算机接口知识，熟悉WinCE或Linux等嵌入式操作系统；
        4. 精通C/C++编程语言，熟悉QT编程；精通DSP、NXP、ARM等单板开发与调试；对ucos等实时嵌入式系统或嵌入式linux系统有了解。
        5. 具有软件项目管理经验，可带领团队开展软件研发。
        6. 英语听读写流利，可阅读英文文献并有撰写英文论文经验。
        7. 执行力强，性格开朗，诚实守信。`
    }, {
      name: '机器视觉工程师',
      salary: '13-25K 14薪',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `工作职责：
        1. 3D/2D尺寸测量、缺陷检测等非标AOI定制化机台整体光学系统的方案设计；
        2. 负责方案实施过程中关键问题攻关；
        3. 领导机器学习/深度学习的算法在机器视觉领域应用的研究；
        4. 负责视觉检验模型现场应用的监控、改善、优化、迭代；
        5. 负责对国内外最前沿技术和应用进行跟踪和学习，并结合公司业务情况进行技术预研和项目规划；
        6. 参与或负责技术团队的建设和管理工作。
        工作经验要求：
        1. 本科以上学历，数学、计算机、机电一体化、工程光学、几何光学等相关专业
        2. 四年及以上机器视觉等相关经验；
        3. 熟悉工业相机和机器视觉光源、激光线扫、结构光传感器等选型与使用；
        4. 了解3D/2D视觉算法应用，能定量分析系统测量误差。有使用深度学习技术解决过实际工程问题者优先；
        5. 对机械整体结构精度的可实现性有概念，具备较强的工程实现能力。
        技术要求：
        1. 具备扎实的数学功底，对机器视觉理解透彻，了解机器学习、深度学习等技术原理；
        2. 熟悉常用视觉算法模型，精通Python或类似的开发语言，具备扎实的编码和调试能力；
        3. 对算法研发有强烈兴趣，对使用新技术解决实际问题有极强的热情。
        4. 有较强的责任心、创新意识，具备良好的团队协作精神和一定的沟通协调能力，吃苦耐劳、踏实敬业，能够承受较大的工作压力`
    }
  ]
},
{
  name: '优艾智合',
  intro: `优艾智合机器人，专注机器人研发与制造的创新型高新企业。掌握移动机器人底盘与系统核心技术，致力于自动化、场内物流解决方案与自动化巡检及维保解决方案，主要服务于半导体制造、飞机制造、汽车自动化、电网维护、能源冶炼、物业维保、公共交通自动化等行业。
  业务布局：总部位于深圳，设有苏州，西安分部；国内业务覆盖17个省；国际业务覆盖日本、韩国、新加坡、德国、意大利、土耳其等30多个国家。
  合作伙伴：中国航空工业集团，中国商飞，华为集团，东芝中国，空中客车等百家知名企业。
  荣获奖项：国家级创新创业奖项30余项，两年蝉联“机器人诺贝尔奖”之称的恰佩克技术创新奖。
  专利技术：拥有80余项机器人领域核心专利技术，为企业发展提供保障性技术壁垒。
  技术领域：涵盖机器人定位导航、运动控制、人机交互、机械臂控制、云平台等。
  行业首创：打造全球第一台商用巡检车，全球第一台检疫机器人等等。`,
  img: true,
  desc: ``,
  city: '深圳',
  field: '智能硬件',
  scale: '100-499人',
  financing: '无',
  tags: ["五险一金", "带薪休假", "年终奖", "员工旅游", "节日福利", "零食下午茶"],
  web: '',
  jds: [
    {
      name: 'Slam算法工程师/高级工程师',
      salary: '25-35K',
      type: '社招',
      edu: '硕士',
      city: '深圳',
      content: `岗位职责：
        1、了解常见的激光SLAM算法，并对算法进行原理级别的优化；
        2、优化在动态变化环境中的机器人定位算法，提升算法精度和稳定性；
        3、 对复杂环境下的激光定位算法进行优化，提升机器人的全局定位精度；
        4、 灵活应用二维码，反光板，点云几何特征等辅助手段来显著提升机器人局部定位精度；5、 对建图算法的SLAM框架具有深入研究，提升建图的闭环检测速度和可支持的最大建图面积，提升地图的精细化水平。
        任职要求：
        1、全日制本科以上学历（985、211优先），具有2-3年的移动机器人行业从业经验者；
        2、具有提升机器人动态环境下定位精度的实际研发经验或者项目实施经验；
        3、对于IMU 里程计 等多数据源融合有深刻认识；
        4、对于Particle Filter、EKF等常见滤波方法有深刻认识并可以灵活应用这些滤波器完成多定位数据的融合；
        5、具有机器人定位导航模块架构设计经验者优先；
        6、 具备娴熟的C++编程技巧，熟悉Git，Linux嵌入式开发者、良好文档记录习惯者优先；
        7、 有过Robocup、RoboCon等国内外机器人竞赛经验者，发表过优质论文者优先。`
    }, {
      name: '产品经理',
      salary: '20-30K',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `岗位职责：
        1、负责公司机器人调度系统调研分析，用户体验设计，需求撰写规划，实施及产品的持续优化改进；
        2、能敏锐把握用户需求，完成产品定义文档和产品需求文档，形成原型图；
        3、产品设计，包括功能列表、用户用例、业务流程、界面原型，交互设计等；
        4、项目管理，包括各种资源的协调，项目计划的进程等，确保产品开发的进度和质量；
        5、跟踪各渠道用户反馈，根据数据、业务及需求，调整产品方案及设计；
        6、产品交付管理并持续改进；
        7、对接项目团队，提供方案支持。
        任职要求：
        1、全日制本科学历以上，3-5年以上产品经理工作经验，有完整的0到1产品规划设计经验；
        2、熟悉Sketch、Axure、Xmind等工具；
        3、有独立管理产品与推进实现产品的完整业务过程经验，包括从市场/竞品/客户调研、需求分析到产品发布；熟练编写需求文档、业务流程图、原型图等，拥有客户端产品设计和后端管理产品设计经验。
        4、逻辑能力强、沟通能力强、思维敏捷、善于思考和抓住重点。
        面试时请携带至少一款项目资料展示（原型图或脑图或需求文档或成品等）。`
    }
  ]
},
{
  name: '中原动力',
  intro: `中原动力智能机器人有限公司是由国外院士领衔的海归教授及博士团队牵头，基于多模态学习、人机融合等重大研究成果，在上海理工大学机器智能研究院IMI等机构联合支持下成立。
  公司承担了从产品定位、研发、测试、销售以及收集市场反馈后再定位的闭环过程中的全部角色，并携手郑东新区管委会、上海理工大学研究院，联合成立郑州人工智能与机器人应用科学技术研究院。
  公司产品主要应用于智慧物业、智能制造、智慧教育和智慧医疗等领域，用高品质为行业创新发展赋能。
  公司总部位于国家大数据综合试验核心区——郑州市郑东新区智慧岛，并在中国上海和德国汉堡分别设有研发中心，为全球制造业、医疗服务、智慧城市、公共事业等客户提供全方位优质服务。
  科研队还包括博士后、博士16人，硕士30余人，其中大部分人员来自德国汉堡大学、麻省理工学院、上海理工大学、上海交通大学等名校，在结合上理工机器人智能研究的人形机器人的物理平台，打造出强人工智能下的人形机器人，从而真正代替人工进入各类服务场景。同时研究院将帮助郑东新区培养一批在这个领域的尖端人才，助力郑东新区建立人工智能和机器人领域的人才高地。`,
  img: true,
  desc: ``,
  city: '郑州',
  field: '人工智能硬件',
  scale: '100-499人',
  financing: '未融资',
  tags: ["五险一金", "带薪休假", "定期体检", "加班补助", "员工旅游", "通讯补贴", "交通补助", "节日福利"],
  web: '',
  jds: [
    {
      name: '导航算法工程师',
      salary: '10-20K',
      type: '校招/社招',
      edu: '硕士',
      city: '郑州',
      content: `职责描述：
        1. 负责SLAM算法的开发和验证;
        任职要求：
        1. 硕士及以上学历，计算机、自动化、控制等相关专业；
        2. 具备优秀的问题分析能力，以及良好的团队意识与协作能力；
        3. 熟练掌握Python，C/C++，具备二次开发能力；
        4. 熟悉室内室外导航定位、熟悉ROS系统；`
    }, {
      name: '深度学习视觉算法工程师',
      salary: '10-20K',
      type: '校招/社招',
      edu: '硕士',
      city: '郑州',
      content: `职责描述：
        1. 协助调研和整理视觉相关任务的最新工作;
        2. 根据任务设计框架, 并完成技术验证;
        3. 参与项目系统的需求分析, 确定处理框架;
        4. 参与完成系统分层设计, 对CV相关算法模块进行封装.
        任职要求：
        1. 硕士及以上学历，计算机、自动化、控制等相关专业；
        2. 具备优秀的问题分析能力，以及良好的团队意识与协作能力；
        3. 熟练掌握Python，C/C++，具备二次开发能力；
        4. 熟悉视觉、自然语言、深度学习相关算法；`
    }, {
      name: '抓取算法工程师',
      salary: '10-20K',
      type: '校招/社招',
      edu: '硕士',
      city: '郑州',
      content: `职责描述：
        1. 协助调研和整理机器人抓取相关任务的最新工作;
        2. 根据任务设计框架, 并完成技术验证;
        3. 参与项目系统的需求分析, 确定处理框架;
        4. 参与完成系统分层设计, 对机械臂抓取相关算法模块进行封装.
        任职要求：
        1. 硕士及以上学历，计算机、自动化、控制等相关专业；
        2. 具备优秀的问题分析能力，以及良好的团队意识与协作能力；
        3. 熟悉ROS环境, 熟练掌握Python，C/C++，具备二次开发能力；`
    }, {
      name: '运动控制算法工程师',
      salary: '12-18K',
      type: '校招/社招',
      edu: '本科',
      city: '郑州',
      content: `职责描述：
        1. 机器人运动学、动力学建模分析;
        2. 机器人运动控制算法及程序开发;
        3. 与本体设计、硬件部门协作完成机器人设计;
        4. 机器人运动控制程序升级维护;
        5. 其他研发相关工作.
        任职要求：
        1. 本科及以上电子信息科学与技、自动化、控制科学与工程、计算机科学与技术、机器人技术等相关专业；
        2. 具备优秀的问题分析能力，以及良好的团队意识与协作能力；
        3. 熟悉机器人运动学、动力学分析、数值分析、机器人学、机器人仿真技术; 
        4. 熟悉ROS、Linux;
        5. 熟悉关节空间运动规划;
        6. 熟悉机器人建模;
        7. 熟悉最优求解器使用。`
    }, {
      name: '嵌入式开发工程师',
      salary: '8-12K',
      type: '校招/社招',
      edu: '本科',
      city: '郑州',
      content: `职责描述：
        1. 与运动算法工程师协作开发机器人控制程序
        2. 与硬件部门协作选型控制器芯片、外设等
        3. 依据功能需求设计嵌入式软件
        4. 书写开发技术文档
        5. 调试程序bug、完善程序性能
        6. 其他研发相关工作
        任职要求：
        1. 本科及以上电子信息科学与技、自动化、控制科学与工程、计算机科学与技术、机器人技术等相关专业；
        2. 具备优秀的问题分析能力，以及良好的团队意识与协作能力；
        3. 专业技能要求:
        STM32单片机开发
        电机PID控制
        UART、I2C、RS485、RS232、CAN等现场总线通信
        git
        远程升级
        4. 专业知识要求: PID控制方法、单片机原理、数字信号处理、嵌入式系统等`
    }, {
      name: '电机控制算法工程师',
      salary: '8-25K',
      type: '社招',
      edu: '本科',
      city: '郑州',
      content: `职责描述：
        1. 负责永磁同步电机控制算法的开发，完成所需的功能设计、算法开发、模型仿真、软件编写、调试等工作；
        2. 参与电机控制器的协议对接，系统需求，硬件设计评审等工作；
        3. 负责电机及控制器的安装调试及性能测试等工作。
        任职要求：
        1. 本科及以上电子、计算机相关专业；
        2. 电机控制相关工作经验3年以上;
        3. 具备优秀的问题分析能力，以及良好的团队意识与协作能力；
        3. 熟练掌握直流无刷控制原理；熟悉电机控制各方面方面的知识；熟悉电机控制相关算法：FOC、方波算法;
        4. 熟练使用相关开发软件，如Matlab等；电机驱动器产品的软件编写和调试。`
    }, {
      name: '结构工程师(高空)',
      salary: '8-16K',
      type: '社招',
      edu: '本科',
      city: '郑州',
      content: `职责描述：
        1. 负责城市管养高空机器人结构设计与实现；
        2. 协助其他部门完成调试任务；
        3. 完成相应工作的文档资料整理；
        4. 电机选型及参与产品方案设计；
        5. 样机组装调试工作。
        任职条件：
        1. 本科及以上学历，机械设计相关专业，具有3年以上工作经验；
        2. 熟悉solidworks、CAD等设计软件；
        3. 有高空机器人，无人机设计经验者优先；
        4. 对碳纤维等航空材料有一定的设计经验；
        5. 对机器人常用的传感器、电机、减速机以及传动方案比较熟悉。`
    }, {
      name: '结构工程师(机械臂)',
      salary: '8-16K',
      type: '社招',
      edu: '本科',
      city: '郑州',
      content: `职责描述：
        1. 负责轻量化机械臂结构设计与实现，；
        2. 负责机械臂的运动学和动力学的仿真，对机械臂进行轨迹规划和仿真分析；
        3. 完成相应工作的文档资料整理；
        4. 电机等器件选型及参与产品方案设计；
        5. 样机组装调试工作。
        任职条件：
        1. 本科及以上学历，机械设计相关专业，具有3年以上工作经验；
        2. 熟悉solidworks、CAD等设计软件，熟悉ANSYS、Matlab等仿真软件；
        3. 有非标自动化设备、检测设备设计经验；
        4. 有机械臂设计经验者优先；
        5. 对机器人常用的传感器、电机、减速机以及传动方案比较熟悉。`
    }, {
      name: '机械工程师',
      salary: '10-15K',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `岗位职责：
        1、负责城市管养高空机器人结构设计与实现；
        2、协助其他部门完成调试任务；
        3、完成相应工作的文档资料整理；
        4、电机选型及参与产品方案设计；
        5、样机组装调试工作。
        任职条件：
        1、本科及以上学历，机械设计相关专业，具有3年以上工作经验；
        2、熟悉solidworks、CAD等设计软件；
        3、有高空机器人，无人机设计经验者优先；
        4、对碳纤维等航空材料有一定的设计经验；
        5、对机器人常用的传感器、电机、减速机以及传动方案比较熟悉。`
    }, {
      name: '算法工程师',
      salary: '25-35K',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `技能要求：
        深度学习，TensorFlow，机器学习，pytorch，NLP，知识图谱
        职责描述：
        在专家院士团队的指导下，面向广场、公园等场景下的迎宾引导、语音识别、人机交互等应用，参与NLP相关任务的研发和测试。
        任职要求：
        1. 对机器人兴趣浓厚，有强烈的内驱力、责任心和团队意识；
        2. 有IT或数学等相关专业全日制硕士学历，自学能力强；
        3. 熟悉Linux编程，熟练掌握Python、C/C++；
        4. 了解人工神经网络基本原理与NLP基础算法，熟悉深度学习主流框架(Pytorch/TensorFlow /Caffe2)；
        5. 在NLP有应用经验者优先。`
    }, {
      name: 'AI工程师 无人驾驶方向',
      salary: '10-15K',
      type: '校招/社招',
      edu: '本科',
      city: '郑州',
      content: `任职要求：
        1. 本科及以上学历，计算机、通信、电子、自动化，以及应用数学专业；
        2. 具备优秀的问题分析能力，以及良好的团队意识与协作能力；
        3. 熟悉Linux、ROS系统，熟练掌握Python，C/C++，具备二次开发能力；
        4. 了解机器学习常用算法；
        5. 具有良好的中/英文资料检索和理解能力；
        6. 深刻理解/掌握以下一个或多个领域：
        1) 基于视觉/激光雷达的目标检测、识别、跟踪；
        2) 点云/图像场景分割、理解；
        3) 点云/图像处理方法及相关工具库;
        4) 多传感器融合方法;
        5) 激光/视觉SLAM;
        6) 高精度地图构建;
        7) 无人车驾驶决策与路径规划及控制算法等。
        7. 具有以下任一经验者优先：
        1) 具有无人驾驶，移动机器人相关项目开发经验；
        2) 了解autoware，Apollo等开源自动驾驶项目；
        3)了解无人驾驶领域的前沿技术发展；`
    }, {
      name: '电机控制算法工程师',
      salary: '10-15K',
      type: '社招',
      edu: '本科',
      city: '郑州',
      content: `岗位职责
        1.负责永磁同步电机控制算法的开发，完成所需的功能设计、算法开发、模型仿真、软件编写、调试等工作；
        2.参与电机控制器的协议对接，系统需求，硬件设计评审等工作；
        3.负责电机及控制器的安装调试及性能测试等工作。
        任职要求
        1.电子、计算机相关专业本科及以上学历；
        2.电机控制器3年及以上开发经验；
        3.熟悉电机控制各方面方面的知识；
        4.熟练使用相关开发软件，如Matlab等；
        5.熟练掌握直流无刷控制原理；
        6.负责电机驱动器产品的软件编写和调试，并完成相关设计和分析文档；
        7.具有新能源汽车电机驱动者优先；`
    }, {
      name: '算法工程师',
      salary: '10-15K',
      type: '校招/社招',
      edu: '硕士',
      city: '郑州',
      content: `技能要求：
        多传感器融合，感知算法，路径规划，SLAM，定位
        在专家院士团队的指导下，参与机器人低速无人驾驶研发，主要通过视觉、雷达、GPS等传感数据融合，进行环境建模与路径规划，实现广场、公园等场景下的机器人自主导航。
        任职要求：
        1. 对机器人兴趣浓厚，有强烈的内驱力、责任心和团队意识；
        2. 有IT或数学等相关专业全日制硕士以上学历，自学能力强；
        3. 理解/掌握以下一个或多个领域：
        1) 定位方法（室内和室外皆可）
        2) 基于视觉/激光雷达的目标检测、识别、跟踪；
        3) 多传感器融合方法;
        4) 激光/视觉SLAM;
        5) 高精度地图构建;
        6) 无人车驾驶决策与路径规划及控制算法等;`
    }, {
      name: 'ROS开发工程师',
      salary: '10-15K',
      type: '校招/社招',
      edu: '本科',
      city: '郑州',
      content: `职责描述：
        1. 使用C或C++开发ROS系统下的应用软件，和相应的软件测试；
        2. ROS系统搭建；
        3.软件开发文档管理。
        任职要求：
        1. 本科及以上学历，自动化、电子信息，计算机、软件工程等方向；
        2. 有一定的ROS软件开发经验，熟悉主流的机器人软硬件开发平台；
        3. 2年及以上工作经验，薪资无上限，依能力定薪资;`
    }, {
      name: '计算机视觉工程师',
      salary: '10-15K',
      type: '校招/社招',
      edu: '硕士',
      city: '郑州',
      content: `技能要求：
        多传感器融合，感知算法，路径规划，SLAM，定位
        在专家院士团队的指导下，参与机器人低速无人驾驶研发，主要通过视觉、雷达、GPS等传感数据融合，进行环境建模与路径规划，实现广场、公园等场景下的机器人自主导航。
        任职要求：
        1. 对机器人兴趣浓厚，有强烈的内驱力、责任心和团队意识；
        2. 有IT或数学等相关专业全日制硕士以上学历，自学能力强；
        3、 理解/掌握以下一个或多个领域：
        1) 定位方法（室内和室外皆可）
        2) 基于视觉/激光雷达的目标检测、识别、跟踪；
        3) 多传感器融合方法;
        4) 激光/视觉SLAM;
        5) 高精度地图构建;
        6) 无人车驾驶决策与路径规划及控制算法等;`
    }, {
      name: '硬件开发工程师',
      salary: '8-12K',
      type: '社招',
      edu: '本科',
      city: '郑州',
      content: `岗位职责：
        1）负责机器人电机驱动方案、传感方案设计与调试；
        2）参与产品的整体方案设计、元器件选型、原理图和PCB设计工作；
        3）硬件测试程序及部分驱动程序的开发；
        4）负责产品研发各个阶段的硬件调试，性能测试及性能改进；
        5）完成所有开发文档、生产/测试指导文档及版本控制。
        任职要求：
        1）本科以上学历，从事硬件设计5年以上， 电子信息、机电、计算机等相关专业；
        2）具有电机驱动、传感器信号采集开发经验者优先；具有智能机器人产品开发经验者优先；
        3）具备独立的嵌入式系统硬件设计开发经验，掌握硬件设计调试的基本技能，并且富有创新能力；
        4）熟练使用Altium Designer、Cadence、PADS、ALLEGRO等电路设计软件，有多层板开发的经验；
        5）能熟练阅读英文的专业技术文档。`
    }, {
      name: '嵌入式软件开发工程师（系统集成方向）',
      salary: '8-12K',
      type: '社招',
      edu: '本科',
      city: '郑州',
      content: `岗位职责：
        1、负责嵌入式软件开发；
        2、测试软件功能；
        3、维护嵌入式软件的开发框架；
        4、撰写软件开发文档；
        任职要求
        1、本科及以上学历，电子信息、自动化、计算机科学和通信工程等专业；
        2、掌握STM32等多种系列单片机的开发；
        3、熟悉使用各种常用的传感器设备；
        4、熟悉UART、CAN、SPI等多种通信协议；
        5、有完整的项目开发经验；`
    }
  ]
},
{
  name: '艾利特机器人',
  intro: `艾利特科技有限公司（以下简称艾利特，包括所属关联公司：苏州艾利特机器人有限公司（母公司），苏州艾利特智能自动化有限公司，北京艾利特科技有限公司）成立于2014年8月，是一家由北京航空航天大学、清华大学、美国哥伦比亚大学博士及博士后发起成立的创新型精英企业。

  艾利特机器人技术研发中心坐落于北京中关村核心地带，其中研发人员约50名，90%以上为硕士及以上学历，均来自国内外各大名校，核心团队拥有15年以上机器人相关研发经验。同时，艾利特在苏州工业园区规划有近万平米生产研发基地，已于2018年3月投产，各类工业机器人年产规模可达5000台。艾利特在机器人核心部件控制系统/伺服驱动系统、智能视觉系统、协作机器人以及各类工业机器人的研发和生产上处于国内领先地位，其中机器人控制技术已处于国际领先水平。

  艾利特作为一家集产品研发、生产、组装、测试、销售、售后、系统集成于一体的机器人企业，通过4年的高速发展，已完成机器人全产品线布局。

  未来，艾利特还将在机器人研发、生产、智能化解决方案等方面持续投入，以卓越的技术实力、精湛的生产工艺、严谨务实的工作作风推进产业进程，引领“智能工人”新时代，助力中国制造走向世界。`,
  img: true,
  desc: ``,
  city: '上海',
  field: '机械设备/机电/重工',
  scale: '100-499人',
  financing: 'B轮',
  tags: ["五险一金", "带薪休假", "奖励年假", "话费补贴", "餐补"],
  web: '',
  jds: [
    {
      name: '现场应用工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '苏州/上海/深圳/北京',
      content: `职责：
        1、技术支持和培训客户进行协作机器人的编程、调试和维护；
        2、随业务人员拜访客户，讲解协作机器人特点、应用及演示；
        3、现场支持客户的应用调试和内部应用开发及展示；
        4、售前技术支持和方案评估、现场方案验证；

        要求：
        1、自信、上进，良好的沟通能力和执行力；
        2、大专及以上学历，自动化、机电一体化、电气、计算机等相关专业；
        3、两年及以上机器人行业从业经验，包括机器人调试、培训、方案设计或开发；
        4、熟悉至少一款主流的工业机器人编程及应用；熟练掌握机器人与PLC的总线通讯；
        5、有视觉与机器人项目经验并了解机器人相关计算及概念：例如位姿乘法，正逆运动学等； 
        6、精通一门高级语言者优先，熟练solidworks软件或者Eplan软件这优先；
        7、能否适应短期高频率的出差， 具备基本的英文听说读写能力者优先；`
    }, {
      name: '应用软件开发工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '苏州/上海',
      content: `职责：
        1、开发基于协作机器人的应用软件，例如力控、视觉、轨迹生成等；
        2、协作机器人的二次开发及测试，包括上位机、控制器插件以及物联网终端等；
        3、开发文档的编写与维护，培训和支持高阶客户及合作伙伴的二次开发。

        要求：
        1、自信、上进，良好的沟通和归纳总结能力、自主性强；
        2、本科及以上，自动化、计算机及机电一体化等相关专业毕业；
        3、精通C++或者Python，熟悉Linux，具备1年及以上机器人软件开发经验；
        4、熟悉机器人运动学、动力学等相关概念，并且熟悉TCP/IP，RS485等通讯方式；
        5、熟悉视觉、力控及ROS开发者优先；
        6、具备良好的英文阅读和书写能力者优先；
        7、参加过机器人大赛、智能车等选手优先；`
    }, {
      name: '机械工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '苏州/上海',
      content: `职责：
        1、支持客户的方案评估、节拍设计及优化；
        2、同业务人员拜访客户，展示协作机器人应用方案及应用分享；
        3、协作机器人典型应用及组件开发，专利设计以及实现；
        4、内部测试及展会方案设计与实现；
        5、方案评估、仿真平台搭建并形成培训教程培训客户；

        要求：
        1、自信、上进，良好的沟通能力，抗压能力和执行力；
        2、两年及以上自动化经验，本科及以上，机械、机电一体化及电气等相关专业毕业；
        3、熟练应用AutoCAD和Solidworks或者Pro/E或Creo;
        4、熟悉气动件、导轨、电机、常用传感器等原理和选型；
        5、熟悉尺寸公差和常见加工工艺；
        6、有机器人项目经验者优先；`
    }, {
      name: '应用支持经理',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '上海/深圳',
      content: `职责：
        1、领导和协调大区范围内的现场技术支持人员，开展协作机器人售前售后技术支持；
        2、带领团队完成针对客户的培训，组织并完善内部现场技术人员的培养；
        3、协同销售开发重点客户，组织应用评估、开发、测试与实施；
        4、市场及行业信息的收集和总结，分析主要应用市场特点和竞品信息；

        要求：
        1、自信、担当，敢于自我挑战，良好的沟通表达能力和执行力；
        2、本科及以上学历，自动化、机电一体化、电气、计算机等相关专业；
        3、精通至少一款主流工业机器人产品，熟悉至少一种高级编程语言；
        4、三年及以上机器人行业从业经验，包括机器人调试、培训、方案设计或开发；
        5、具备较好的文档功底，具备基本的英文听说读写能力，适应短期高频出差；`
    }, {
      name: '设备维修技术员',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '苏州',
      content: `职责：
        1、负责协作机器人的故障诊断、检测、维修以及测试；
        2、协调和辅助研发及其他工程师完成故障的root cause分析并生成报告；
        3、维护和更新ERP系统上售后的状态，督促相关工程师的售后更新；
        4、售后相关物料的定期清点、申请和维护；

        要求：
        1、大专以上学历,机电一体化、电子、电工、仪器仪表,机械加工等机电相关专业;
        2、2年以上电子厂自动化设备的维护、维修工作经验
        3、了解设备基本元气器件工作原理; 熟悉使用各类机电工具、仪表;
        4、工作认真、严谨，能够吃苦耐劳,有团队合作精神,服从工作安排。`
    },  {
      name: 'Technical Support Engineer-Overseas',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `Job descriptions
        1.Technical training and support  to overseas customers on Collaborative robots(Cobot).
        2.Assist sales on product demonstration and success cases sharing to customers;
        3.Support technical side on overseas marketing activities.
        4.Bridge customer requests with internal technical resources.
        5.Technical intelligience on existing and emerging competitive products.

        Requirements
        1.Confident, positive, great communication skills and self-motivated.
        2.Good Skills on both oral and written english. 
        3.Bachelor degree or above on Automation, Computer Sience or Mechatronics.
        4.At least two years‘ experience on Robotics or Automation area on technical support or as a developer.`
    }
  ]
},
{
  name: '驭势科技',
  intro: `驭势科技UISEE致力于用AI驾驶打造面向未来的出行和物流，重塑人类的生活方式，为人们带来多效用、平等、安全的出行体验以及高效、生态友好的资源运转模式。

  驭势科技总部设于北京，在上海、浙江和深圳等地均设有分支机构，拥有数百人的研发团队和完整的知识产权布局。驭势科技在业务上已形成可规模化部署的L3-L4级智能驾驶系统，与大量头部客户协同创新，并已在多种商业场景中率先落地。

  公司标语： 以AI驾驶重塑人类生活方式`,
  img: true,
  desc: ``,
  city: '上海/北京/深圳',
  field: '智能硬件',
  scale: '100-499人',
  financing: 'B轮',
  tags: ["五险一金", "免费体检", "商业保险覆盖家属", "班车或交通补贴", "节日生日礼物", "免费午餐", "零食咖啡不断", "员工俱乐部", "带薪年假"],
  web: '',
  jds: [
    {
      name: '定位与感知软件工程师',
      salary: '16-35K 14薪',
      type: '社招',
      edu: '硕士',
      city: '上海/北京/深圳',
      content: `职位描述
        1.研发业界领先的无人驾驶的定位与感知软件栈
        工作职责
        1.研发无人驾驶的定位与感知的软件基础设施及架构持续性优化，提升系统安全性、可靠性、鲁棒性和可扩展性
        2.对无人驾驶的高精度定位和感知模块进行性能优化，能够满足在嵌入式平台上的实时性要求
        职位要求
        1.有很强的工程能力，精通C / C++语言以及至少另一种常见编程语言，编程经验丰富
        2.相关专业硕士以上学历，3年以上工作经验
        3.数据结构和算法基础知识良好，对面向体系结构的优化、多线程优化、数据并行优化、CUDA编程等方面有较好经验，能够开发高性能、实时运行的软件
        4.熟悉常见深度学习网络在嵌入式平台上的部署、优化和运行
        5.有较为扎实的数学基础，精通常见的几何、统计学等
        6.致力于创造解决实际问题的技术
        优先考虑
        1.优先考虑 熟悉高性能运算加速工具如 Neon 以及GPGPU 技术如 GLES、CUDA 和OpenCL 等
        2.优先考虑 熟悉常用的数学运算库
        3.优先考虑 熟悉图像和激光雷达数据处理领域的常见库如 PCL和OpenCV等
        4.优先考虑 ACM等编程竞赛获奖者`
    }, {
      name: '无人驾驶预测算法工程师',
      salary: '16-40K 14薪',
      type: '社招',
      edu: '硕士',
      city: '上海/北京',
      content: `职位描述
        1.负责满足复杂场景和任务要求的无人驾驶预测算法的探索和改进，以及相应算法在实车运营环境中的设计、实现和迭代；
        职位要求
        1.具有扎实的数学基础和抽象问题、解决问题的能力；
        2.有解决无人驾驶中的障碍物预测问题的项目经验；
        3.熟悉各类机器学习算法并有相应的项目经验；
        4.熟知基本算法和算法优化的方法和思路；
        5.具有丰富的Linux系统下C/C++语言编程经验和良好的编程规范；
        6.良好的沟通表达和写作能力；
        7.良好的团队合作精神；
        优先考虑
        1.计算机相关专业教育背景，编程算法能力强；
        2.发表过高质量学术论文；`
    }, {
      name: '无人驾驶决策算法工程师',
      salary: '16-40K 14薪',
      type: '社招',
      edu: '硕士',
      city: '上海/北京',
      content: `职位描述
        1.负责满足复杂场景和任务要求的无人驾驶决策算法的探索和改进，以及相应算法在实车运营环境中的设计、实现和迭代；
        职位要求
        1.具有扎实的数学基础和数学建模能力；
        2.对无人车有一定了解，有无人驾驶决策相关项目经验；
        3.熟知基本算法和算法优化的方法和思路；
        4.具有丰富的Linux系统下C/C++语言编程经验和良好的编程规范；
        5.好的沟通表达和写作能力；
        6.良好的团队合作精神；
        优先考虑
        1.熟悉机器学习和强化学习原理并有一定项目经验；
        2.熟悉MDP/POMDP原理并有一定项目经验；
        3.计算机相关专业教育背景，编程算法能力强；
        4.发表过高质量学术论文；`
    },  {
      name: '定位与感知算法工程师',
      salary: '16-40K 14薪',
      type: '社招',
      edu: '硕士',
      city: '上海/北京/深圳',
      content: `职位描述
        1.用相机、激光雷达、里程计、IMU等传感器数据融合识别和理解复杂环境，实现各种复杂场景下的高精度融合定位能力，为无人驾驶系统在定位方面提供强有力的支撑。
        2.使用机器视觉，激光雷达等数据处理和多传感器数据融合，实现障碍物识别、多目标跟踪等复杂感知功能
        任职条件
        1.掌握常用的机器学习和深度学习框架和算法，并有一定的实践经验
        2.有扎实的图像分析和模式识别理论基础，精通常见的计算机视觉处理任务
        3.熟悉无人车或机器人的定位算法
        4.有比较丰富的基于激光雷达或视觉的场景分割、目标检测、目标识别、目标跟踪等算法的实战经验
        5.有较强的工程能力，精通C / C++语言以及至少另一种常见编程语言
        6.有发明创造的理想和热情，致力于创造解决实际问题的技术
        7.有一定无人驾驶领域的定位和感知工作经验加分
        8.熟悉Visual SLAM 和Lidar SLAM等在机器人定位和导航领域中常用的方法加分
        9.熟悉stereo、structured light、ToF 等三维成像原理和方法加分
        10.熟练掌握卡尔曼滤波和粒子滤波等算法及实现加分
        11.熟悉图像和激光雷达数据处理领域的常见库如 PCL和OpenCV等加分
        12.熟悉激光雷达三维重建的原理和方法加分
        13.发表过CVPR / ECCV / IROS / ICRA / ICCV / NIPS / ICML 等视觉、机器人、AI 领域会议文章
        加分
        1.熟悉高性能运算加速工具如 Neon 以及GPGPU 技术如 GLES、CUDA 和OpenCL 等加分
        2.具有智能车未来挑战赛或者相关机器人比赛经历者加分
        3.ACM等编程竞赛获奖者加分`
    },  {
      name: '计算机视觉算法工程师',
      salary: '16-40K 14薪',
      type: '社招',
      edu: '硕士',
      city: '上海/北京',
      content: `职位描述：
        1.用视觉识别和理解复杂环境，为视觉主导的无人驾驶系统在感知和定位方提供强有力的支撑；
        任职条件：
        1.熟练掌握C++和Python；
        2.熟练掌握图像分析和模式识别理论基础，包括目标识别和跟踪、三维感知、深度估计等常见的计算机视觉处理任务；
        3.熟练掌握数学基础，包括常见的几何、统计学等，并熟悉这些技术在图像识别领域中的应用；
        4.具备扎实的机器学习和深度学习理论基础和工程能力，熟悉TensorFlow、Pytorch、Caffe和MXNet中至少一种框架；
        5.具备优秀的分析和解决问题的能力，项目推动力和团队协作能力；
        6.了解SLAM相关算法，例如ORB-SLAM、LSD-SLAM等；
        7.熟悉图像识别领域的常见工具如 OpenCV 和PCL等；
        8.发表过CVPR/ECCV/ICCV/NIPS/ICML 等视觉和 AI 领域会议文章优先；`
    },  {
      name: '高精地图开发工程师',
      salary: '16-40K 14薪',
      type: '社招',
      edu: '硕士',
      city: '上海',
      content: `职责描述：
        1.高精地图端&云传输、更新、自动化生成系统的开发
        2.高精地图车端服务功能开发，包括车端数据生产、管理、服务接口开发
        3.高精地图云端服务开发
        4.高性能加密地图存储格式开发
        5.标准化地图服务SDK开发
        6.与研发团队协作，完成需求沟通、标准制定、服务开发等工作
        任职要求：
        1.本科以上学历, 3年以上工作经历, 计算机或测绘相关专业
        2.具有一定的网络开发经验者优先， 如RCP、REST API等
        3.熟悉一种地图数据规格者优先，如OpenDrive/NDS/Shape等导航数据格式
        4.Python、Go语言有经验者优先
        5.有一定的地理数据处理经验者优先`
    },  {
      name: '无人驾驶车路协同架构师',
      salary: '16-40K 14薪',
      type: '社招',
      edu: '硕士',
      city: '北京',
      content: `职位描述
        1.负责无人驾驶车路协同系统架构的设计；
        2.负责利用路端设备提升无人驾驶安全性的方案设计和应用场景设计；
        3.针对应用场景，推荐合理的车路协同方案；
        职位要求
        1.热爱无人驾驶行业；
        2.有车路协同相关工作经验，熟知V2X架构和相关标准；
        3.具备独立系统架构设计能力，有丰富的系统架构设计和实现经验；
        4.具备较好的系统分析能力和解决问题的能力；
        5.很强的团队合作精神和沟通能力；
        优先考虑
        1.从事过大型车路协同典型应用项目；
        2.有无人驾驶车路协同相关项目成功落地经验；
        3.了解无人驾驶车端相关算法；`
    }
  ]
},
{
  name: '银星智能',
  intro: `深圳市银星智能科技股份有限公司成立于2005年，总部位于深圳，隶属于银星集团，员工1200余人，专注为客户提供家庭和商用服务机器人整机方案设计服务、制造服务以及增值服务，是一家集研发、生产、销售于一体的国家级高新技术企业。公司自成立以来，持续坚持技术突破和产品创新，每年研发投入占总收入的12%以上，主要产品涵盖扫地机器人、洗地机器人、擦地机器人、商用清洁机器人等，扫地机器人年产量150万台，年产值10亿，公司正处于IPO上市准备阶段。

  截止到2020年8月份，银星智能技术专利累计520项，与上海交通大学、清华大学等国家知名院校进行校企合作，共同进行技术研发和攻关，研发队伍中硕博人员占比33%，主要技术负责人毕业于新加坡南洋理工大学、清华大学等知名高校。

  公司与松下、Bissell、SEB、Anker等国内外知名企业建立长期战略合作关系。近几年来，银星智能承担了科技部、广东省、深圳市的多项科技项目，包括服务机器人的科技支撑计划、国家火炬计划、广东省科技攻关等项目，并获得广东省科学技术奖三等奖和深圳市的科技进步二等奖。公司积极组织和参与服务机器人行业标准及国家标准的起草工作，目前服务机器人行业标准和国家标准已经正式发布，取得良好的经济和社会效益。`,
  img: true,
  desc: ``,
  city: '深圳',
  field: '智能硬件',
  scale: '1000-9999人',
  financing: '未融资',
  tags: ["五险一金", "定期体检", "加班补助", "年终奖", "带薪年假", "员工旅游", "餐补", "节日福利"],
  web: '',
  jds: [
    {
      name: '结构工程师',
      salary: '14-24K 14薪',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `工作职责:
        1、负责研发中心产品结构制作、试产、量产问题跟踪/分析/测试处理（ID图确认、主导3D制作及修改/3D检讨会、开模跟进等） ；
        2、T1样品检测确认，T2样品检讨并发出改模资料；
        3、T3样品确认BOM，治具申请单发出，备料通知书发出；
        4、主导发出所有试产资料，试产检讨和问题点总结；
        5、生产跟进、异常处理和持续改进。
        任职资格:
        1、本科及以上学历，机电一体化、机械设计与制造等相关专业；
        2、3年以上工作经验，全面主导过产品结构设计工作，熟悉扫地机器人、手持吸尘器及机器人行业（必要条件）；
        3、熟悉研发部项目管理流程及部设计流程，能熟练运用各类办公软件和结构设计软件PRO/E4.0-5.0和CAD软件；
        4、亲和力强，善沟通，具有较强的人际关系处理能力，较强的组织、计划、控制、协调能力。`
    }, {
      name: 'SLAM算法工程师',
      salary: '15-50K 14薪',
      type: '校招/社招',
      edu: '硕士',
      city: '深圳',
      content: `岗位职责：
        1、负责基于2D激光雷达的环境地图构建算法研究及测试；
        2、负责开发及优化定位地图绘制软件；
        3、负责扫地机SLAM中的信息配准融合、闭环检测等前端算法以及贝叶斯滤波、图优化等后端算法的研发和优化；
        4、负责开发、测试相应算法并提高算法性能；
        5、负责各型号激光雷达性能测试与适配。
        任职资格
        基本要求：硕士及以上学历。
        岗位要求：
        1、扎实的数学基础，掌握视觉SLAM算法相关理论知识；
        2、扎实的掌握C/C++开发、调试的经验，熟悉Linux开发环境；
        3、熟悉gmapping、cartographer等开源2D激光SLAM算法；
        4、熟悉AMCL等定位算法，有实际调试和优化的经验；
        5、熟练阅读相关英文文献；
        6、熟悉ROS，Gazebo；
        7、有无人机、机器人、AGV相关行业经验优先；在校期间有过机器人、智能小车比赛经验的优先。`
    }, {
      name: '硬件工程师',
      salary: '15-25K 14薪',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `工作职责:
        1、整理新产品关键物料清单，撰写硬件设计说明书
        2、设计初版电子原理图，及PCB LAYOUT
        3、建立产品电子部分BOM，主导新物料打样、测试并输出报告
        4、主导安规及EMC摸底测试并完成报告
        5、检查直流电源品质分析报告，交流信号品质分析报告
        6、主导关键电子元件测试报告
        7、推动并配合PIE完成产品治具和SOP
        8、负责输出试产资料(Parts List 、零件位置图 、坐标、钢网、物料检验规范)
        9、 落实试产问题点分析、改善及改善后报告输出
        10、 负责量产资料发行(Parts List、电子原理图、元件位置图、元件、组件确认)，维护量产产品
        任职资格:
        1、本专业领域8年以上工作经验，其中同等岗位5年以上工作经验；
        2、具备扫地机器人/商用清洁机器人方面专业知识；
        3、能够根据项目的总体设计进行模块设计开发、电路设计、电路板焊接与调试及子模块集成，能够在实践中获得的技能并分享
        4、具有产品开发全过程中多个环节的实践经历，能及时处理异常问题
        5、具备电磁兼容和电磁干扰方面的设计经验
        6、能够熟练使用项目相关的开发工具`
    }, {
      name: '视觉算法工程师',
      salary: '15-30K 14薪',
      type: '校招/社招',
      edu: '本科',
      city: '深圳',
      content: `工作职责:
        1、负责视觉VINS、ORB等算法的研究；
        2、负责松耦合、紧耦合VIO优化算法研究；
        3、负责视觉非线性优化算法研究；
        4、负责视觉特征点、回环等算法研究；
        5、负责视觉重定位算法研究。
        任职资格：
        1、扎实的数学基础，掌握视觉SLAM算法相关理论知识，并有在移动机器人、无人机、无人驾驶相关方面2年以上的工作经验；
        2、扎实的掌握C/C++开发、调试的经验，熟悉Linux开发环境；
        3、熟悉VINS、ORB、SVO等算法中的一种或几种；
        4、熟悉Ceres图优化非线性算法；
        6、熟悉ROS，Gazebo，在校期间有过机器人、智能小车比赛经验的优先；
        7、有较强的英文文献阅读理解能力，并能转化为工作助力。`
    }, {
      name: '路径规划算法工程师',
      salary: '15-30K 14薪',
      type: '校招/社招',
      edu: '本科',
      city: '深圳',
      content: `工作职责:
        1、负责开发全局导航路径规划算法；
        2、负责研发智能分区算法算法；
        3、负责智能脱困算法的研发；
        4、负责最优路径算法的优化和开发；
        5、负责局部清扫路径算法优化和开发。
        任职资格:
        1、扎实的掌握C/C++开发、调试的经验，熟悉Linux开发环境；
        2、扎实的数学基础，掌握SLAM算法相关理论知识；
        3、有全覆盖地图搜索算法的开发经验；
        4、精通A*、D*、BFS等算法；
        5、熟练阅读相关英文文献；
        6、熟悉ROS，Gazebo；
        有扫地机器人、无人机、机器人、AGV相关行业经验优先；在校期间有过机器人、智能小车比赛经验的优先。`
    }, {
      name: '嵌入式软件工程师',
      salary: '12-24K 14薪',
      type: '社招',
      edu: '大专',
      city: '深圳',
      content: `工作职责: 
        1、能独立开发调试生产用上位机；
        2、精通STM32单片机开发，熟悉应用各种外设；
        3、熟悉数字电路设计，具有很强的逻辑思维能力、自学能力和团队协作能力；
        任职资格:
        1、精通C语言程序设计，熟悉C++编程；
        2、有扫地机开发经验优先。`
    }, {
      name: '项目经理',
      salary: '15-25K 13薪',
      type: '社招',
      edu: '大专',
      city: '深圳',
      content: `工作职责:
        1、负责组建项目团队、启动项目立项会，负责制定项目实施计划；
        2、组织、分配项目团队成员的工作，落实具体任务，并领导团队针对重要问题提出解决方案；
        3、协调跨部门间的信息和资源，以达到项目进度目标；
        4、负责将客户需求导入内部项目管理工作，并及时反馈信息给客户；
        5、负责项目进度管理、成本控制、质量控制和风险管理；
        6、负责内、外部项目文档收集、整理、归档；
        7、负责组织与项目有关的阶段评审及决策；
        8、定期总结和汇报项目整体进度状况；
        9、负责项目结案（项目经验总结、项目移交）。
        任职资格:
        1、本科及以上学历，机械、工程类专业或管理类相关专业；
        2、3年以上的项目管理相关经验；
        3、熟悉研发流程、产品开发流程和质量控制流程；
        4、熟悉工程、材料和品质等多个领域的基础知识 ；
        5、掌握项目管理领域的知识，具有较强的项目管理能力；
        6、英语听、说、读、写能力优秀；
        7、具备多个项目并行管理经验者优先考虑；
        8、具有PMP证书者优先考虑。`
    }, {
      name: '运动控制算法工程师',
      salary: '15-25K',
      type: '校招/社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1、负责运动控制模型开发优化调试；
        2、负责位置、速度控制接口验证和调优；
        3、负责位置跟随控制算法开发调试；
        4、负责最优路径算法的优化和开发；
        5、负责局部清扫路径算法优化和开发
        任职资格：
        1、扎实的掌握C/C++开发、调试的经验，熟悉Linux开发环境；
        2、扎实的数学基础，掌握SLAM算法相关理论知识；
        3、精通机器人的两轮差速模型；
        4、精通PID的模型建立、仿真、以及参数调优；
        5、熟悉运动插补算法；
        6、熟悉ROS，Gazebo，有扫地机器人、无人机、机器人、AGV相关行业经验优先；在校期间有过机器人、智能小车比赛经验的优先；
        7、有较强的英文文献阅读理解能力，并能转化为工作助力。`
    }
  ]
},
{
  name: 'MINIEYE',
  intro: `MINIEYE成立于2013年，是国内领先的自动驾驶企业，致力于用人工智能技术为自动驾驶汽车提供可靠的感知与决策解决方案。MINIEYE持之以恒的使命，是在提升驾驶自动化程度的同时，降低交通事故率、保障驾乘人员的行车安全。
  MINIEYE总部位于深圳，同时在北京、上海、长沙等地设有分部，团队成员不仅包含青年千人计划专家，还有来自于佐治亚理工学院、美国加州大学、美国波士顿大学、法国科学院、新加坡国立大学、新加坡南洋理工大学、清华大学、华中科大等国内外名校的毕业生，以及来自知名企业与研究机构的优秀前雇员。核心团队成员多次在国际顶尖期刊上发表论文，被深圳市认定为“孔雀团队”。`,
  img: true,
  desc: ``,
  city: '深圳/北京/上海',
  field: '自动驾驶/智能硬件/人工智能',
  scale: '100-499人',
  financing: 'C轮',
  tags: ["五险一金","带薪年假", "周末双休", "员工旅游", "通讯补贴", "节日福利", "免费零食", "弹性办公"],
  web: '',
  enroll: '',
  jds: [
    {
      name: '系统工程师',
      city: '深圳/上海',
      salary: '15-40K',
      type: '社招',
      edu: '本科',
      content: `工作职责:
        1. 客户系统需求确认，制定产品系统方案（包括产品功能规范、系统架构、系统需求分析）；
        2. 负责ADAS项目客户的SOR分解，相关法规标准解读，制定各算法模块[感知，控制等]性能指标，以及指导制定相关测试方案；
        3. 作为验收方，对整个ADAS系统性能指标和各大模块的指标负责；
        4. 了解公司各产品的技术原理，可以对接客户项目需求评估我们技术的满足程度。
        岗位要求：
        1. 熟悉ADAS各模块的原理[感知，控制或执行]，有三年以上ADAS量产的经验；
        2. 有丰富的跟车厂合作经验，具备独立和客户及供应商进行技术交流的能力；
        3. 有一定的计算机编程，计算机视觉或车辆控制的开发经验；
        4. 较好的沟通，书面表达及文档编辑能力。`
    }, {
      name: '融合算法工程师',
      city: '深圳/北京',
      salary: '20-40K',
      type: '校招/社招',
      edu: '硕士',
      content: `职位描述：
        1. 研究摄像头和毫米波雷达多目标跟踪融合算法；
        2. 负责算法的验证和优化。
        岗位要求:
        1. 2年及以上多目标跟踪，摄像头和毫米波雷达融合相关开发经验；
        2. 熟练掌握多目标匹配算法，kalman滤波算法；
        3. 熟悉摄像头，雷达的基本工作原理；
        4．熟练掌握C/C++/Matlab等常用编程语言，丰富的Linux代码开发经验；
        5．具有ADAS、无人驾驶相关项目经验的优先。`
    }, {
      name: 'SLAM工程师',
      city: '深圳',
      salary: '20-40K',
      type: '校招/社招',
      edu: '硕士',
      content: `岗位职责:
        研究开放道路环境，基于单目摄像头的SLAM/VIO算法；
        地图元素重建算法（交通标示牌、电线杆、车道线等）；
        负责算法的实现和优化；
        岗位要求:
        两年以上SLAM、VIO算法开发经验，熟悉目前主流的视觉SLAM/VIO算法；
        有基于视觉的高精地图开发经验的优先；
        理论基础扎实，熟悉多视图几何，卡尔曼滤波等原理；
        C/C++ 算法实现能力；
        具有ADAS、无人驾驶相关项目经验的优先。`
    }, {
      name: '视觉算法工程师',
      city: '深圳/北京/南京/上海',
      salary: '20-40K',
      type: '校招/社招',
      edu: '硕士',
      content: `职位描述：
        1. 采用深度学习与传统机器学习方法，对自动驾驶场景下的视频做语意分析，包括目标检测、语意分割、图像分类、特征点定位、光流跟踪等任务。
        招聘要求：
        1.硕士及以上学历，熟悉计算机视觉与模式识别，做过图像中的目标检测、语意分割、图像分类、特征点定位等任务，有自动驾驶方向的工作经验优先；
        2.深入理解目标检测、特征点定位、目标跟踪主流算法，了解传统机器学习算法及深度学习相关分类算法；
        3.具备相关扎实的理论基础，与较强的动手能力，和分析问题能力；
        4.熟练使用pytorch, caffe, tensorflow，mxnet中的一种或者几种深度学习框架；
        5.具有良好的英文读写能力。`
    }, {
      name: 'C++算法开发工程师',
      city: '深圳/上海',
      salary: '20-40K',
      type: '校招/社招',
      edu: '硕士',
      content: `职位描述： 
        1. 根据 舱内感知产品 的需求和使用场景，进行相关功能的算法研发与测试； 
        2. 和多个部门（硬件、嵌入式、深度学习算法组等）协作，开发高效可靠的视觉感知产品（语言以C++为主），并直接对最终产品负责。 
        任职要求：
        1. 工作细心，认真负责。有强烈的责任感，积极的态度； 
        2. 有良好的沟通表达能力，和团队意识； 
        3. 精通常用数据结构和算法，有相关背景者优先； 
        4. 国内外知名院校本科以上学历； 
        5. 两年以上 C/C++ 研发经验。编程能力优秀； 
        6. 思路清晰，思维敏捷，乐于钻研，快速的学习能力，良好的英文资料阅读能力； 
        7. 熟悉 Linux 开发环境； 
        8. 有 ICPC/CCPC 类编程竞赛获奖经历者优先； 
        9. 有计算机视觉或者计算机学科背景优先。 `
    }, {
      name: '自动驾驶算法开发工程师',
      city: '深圳',
      salary: '15-40K',
      type: '校招/社招',
      edu: '本科',
      content: `职位描述：
        1. 根据自动驾驶视觉感知模块的需求和使用场景，进行相关功能的算法研发与测试；
        2. 和多个部门（硬件、嵌入式、深度学习算法组等）协作，开发高效可靠的视觉感知产品，并直接对最终产品负责。
        职位要求：
        1. 工作细心，认真负责。有强烈的责任感，积极的态度；
        2. 有良好的沟通表达能力，和团队意识；
        3. 精通常用数据结构和算法，掌握C++/golang/rust/java其中一种编程语言；
        4. 国内外知名院校本科以上学历；
        5. 思路清晰，思维敏捷，乐于钻研，快速的学习能力，良好的英文资料阅读能力；
        6. 有计算机视觉或者计算机学科背景优先。
        7. 有编程竞赛获奖经历者优先；`
    }, {
      name: '嵌入式开发工程师',
      city: '深圳',
      salary: '15-35K',
      type: '校招/社招',
      edu: '本科',
      content: `职位描述：
        1. 设计并开发量产级 SDK和解决方案；
        2. 开发linux驱动程序和应用程序，并进行系统集成和测试，解决疑难问题；
        ３. 设计并开发RTOS程序，满足系统高实时，异常安全等需求；
        ４. 深入理解产品，参与产品的整个生命周期开发过程，包含需求定义、设计、实现、测试等。
        任职资格：
        1. . 丰富的嵌入式软件开发和集成经验，精通C/C++语言编程，丰富的linux应用开发能力 ，有良好的编程习惯 ，有独立设计开发能力；
        2. 深入理解linux内核，丰富的linux内核开发经验，如：linux内核的移植和开发、linux设备驱动的设计和开发；
        3. 熟悉常见的串行接口通信协议（UART，SPI，I2C，USB）、高速数据接口协议的经验（以太网，MIPI，USB，HDMI，PCIe，SATA）以及内存访问协议（SDRAM / DDRx控制器和PHY）；
        4. 深入理解硬件和ARMv7、ARMv8架构，多核编程和SMP相关的知识 ，熟悉异构多核硬件架构，具有基本的架构设计能力。`
    }, {
      name: 'HIL开发工程师',
      city: '深圳/上海',
      salary: '20-40K',
      type: '社招',
      edu: '本科',
      content: `职位描述：
        1.负责ADAS的HIL系统搭建和维护； 
        2.负责HIL台架的测试工作，协助算法工程师进行算法开发及测试工作； 
        3.编写测试用例，编写自动化测试脚本，完成测试分析。
        任职要求：
        1.2年以上ADAS的HIL开发经验； 
        2.熟悉MATLAB、C语言，熟悉CarSim, preScan，dSPACE、vector等工具或软件； 
        4.具备良好的沟通能力及团队协作精神、工作责任心强； 
        5.本科及以上汽车/车辆工程、电气自动化、控制工程、机电一体化等相关专业；
        5.优秀的职业素养和团队合作精神，良好的沟通和抗压能力。`
    }, {
      name: '控制算法工程师',
      city: '深圳',
      salary: '20-40K',
      type: '社招',
      edu: '本科',
      content: `职位描述：
        1.负责ACC or LKA功能控制策略和控制算法研发和优化；
        2.负责ACC or LKA功能控制算法的测试。
        职位要求：
        1.本科及以上，熟悉车辆控制理论；
        2.专业要求自动控制，车辆工程等优先
        3.3年以上相关开发领域工作经验，有ACC or LKA开发相关经验优先；
        4.车辆工程控制类相关专业，熟悉自动驾驶系统相关零件的工作原理；
        5.熟悉matlab/simulink，C开发；
        6.良好的沟通能力，压力承受能力，具备较强的创新能力。`
    }, {
      name: '算法测试工程师',
      city: '深圳',
      salary: '15-30K',
      type: '社招',
      edu: '本科',
      content: `职位描述: 
        1. 负责自动驾驶L0 ~ L2产品的质量评测，推动产品落地； 
        2. 参入自动化评测系统建立，完善评测体系； 
        3. 深度参入产品研发项目，协同项目经理、算法研发人员一起根据产品需求制定测试方案，执行测试用例； 
        任职要求: 
        1. 本科及以上学历，计算机、通信等相关专业； 
        2. 良好的数据敏感能力、较强的逻辑分析能力、有1到2年算法测试相关工作经验； 
        3. 有自动驾驶行业相关从业经历者优先； 
        4. 熟练使用一种或多种脚本语言； 
        5. 严谨细致，善于发现问题、分析问题，快速适应和学习能力，良好的沟通能力。`
    },
  ]
},
{
  name: '大族机器人',
  intro: `深圳市大族机器人有限公司，由上市公司一大族激光科技产业集团股份有限公司(股票名称：大族激光，股票代码：002008)投资组建，是在大族电机机器人研究院100多人的团队基础上孵化而成的国家级高新技术企业，公司致力于智能机器人在工业、医疗、物流、服务等领域的研发、推广和应用，成为智能机器人时代的全球领导者。
  公司成立于2017年9月，总部位于深圳市南山区科技园，生产基地位于宝安区大族激光工业园。2019年4月，公司在德国投资设立大族机器人德国子公司，团队成员为来自世界不同国家的顶尖的机器人行业专家，助力公司成为世界领先的机器人行业标杆。
  公司与苏黎世联邦理工学院、德国亚琛工业大学、加拿大麦克马斯特大学、德国弗劳恩霍夫研究所、德国比勒费尔德大学、新加坡国立大学、意大利理工学院、德国汉堡工业大学、德国达姆施塔特工业大学、德国乌尔姆大学、香港理工大学、清华大学、北京航空航天大学、中科院深圳先进院、深圳大学、南方科技大学、广东工业大学、华中科技大学等国内外知名大学建立了长期合作的关系。
  公司秉承“领先、快速、服务、分享、激情、积极、好奇”的企业价值观，以“用机器人技术为人民服务”为使命，基于十多年的电机、伺服驱动和运动控制经验，掌握了智能机器人的所有核心关键技术，自主开发的六自由度和七自由度协作机器人，技术全球领先，具有世界核心竞争力。公司紧密把握市场需求，积极研讨新技术，开展机器人在各种细分市场的应用开发，深入推进协作机器人事业。`,
  img: true,
  desc: ``,
  city: '深圳',
  field: '机器人',
  scale: '100-499人',
  financing: '',
  tags: ["竞争力薪酬", "员工培训", "年终奖金", "加班补助", "员工宿舍", "节日福利", "高温补贴", "年度旅游", "年度体检"],
  web: '',
  jds: [
    {
      name: 'UI设计师（产品设计师）',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.负责机器人软件产品设计和体验的相关工作，完成业务流程、任务流设计和界面设计；    
        2.具有良好的需求把握和逻辑分析能力，理解业务和用户需求，并根据产品使用场景和资源配置提出可行性设计方案；
        3.组织产品评估与可用性测试，持续打磨产品；
        4.与开发团队紧密合作，管控设计质量，配合团队完成产品走查与验收；
        5.关注市场趋势和竞品，结合现产品功能进行优化；  
        6.输出指导性的产品设计相关文档，如需求文档、设计文档。
        任职要求
        1.本科（或）以上学历，工业设计、人机交互、视觉设计、计算机等相关专业；
        2.3年以上的产品设计相关经验；  
        3.熟练运用各类产品界面设计工具，如：Sketch、Figma、Axture等；  
        4.优秀的理解和沟通能力，能精准的叙述设计的内容以及思路，与团队进行高效的沟通与协作。  
        5.积极主动，学习能力强，注重细节，专业意识，团队合作精神和责任心；
        6.具有创造性思维，能从用户体验角度提出独立的方案；
        7.能够对设计任务进行有效的拆分和分配，推动设计在项目中的实现。`
    }, {
      name: '算法工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.负责机器人标定、性能测试等用于生产测试的算法和软件的开发；
        2.负责机器人搬运、码垛、焊接、力控等工艺包算法开发；
        3.负责算法的实现、优化、测试、移植和产品化等相关工作；
        4.负责机器人产品性能的持续优化和产品化；
        5.编写算法技术文档。
        任职要求：
        1.本科及以上学历，自动化、数学、机械电子、航空航天、计算机、测控等相关专业；
        2.具有机器人、CNC控制算法等相关领域2年以上工作经验；
        3.同时具备理论研究、推导、仿真以及编程实现的能力，熟悉Matlab/Python、C/C++；
        4.熟悉机器人的正逆解、轨迹规划、动力学建模、伺服控制等；
        5.熟悉机器人行业应用，如搬运、码垛、上下料、焊接、打磨等；
        6.思路清晰，分析能力强，主观能动性强。`
    },  {
      name: '视觉算法工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.负责机器人视觉模块开发，算法研究与应用；
        2.熟悉常用视觉相机、光源、镜头选型，应用案例测试；
        3.撰写软件设计方案，开发文档，测试文档等。            
        4.负责公司协作机器人视觉应用硬件选型、验证、测试；
        5.完成上级领导安排任务；
        任职要求：
        1.本科或同等以上学历（海归优先）；
        2.计算机、视觉、自动化相关专业；
        3.CET-6考试分数426分以上（或者同等英语能力），英语口语流利。`
    },  {
      name: '软件开发工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.负责公司控制器开发、测试；
        2.负责公司示教器开发、测试；
        3.管理软件BUG，管理并发布软件版本；
        4.设计编写软件设计文档
        5.完成上级领导交办的其他工作。
        任职资格：
        1. 本科或同等以上学历；计算机、软件相关专业；
        2. 具有三年以上自动化行业/工控行业大型知名公司软件开发经验；
        3. 有较强的学习能力、良好的沟通和团队协作能力；  
        4. 熟悉C++软件开发技术，python开发，网络开发，多线程开发； 
        5. 熟悉工业机器人开发技术和运动控制开发技术；
        6. 能够运用脚本语言如python开发项目。
        前端开发工程师
        岗位职责：
        1.根据产品需求，设计、开发、测试和调试web网页，编写高质量可维护的代码，并撰写相关技术文档。
        2.负责线上系统维护、不断优化现有产品，参与团队基础技术、应用框架体系和工程化体系建设。
        任职要求:
        1.本科及以上学历，计算机科学专业，三年以上基于vue框架的前端开发经历，熟练掌握JS、HTML、CSS。
        2.精通Vue，并有复杂的基于vue框架的PC端成熟复杂项目经验。
        3.具备扎实的计算机基础知识，熟练使用Node.js。
        4.责任心强，具备较强的学习能力、抗压能力和团队协作能力。
        加分项:
        1.有客户端(Electron等)、uniapp开发经验者优先。
        2.熟悉数据库优先。
        3.有3D可视化开发经验者优先，熟悉使用three.js。
        4.对知名开源项目有过贡献者优先。`
    },  {
      name: '应用软件工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.根据机器人细分市场的客户需求，负责机器人应用的软件设计、开发、测试和调试工作；
        2.编写相关技术文档；
        3.负责现场安装调试；
        4.项目过程中，提供技术指导、故障排除及后期维护工作。
        任职要求：
        1.本科或同等以上学历；
        2.计算机、自动化相关专业；
        3.擅长C++/QT/MFC/HMI/python任意一种；
        4.有机器人相关整机自动化项目经验优先；
        5.接受出差。
        嵌入式软件工程师
        岗位职责：
        1.负责电机系统的嵌入式开发；
        2.负责底层各种软件接口的开发和维护；
        3.在底层实现电机控制算法的编写；
        4.完成上级领导交办的其他工作。  
        岗位要求：
        1.本科及以上学历；电子、自动化专业。
        2.具备DSP、ARM等嵌入式开发经验，熟悉电机控制系统、数字信号处理优先考虑；
        3.精通C，精通TI DSP或者STM32，熟悉底层开发流程；
        4.解决分析问题的能力强。英语四级以上。`
    },  {
      name: '软件测试工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.负责工业机器人的示教器和控制器测试，制作测试报告等相关文件，管理发布软件版本；
        2.使用python/C++开发自动测试工具；
        3.收集并整理BUG，要求开发人员完成BUG修改，对产品提出改善性的建议，积极学习工业机器人测试技术，提升测试水平。
        任职要求：
        1.专业限制：本科及以上学历，工业自动化专业；
        2.行业限制：具备两年以上工业机器人/自动化行业测试、开发、技术支持等相关工作经验，能够熟练使用机器人自动控制、运动控制测试技术；有工业机器人系统测试经验的优先考虑。
        3.素质要求：认同测试工作的重要性，有较强的主动性、学习能力和抗压能力。`
    },  {
      name: '硬件工程师（电气工程师）',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.负责机器人机器人本体及控制器的电气系统设计；  
        2.负责电气故障分析，解决相关问题； 
        3.跟进电气部分的产品化。 
        任职要求：   
        1.大专及以上学历，电子、电气、自动化相关专业； 
        2.  三年以上电子电气自动化相关行业工作经验，熟悉EMC 、EMI等设计标准，熟悉CE、UL等机器人相关认证者优先；
        3.  有机器人、数控机床、自动化设备相关电气设计工作经验者优先；
        4.  执行力和团队协作能力强，具有解决问题的能力，能适应短期出差。`
    },  {
      name: '机器人本体结构工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.负责机器人机械结构、传动结构、减速机结构及密封结构的方案设计及选材选型； 
        2.负责机器人产品机械结构的仿真模拟、结构振动模态分析、结构的改进及优化；；
        3.负责机器人零件3D及工程图绘制；
         4.  协助工业设计师、电子工程师、电气工程师优化机器人设计；
         5. 负责处理产品安装调试中发现的结构上的技术问题并进行优化设计； 
         6. 负责将设计成果输出图纸、Bom表等。  
        任职要求：
        1.本科或以上学历，机械、机电一体化专业, 良好的英语听说能力；
        2.有工业机器人本体设计、大型自动化设备结构设计经验，熟悉精密复杂机械设计原理及方法；
        3.能够对机械结构进行可行性分析，合理的材料选型、受力分析并进行结构优化；
        4.熟悉钣金件、机加件、塑胶等加工工艺；
        5.熟练使用Proe/SolidWorks等相关软件；
        6.工作认真负责，严谨细致，有良好的创新精神和团队精神。`
    },   {
      name: '机械工程师（项目）',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.参与项目评审，负责机械方案设计，包括制图、材料与配件选型、工装夹具设计等，把控项目风险点；
        2. 对产品结构的关键部件进行静力计算、运动学分析、动力学分析与仿真；
        3. 负责项目输出资料的编制、更改、更新、归档；
        4.负责机械加工的沟通与进度跟踪、样机的装调、量产跟进；
        5.处理生产、加工及装配调试过程中出现的问题；
        6.负责与客户技术沟通，提供现场应用及售后技术服务。
        任职要求： 
        1.本科及以上学历，机械工程，机电一体化，机器人模具设计等相关专业；
        2.有3年以上非标自动化或机器人行业设计工作经验；
        3.可独立设计机械项目，有创新能力，有良好外观设计和审美能力；
        4.熟练使用office、proe或solidworks或autocad等软件，并熟练进行机械系统三维设计并绘制工程图纸； 
        5.熟悉常用机电部件及其品牌；
        6.有机械设计常用材料，如铝合金，钣金及塑胶件有过相关设计经验优先。`
    },   {
      name: '机器人测试工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.负责公司机器人产品出货前整机测试工作;
        2.记录并反馈产品异常问题，配合工程师排查解决问题;
        3.制作测试治具，优化测试方法及流程。
         任职要求:
        1.大专及以上学历，机器人、电气自动化、机电一体化等相关专业。
        2.有机器人测试/调试相关经验者优先。
        3.了解基本的机械/电气原理。
        4.能熟练使用office办公软件。
        5.工作认真仔细，责任心强。
        优秀应届毕业生亦可。`
    },    {
      name: '技术支持工程师（海外/国内）',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '深圳',
      content: `岗位职责：
        1.参与项目评审，根据客户需求制定产品售前方案，进行方案演示和客户培训；
        2. 为客户提供技术咨询和现场调试等服务，解决客户问题；
        3. 负责产品说明书等对外技术文档的维护工作；
        4. 提供展会支持，保证公司参展设备在展会期间的正常运行。
        任职资格：
        1.大专及以上学历；
        2.机械、电气、机电一体化相关专业；
        3. 一年以上自动化项目经验；
        4. 海外技术支持要求英语六级以上，听说读写能力佳；
        5. 熟练使用CAD、Solidworks、PROE等任意一款制图软件；
        6. 优秀应届毕业生。`
    }
  ]
},
{
  name: '中科深谷',
  intro: `中科深谷是致力于“先进制造”与“人工智能”的深度融合，以新技术促进工业产业发展和赋能工程人才培养的高科技创新型企业。总部位于国家科技之城、全球AI产业基地一中国合肥高新区。目前在北京、上海、深圳、苏州、武汉、西安等地已设立了分公司和办事处。
  团队聚集了一批高学历、年轻化、海外留学经历、资深行业背景的奋斗者。在机器人核心器件、移动作业智能机器人、燃油作业无人机、先进制造工业互联网方面掌握了多项核心技术。机器人与自动化装备技术和产品服务过华为、唯品会、电科集团、富士康、科大讯飞、江淮、奇瑞、国家电网、埃夫特等知名企业单位。燃油轻型重载作业无人机整机性能处于国际行业标准，国内领先水平。已成功应用在森林防火、边境巡检、农业防护应用等。在先进制造产业应用中，通过5G通讯技术及室外北斗导航的融合，打通物理层、数据层、终端应用层，实现多场景人工智能化作业，以先进技术促进产业发展。
  同时，中科深谷立足教育、深化产教融合，探索新技术与新工科产业人才培养内在机理。并以开放的发展观联合和依托国内外多所知名高校科研力量，如清华大学、中国科学技术大学、东南大学、浙江大学、华中科技大学、上海交通大学、北京航空航天大学，美国佐治亚理工学院、新加坡南洋理工大学、香港中文大学等。深入研究不同层次高校机器人工程、人工智能、智能制造等专业（方向）的人才培养模式和教学规律及特点。并将相关的工业产业的核心技术与器件及装备底层开源开放出来，融合人才培养和教学规律，形成系列成熟先进的实验装备和专业课程实验教学解决方案。探索出能同时支撑教学、科研、工程项目、创新大赛四维一体化人才培养创新模式。努力搭建最专业的“开源机器人+”产业人才培养赋能服务生态圈。含仪器开发、实验装备、师资培训、云课程、产业学院、校企合作、产教融合、科技投资、项目孵化等。截至目前，团队已服务国内外500+企业单位，300+高校院所。`,
  img: true,
  desc: ``,
  city: '合肥',
  field: '机器人',
  scale: '100-499人',
  financing: '',
  tags: ["五险一金", "绩效奖金", "年终奖金", "加班补贴"],
  web: '',
  jds: [
    {
      name: '伺服驱动器中高级软件开发工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '合肥',
      content: `岗位职责：
        1. 负责伺服电机驱动器的软件开发工作，与硬件工程师配合完成产品开发/小批量制造。
        2. 负责对伺服驱动器硬件及整个运动控制系统进行功能、性能测试。
        3. 设计控制算法、软件实现，完成调试测试。
        4. 设计电机参数辨识、负载辨识、惯量辨识、振动抑制、ADRC自抗扰等伺服驱动控制算法、软件实现，完成调试测试。
        5. 完成产品开发过程中的产品规格书等各类文档，并及时归档。
        6. 完成上级安排的其它工作。

        任职资格：
        1. 本科及以上学历，电力电子、电气传动、电气自动化等相关专业毕业。
        2. 有两年及以上伺服驱动器开发工作经验，能独立承担驱动器软件开发工作，做过成型产品者优先。
        3. 精通STM32或DSP软件设计，精通C语言，熟练使用IAR、Keil或CCS开发经验者优先。
        4. 精通电力机拖动理论，了解直流无刷、交流伺服电机的原理，熟练掌握自动控制理论及PID算法的优先。
        5. 掌握磁场定向控制等电机驱动控制相关算法，了解各种滤波理论和使用方法，有MATLAB/Simulink算法仿真经验者优先。
        6. 熟悉绝对值编码器原理和主流绝对值编码器通信协议，有绝对值编码器使用经验者优先。
        7. 熟悉前馈原理，了解动力学基本理论，有振动抑制、电机参数识别经验者优先。
        8. 熟悉canopen，ethercat等总线标准，有相关总线开发经验者优先。
        9. 具有较强的学习、创新能力，独立工作能力强，并具有团队精神，抗压能力较强，有较强的沟通、协调能力，愿意接受挑战。`
    }, {
      name: '伺服驱动中高级硬件工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '合肥',
      content: `岗位职责：
        1. 负责机器人控制系统硬件电路设计。
        2. 驱动器原理图和PCB设计制板及电路仿真和分析。
        3. 关键元器件、芯片的选型。
        4. 编写驱动器相关产品硬件部分的设计文档、技术标准与参数。
        5. BOM及相关技术文档规范化整理等。
        6. 协助控制器软件、硬件联调，性能、功能测试。
        7. 解决生产过程中的技术问题。

        任职资格：
        1. 本科及以上学历，电子、自动化、机电、计算机等相关专业毕业。
        2. 精通一款PCB设计软件，并具有4层板及以上的设计及仿真经验。
        3. 三年以上电机驱动或单片机控制系统硬件研发工作经验。
        4. 精通数字、模拟电路及DSP/ARM/FPGA电路，熟悉软硬件开发流程的优先。
        5. 有扎实的数电/模电设计和分析能力。
        6. 熟悉如UART、CAN、IIC、RS485、WIFI等常用通讯接口的硬件设计。
        7. 有两年以上的实际项目开发经验。 `
    }, {
      name: '高级FAE技术支持工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '合肥',
      content: `岗位职责：
        1. 负责公司产品知识、课程、PPT等的演示、讲解。
        2. 与老师进行线上交流沟通，收集客户的技术问题，担任线上讲师。
        3. 协助销售部参加展览会、交货等并进行现场讲解演示、交货调试、培训。
        4. 参与公司的技术培训,负责公司产品的售前、售后和技术支持工作。
        5. 负责技术方案的设计和撰写，为销售部及时提供对应文案。
        6. 参与产品认证、专利撰写、项目申报等工作。
        7. 公司交办的其它工作。

        任职资格：
        1. 本科及以上学历，自动化、电子技术、机电一体化、汽车电子等专业毕业，硕士优先。
        2. 两年以上相关工作经验。
        3. 善于沟通交流，有较强的学习能力，接受出差。
        4. 有独立完成过DSP相关设计项目的优先。
        5. 有TI的DSP电路设计经验者优先。
        6. 有电机驱动、运动控制、移动机器人、机械臂控制系统软件开发经验者优先。`
    }, {
      name: '深谷机器人学院副院长',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '合肥',
      content: `岗位职责：
        1. 负责深谷机器人学院的运营管理工作。
        2. 负责培训讲师的管理、考核及晋升等工作。
        3. 制定招生计划，开展招生推广及宣传工作。
        4. 对培训需求进行调研，对培训课程进行开发、编制、调整、执行，制定培训计划。
        5. 把握学员学习情况，跟进培训效果、收集培训需求。
        6. 上级交办的其他工作。

        任职资格：
        1. 本科及以上学历。
        2. 八年以上教务、招生、学校运营等相关工作经验，有大专、培训机构、高校工作经验者优先。
        3. 熟悉机器人行业、业务，有培训学校工作经验者优先。
        4. 具有良好的团队领导能力，有20人以上团队管理经验者优先。
        5. 具有较强的抗压能力，优秀的组织协调、沟通技巧、人员管理等能力。`
    }, {
      name: '互联网产品运营总监',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '合肥',
      content: `岗位职责：
        1. 负责公司互联网平台的总体运营，带领运营团队实现目标。
        2. 策划、推进及组织协调公司运营活动，针对用户、产品特点和市场状况，进行市场跟踪，针对市场变化制定相应调整策略，提高运营效果。
        3. 建立并完善公司互联网产品运营工作标准和流程。
        4. 负责商务拓展及合作，建立良好的业务合作关系，开展运营项目的推广工作，保证运营项目的顺利执行与业务目标的达成。
        5. 负责产品销售和推广活动组织、开发品牌推广。
        6. 带领部门同事做好产品和推广工作。

        任职资格：
        1. 大专及以上学历。
        2. 五年以上互联网、电子商务产品运营经验，有人工智能、智能制造、机器人、系统集成等行业运营经验者优先。
        3. 熟悉互联网的运营发展趋势，精通互联网的产品、模式和营销方法。
        4. 有丰富的互联网产品运营经验，对互联网及其服务应用的发展具有深入研究，对产品和数据运营敏感，能够使用相关工具分析数据并做出正确的判断。
        5. 了解用户体验的要素，善于倾听用户声音，了解用户及用户需求，注重用户感受及体验。
        6. 擅长项目管理，具备较强的分析和解决问题能力，以及丰富的领导经验和沟通能力。`
    }, {
      name: '机械臂控制系统中高级开发工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '合肥',
      content: `岗位职责：
        1. 对ROS系统或其它实时Linux控制系统的机械臂进行需求分析，方案设计，并进行设计开发。
        2. 编制项目相关开发的技术文档。
        3. 能实现机械臂的高级动力学算法，提升机械臂的性能。。
        4. 对打磨等力控机械臂开发对应的控制软件，按照客户要求做好技术开发工作。
        5. 进行功能仿真和实际控制。
        6. 有CANopen或EtherCAT方面的应用开发经验。
        7. 公司领导安排的其它相关的工作。

        任职资格：
        1. 本科及以上学历，计算机、机电、自动化、电子等相关专业毕业。
        2. 三年及以上相关工作经验，有机器人研发相关工作经验者优先。
        3. 掌握机器人控制理论，有ROS系统开发相关经验的优先。
        4. 熟悉智能控制器、机器人操作系统、视觉抓取、移动机械臂等的优先。`
    }, {
      name: '自动驾驶控制系统开发高级工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '合肥',
      content: `岗位职责：
        1. 负责自动驾驶物流车、AGV、移动机器人底盘控制器的开发。
        2. 负责智能机器人导航系统的研发，参与导航和控制算法设计及实现。
        3. 参与移动机器人ROS激光雷达导航、视觉导航等的开发工作。
        4. 能读取视觉系统、GPS、超声波等传感器的信息、对云台等机器人相关的部件进行通讯和控制。
        5. 参与完善技术方案并协助组织团队实施。
        6. 移动机器人产品量产的测试、改进、认证、文档撰写等工作。
        7. 公司领导安排的其它工作。

        任职资格：
        1. 本科及以上学历，自动化、机械电子工程、计算机等相关专业毕业。
        2. 三年以上相关工作经验，熟悉经典控制和现代控制原理。
        3. 熟练掌握一款嵌入式控制器（STM32/单片机/ARM等）。
        4. 熟悉嵌入式实时操作系统（FreeRTOS或其他）或MBD simulink开发的优先。
        5. 有AGV控制系统开发、运动控制、组合导航相关应用经验优先。`
    }, {
      name: '研发副总监',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '合肥',
      content: `岗位职责：
        1. 协助CTO了解行业情况，进行调查研究，参与制定适合公司的技术发展路线。
        2. 协助CTO带领研发团队，拟定研发计划，进行项目评估、任务分配，进行项目需求分析、部署等工作。
        3. 对项目质量、进度、完成情况进行监督和管理。
        4. 协助CTO完成重要业务模块及核心框架的搭建及实现，负责解决开发过程遇到的难点。
        5. 研发团队的技术指导，提升技术人员的整体水平。
        6. 协助CTO对研发部的日常管理和部门建设，制定并执行部门工作计划。
        7. 参与产品认证、专利撰写和政府项目申报等工作。

        任职资格：
        1. 本科及以上学历，计算机、电子技术、机电、自动化等相关专业毕业。
        2. 六年以上技术开发经验，其中三年以上大中型企业团队管理经验。
        3. 熟悉软件开发技术与开发流程和机器人行业的优先。
        4. 有人工智能、智能制造、系统集成等行业两年以上同岗位工作经验。
        5. 具有良好的沟通能力和带领团队发展与建设的能力。`
    }
  ]
},
{
  name: '钛米机器人',
  intro: `上海钛米机器人科技有限公司坐落于上海张江高科技园区，是以智能医疗服务机器人为载体，为医疗机构提供智慧医院整体解决方案的创新型企业。公司具有自主研发、生产、销售为一体的完整生态链，并将机器人产品应用于医疗领域，解决了实际医疗问题。自成立以来，公司已累计研发、生产近10款医疗服务机器人产品，拥有将机器人、人工智能和物联网技术转化为具体解决方案的丰富经验。至今，钛米机器人产品已在全国300余家三甲医院落地使用，包括郑州大学第一附属医院、武汉协和医院、上海仁济医院、上海瑞金医院及上海第十人民医院等。在高端医疗服务领域，钛米机器人将打破常规医疗现状，颠覆传统医疗模式，引领医疗领域智能化发展！
  `,
  img: true,
  desc: ``,
  city: '上海',
  field: '医疗设备/器械',
  scale: '100-499人',
  financing: 'B轮',
  tags: ["补充公积金","加班补助", "股票期权", "五险一金", "绩效奖金", "年终奖金", "免费班车", "员工旅游", "定期体检", "扁平化管理"],
  web: '',
  enroll: '',
  jds: [
    {
      name: '机械工程师',
      city: '上海',
      salary: '11-20K',
      type: '社招',
      edu: '本科',
      content: `岗位职责：
        1. 按照产品开发输入需求、医疗设备开发流程进行产品机械结构设计；
        2. 负责研发项目产品中外壳曲面结构的设计、机械结构件的设计；
        3. 负责研发样机的试制和装配，协助设备调试；
        4. 负责研发项目产品机械相关技术文件资料的编制、输出；
        5. 负责产品的装配/测试夹具设计、转产和生产操作指南的编制；
        6. 负责机械件外协加工中的技术指导和质量把控。
        任职要求：
        1. 有3年以上器械产品机械设计经验；
        2. 机械设计与制造、工程材料或机电一体化相关专业本科及以上学历；
        3. 熟练使用3D软件工具进行3D曲面设计及2D制图;
        4. 具备扎实的机械设计基础知识；熟悉机加工件、塑胶件、钣金件、传动件设计;
        5. 了解机械行业相关标准，熟悉机械加工工艺，零件表面的处理工艺，对吸塑、吹塑、注塑、翻砂模具有一定了解;
        6. 熟练CAE（运动仿真特性分析、构件应力应变分析和拓扑优化），不限于Adams，Ansys，NX，Creo;
        7. 熟悉机械结构动作原理、熟悉自动化控制的原理和基本流程;
        8. 具有较强的独立解决问题的能力，有机器人比赛或其它比赛获奖者优先;
        9. 有协作机械臂设计经验者优先;
        10. 有机器移动底盘设计经验者优先。`
    }, {
      name: '系统应用工程师',
      city: '上海',
      salary: '24-45K 15薪',
      type: '社招',
      edu: '本科',
      content: `岗位要求：
        1、负责推进新产品的落地以及提升满意度
        2、对于新产品部署和落地文件负责，包括早期项目安装部署、培训和项目跟进
        3、对内培训与支持区域技术团队、技术支持团队
        4、定期整理复盘，与跨部门形成良好沟通，提升产品的质量以及迭代
        技能要求: 
        1、 有良好的文档撰写能力，可以将问题进行具象和抽象描述
        2、 良好的沟通能力，可以与研发进行技术的交流以及内部培训，准确传递技术、产品、价值等信息
        3、 积极向上的态度以及良好的抗压能力
        4、 有计算机背景，过往有硬件、网络、软件、系统等能力为加分项`
    }, {
      name: '机器人软件开发工程师',
      city: '上海',
      salary: '13-20K',
      type: '校招/社招',
      edu: '本科',
      content: `岗位职责：
        1. 负责机器人控制、界面、工具等软件的设计与开发;
        2. 负责相应软件的设计、使用说明等文档的编写;
        任职要求：
        1. 较强的逻辑思维能力，扎实的编码功底;
        2. 有较丰富的图形界面程序的开发经验;
        3. 熟练掌握C++/python等编程语言，熟练掌握TCP/http等网络协议的应用，有较强的编码实现能力；
        4. 有机器人领域软件开发、ROS等经验者优先。`
    }, {
      name: 'SLAM算法工程师',
      city: '上海',
      salary: '20-40K',
      type: '校招/社招',
      edu: '本科',
      content: `岗位职责：
        1. 负责SLAM算法的开发;
        2. 负责算法的编码和单元自测;
        3. 有机器人行业从业经验者优先。
        任职要求：
        1. 较强的逻辑思维能力，扎实的算法功底;
        2. 熟悉SLAM中建图、定位、导航、避障等算法;
        3. 熟悉基于ROS的机器人算法开发;
        4. 熟练掌握C/C++语言，有很强的算法分析和实现能力，具备良好的代码和文档能力。`
    }, {
      name: '机械臂算法工程师',
      city: '上海',
      salary: '20-40K',
      type: '校招/社招',
      edu: '本科',
      content: `工作职责：
        1. 负责机械臂运动学、动力学算法的研究及文档编写;
        2. 负责机械臂运动学、动力学算法的编码实现、测试及文档编写;
        工作要求：
        1. 精通常用机械臂运动学、动力学算法;
        2. 有较强的（C++/MATLAB）编码能力;
        3. 有扎实的数学基础者优先;
        4. 有机械臂实际项目经验者优先。`
    }, {
      name: '视觉算法工程师',
      city: '上海',
      salary: '20-40K',
      type: '校招/社招',
      edu: '本科',
      content: `工作职责:
        1.研究与实现各类深度，点云数据处理算法，如点云聚类，配准，特征计算，去噪，分割等算法
        2.研究与实现各类图像处理算法
        3.研究各类图像点云处理算法的高性能首先方法
        4.研究机械臂抓取位姿态规划算法
        任职资格：
        1.计算机，数学等相关专业硕士及以上学历。
        2.有扎实的图像处理算法理论基础，包括卷积神经网络，传统视觉算法，了解常用的深度学习框架，如tensorflow，Caffe等。
        3.精通机标定，图像增强，目标识别，位姿估计，点云处理和缺陷检测等一个或多个领域，
        4.机械臂视觉抓取项目经验优先
        5.有较强的编码实现能力，精通C++具有linux系统下开发经验。`
    }
  ]
},
{
  name: '程天科技',
  intro: `杭州程天科技发展有限公司于2017年1月成立，是一家集研发、生产和销售为一体的科技型企业。公司前身为哈尔滨程天科技发展有限公司（2012），目前分为杭州总部与哈尔滨公司。程天科技致力于外骨骼机器人技术、智能医疗器械、特种机器人技术与智能系统的开发。其哈尔滨公司于2015年被认定为国家高新技术企业。经过多年的技术积累，程天科技已经成功完成多项科研及工业化产品项目，已申请自主知识产权100余项，并获得各领域奖项20余项，是一家以技术创新为核心驱动力的机器人技术公司。

  程天科技致力于通过人工智能（AI）与机器人技术，配合数据分析及云计算等方式为行动失能、弱能的伤友、老年人及康复医疗机构提供智能康复器械、康复辅具产品和智能化解决方案，促进医疗康复、养老产业发展。以造福肢体残疾患者与行动不便者为已任。同时也涉及娱乐、工业、运动等领域外骨骼技术的研究和产品开发。

  2018年程天科技获得了Pre-A轮融资，引入产业投资人，资金和资源的注入更加速了程天科技的发展。程天科技全体员工秉承“解决问题，信任彼此，与时俱进”的企业文化，拓展人类的感知与体能，满足人们对便捷移动、自由生活的核心需求，忠于企业使命，技术和格局与时俱进、保持技术的先进性，提供更好的机器人产品。坚持在智能技术领域精耕细作，通过技术提升产品的安全性和先进性，通过人文关怀提升用户体验，不断完善外骨骼技术产业链，成为全球外骨骼领域领军企业。人工智能时代已来，未来必将是人机结合的时代，外骨骼必然成为人类的又一个附属器官，程天外骨骼的一小步，便是人类的一大步。

  企业使命: 让每一个人享受机器人的服务
  企业愿景: 成为全球外骨骼领军企业
  企业理念: 解决问题、信任彼此、与时俱进
  `,
  img: true,
  desc: `成为全球外骨骼领军企业`,
  city: '杭州',
  field: '人工智能 机器人',
  scale: '20-99人',
  financing: 'A轮',
  tags: ["五险一金", "绩效奖金", "交通餐饮补贴", "团队聚餐", "定期体检", "节日礼物", "领导好", "休闲餐点"],
  web: '',
  jds: [
    {
      name: 'CTO',
      salary: '面议',
      type: '社招',
      edu: '硕士',
      city: '杭州',
      content: `岗位职责:
        1. 负责核心技术的研发工作； 
        2. 负责核心技术的研究、计划、实施，确保技术的超前性、竞争性； 
        3. 负责技术或项目的可行性评估； 
        4. 负责指导、处理、协调和解决公司项目中出现的技术问题。 
        5. 负责指导制定、审核公司技术管理制度和技术规程标准。
        任职资格： 
        1. 硕士及以上学历，自动控制、自动化、电子信息、控制、机械等相关专业； 
        2. 10年及以上机器人或工业自动化行业（大疆、优必选、国自、蝶和等）经验且有3年及以上的CTO工作经验； 
        3. 在机械设计、硬件、控制算法等领域有某一项的专长，且在技术的理论知识方面有全面了解，发过论文者优先；
        4. 在技术队伍的建设和管理、人员配置与协调、项目可行性评估等方面有丰富的团队管理经验。
        汇报对象：总经理
        下属团队：基础创新中心、技术服务平台`
    }, {
      name: '研发项目经理',
      salary: '20-30K',
      type: '社招',
      edu: '本科',
      city: '杭州',
      content: `岗位职责:
        1. 负责公司自研产品的项目管理，包括资源调配、人员协调、进度跟进、品质控制等，确保项目按期按质完成交付；
        2．寻找挖掘应用场景和客户的需求，规划及细化产品的需求点和设计点；
        3．规划及跟进产品研发周期，协调研发同事，跟踪产品开发进度，完成产品的开发、测试、量产、发布等相关工作，并撰写项目相关报告；
        4．协助市场销售团队进行市场调研，交付和维护满足顾客需求的市场驱动型产品；
        5．产品落地相关认证调查及实施。

        岗位要求：
        1．本科及以上学历，自动控制、机电等相关专业背景；
        2．5年以上机器人、自动化、智能硬件、机电类相关产品研发岗位经验，2年以上新产品的研发项目管理经验，有成功量产及销售的产品经验者优先；
        3．管理客户期望，能够协调产品需求点和技术点之间的矛盾，遵守严格的工程开发流程，协调各部门高效推进产品进度；
        4．具备卓越的执行能力，具有优秀的沟通、协调、抗压能力强，能够有效地组织和推进跨职能、跨团队的合作项目；
        5．具备较强的逻辑思维能力，具备对并行项目的整体把控能力；具备良好的语言组织能力，能够理解技术要点，并形成完整的报告材料。`
    }, {
      name: '嵌入式软件工程师',
      salary: '15-30K',
      type: '社招',
      edu: '本科',
      city: '杭州',
      content: `岗位职责：
        1. 负责嵌入式软件设计开发;
        2. 负责接口通信，算法等的调试及实现工作;
        3. 进行软件bug修复与性能优化;
        4. 协助进行硬件及电子部分的调试与测试;
        5. 根据项目要求完成工程文档。
        任职要求:
        1. 计算机科学与技术、自动化、电子信息工程相关专业本科及以上学历，5年及以上相关工作经验者优先；
        2. 熟悉软件开发流程，有良好的模块化编程习惯和文档规范；
        3. 熟练掌握C/C++，可进行上位机测试软件的开发；
        4. 精通ARM，DSP或者MIPS等CPU，精通SPI、I2C、USB、CAN、SD、UART、TCP/IP等驱动的开发；
        5. 精通Linux系统下的软件开发；
        6. 熟悉ROS操作系统及消息中间件技术优先。`
    }, {
      name: '电机工程师',
      salary: '10-20K',
      type: '社招',
      edu: '本科',
      city: '杭州',
      content: `岗位职责：
        1. 负责直流无刷电机或永磁同步电机的方案制定、设计开发；
        2. 完成电机测试方案的制定，并指导测试部门完成各项测试；
        3. 跟进和解决电机生产问题；
        4. 完成相关技术文档。
        任职要求：
        1. 大学本科及以上学历；
        2. 电机、机电或相关专业，有3年以上整机设计经验，有伺服设计经验优先，熟悉伺服电机的生产制造、检测等环节，对伺服类霍尔和编码器有一定的认识，了解绕组，铁芯，磁钢等电机相关的生产工艺和流程；
        3.熟悉电磁仿真，热力场仿真，电机的绕组、电磁场等进行设计,熟练使用Ansys，Motor-cad，Ansoft等专业软件，懂Matlab优先考虑，熟悉solidwork，cad等机械制图软件；
        4. 有量产经验优先。`
    }, {
      name: '可靠性工程师',
      salary: '8-13K',
      type: '社招',
      edu: '本科',
      city: '杭州',
      content: `岗位职责：
        1. 负责机器人产品可靠性设计分析、可靠性分析评估，可靠性试验及可靠性标准体系建设；
        2. 组织可靠性验证实验并给出报告，并协助研发人员解决问题。 
        3. 能够独立研发开拓非常规的可靠性测试；根据需求探索新的测试方法和测试用例。
        职位要求：
        1. 本科以上，可靠性、机电一体化或自动化相关专业，有2年以上相关产品可靠性测试工作经历；
        2. 懂可靠性工程，熟悉可靠性试验，包括不限于高加速/高应力试验、机械类可靠性、环境类可靠性试验、寿命试验、失效分析等；
        3. 善于学习，有较强的沟通及组织能力。
        汇报对象：研发一部经理`
    }
  ]
},
{
  name: '思岚科技',
  intro: `上海思岚科技有限公司成立于2013年，是全球最早从事机器人自主定位导航技术探索和研发的公司之一，其自主研发的机器人自主定位导航方案在服务机器人领域实现了全面的应用和落地。

  截至目前，思岚科技的业务辐射亚欧美洲20多个国家和地区，服务超过2000家企业和10万个人用户，其产品成熟的应用于微软、壳牌、优必选、科大讯飞、软银等企业的服务机器人项目。

  公司自成立以来已完成了三轮融资，先后获得国家高新技术企业、上海优秀创新创业公司、英特尔机器人创新生态合作伙伴等荣誉，通过不断完善的产品和技术深耕市场，思岚科技坐拥智能移动机器人定位导航70%的市场，是移动机器人行业落地应用的领先企业。

  使命：赋予机器人智能行动能力，跨越技术-成本鸿沟
  愿景：成为全球最好的机器人公司，服务人类世界`,
  img: true,
  desc: `通用智能引领人类生活进步`,
  city: '上海',
  field: '机器人',
  scale: '100-499人',
  financing: 'C轮',
  tags: ["五险一金", "补充医疗", "保险补充", "公积金", "免费班车", "弹性工作", "定期体检", "扁平化管理", "年终奖金", "股票期权"],
  web: '',
  jds: [
    {
      name: '算法工程师',
      salary: '20-35K',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `工作职责:
        1. 负责基于单目，双目，单目+IMU的室内地图构建算法及自主定位算法的前沿技术研发及相关产品实现
        2.负责机器人前沿科技相关算法的研究与开发；
        任职资格:
        1. 本科或本科以上学历，计算机、自动化等相关专业毕业
        2. 熟悉数据结构，操作系统，计算机原理
        3. 对数理逻辑算法有浓厚的兴趣，逻辑思维清晰严谨
        4. 对机器人相关算法有较深的理解和认识，对机器视觉，SLAM，Machine Learning相关领域有深入的研究
        5. 具备扎实的C++语言基础和相关计算机语言编程能力优先
        6. 有Visual Inertial Odometry或SLAM开发经验
        7. 熟悉Feature提取与优化，熟悉DBoW、图优化相关算法
        8. 熟悉ORBSLAM、OKVIS、VINS、DSO算法优先
        9良好的人际交往和团队技术沟通和协调能力。`
    }, {
      name: '嵌入式软件工程师',
      salary: '20-35K',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `工作职责:
      1. 负责基于单目，双目，单目+IMU的室内地图构建算法及自主定位算法的前沿技术研发及相关产品实现
      2.负责机器人前沿科技相关算法的研究与开发；
      任职资格:
      1. 本科或本科以上学历，计算机、自动化等相关专业毕业
      2. 熟悉数据结构，操作系统，计算机原理
      3. 对数理逻辑算法有浓厚的兴趣，逻辑思维清晰严谨
      4. 对机器人相关算法有较深的理解和认识，对机器视觉，SLAM，Machine Learning相关领域有深入的研究
      5. 具备扎实的C++语言基础和相关计算机语言编程能力优先
      6. 有Visual Inertial Odometry或SLAM开发经验
      7. 熟悉Feature提取与优化，熟悉DBoW、图优化相关算法
      8. 熟悉ORBSLAM、OKVIS、VINS、DSO算法优先
      9. 良好的人际交往和团队技术沟通和协调能力。`
    }, {
      name: '测试工程师',
      salary: '20-30K',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `工作职责:
        1. 参与项目需求讨论，制定、设计测试框架及测试方案
        2. 参与日常项目测试，编写测试用例，执行测试，确保项目质量和进度
        3. 追踪项目Bug修复情况，关注寻求解决问题方法
        4. 编写接口测试脚本，主动寻求任何提高测试效率的方法
        5. 持续集成测试，主动提供反馈和优化建议，持续改进项目质量
        任职资格:
        1. 计算机相关专业本科或以上学历, 3-5年软件测试经验
        2. 熟悉测试流程和规范，熟练掌握软件测试方法和常用测试工具
        3. 熟悉Linux或Unix操作系统，具有良好的代码规范意识及编码风格
        4.了解程序动态及静态分析方法
        5. 了解Agile、SCRUM、Test Driven等软件工程方法
        6. 熟悉CI/CD，Jenkins优先
        7.熟悉SLAM、图像视觉、机器人测试优先
        8. 拥有较好的沟通技巧及团队合作精神，较强的责任感及进取精神`
    }, {
      name: 'C++软件开发工程师',
      salary: '20-40K',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `岗位职责：
        1．负责各项软件的设计开发工作，如计算机视觉/图像处理相关算法、Linux系统软件及嵌入式软件
        2．跨部分合作解决产品相关问题
        3．根据研发项目管理要求，输出项目文件和资料
        任职要求:
        1．本科及以上学历；计算机、通信、自动化等相关专业，具有扎实的计算机基础
        2．5年以上工作经验
        3．具有较强的编程能力，精通c/c++编程，有扎实的数学基础
        4．具有Linux开发经验，熟悉Linux开发调试工具
        5．具备模式识别、图像处理、计算机视觉、人脸识别等方面基础优先
        6．熟悉机器人领域SLAM优先
        7．熟悉ARM、DSP、单片机等软件开发优先 
        8．有良好的英文阅读以及文献检索能力
        9．工作认真负责，严谨细致，有良好的团队合作精`
    },
  ]
},
{
  name: '狮尾智能',
  intro: `狮尾智能团队汇集航空、人工智能、移动通信等行业精英，自主研发兼容4G/5G通信网络的智能巡检无人机飞控系统，打造无人机多机管理运营平台，致力于将人工智能等先进技术部署到巡检类无人机的行业应用，服务于基站巡检、道路监控、电力消防、地质灾害、公共治安等垂直领域客户。

  狮尾智能愿景是用心联接空间，创造极致飞行。`,
  img: true,
  desc: ``,
  city: '上海',
  field: '无人机',
  scale: '20-99人',
  financing: 'A轮',
  tags: ["五险一金", "定期体检", "股票期权", "公积金", "带薪年假", "员工旅游", "通讯补贴"],
  web: '',
  jds: [
    {
      name: '无人机飞控高级工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `岗位职责：
        1.负责飞控系统与飞行平台集成，相关软硬件的调试及二次开发，支持应用软件设计；
        2.负责无人机项目方案的软件设计和系统研发，以及无人机飞行控制算法及嵌入式飞行器控制系统开发；
        3.负责飞控和导航算法相关的模型分析、算法设计、功能开发，并编写算法设计各阶段的相关文档；
        4.负责开发无人机飞控系统以及地面站软件。 
        职位要求：
        1.计算机科学、电子信息或航空类相关专业，本科以上学历； 
        2.熟悉飞行器控制系统设计；丰富的C/C++语言和汇编语言开发经验； 
        3.熟悉飞行器常用控制设备与传感器； 
        4.熟悉基于单片机、ARM或DSP等平台的嵌入式应用程序开发；
        5.熟悉APM，PX4，等飞控算法者优先使用；
        6.良好的英语读写能力；有良好的文档和编码习惯； 
        7.具有3年以上飞控开发工作经验算法；
        8.熟悉无人直升机相关飞控知识。`
    }, {
      name: '无人机软件工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `岗位要求：
        1. 本科及以上学历，计算机、自动化、电子、数学、物理等相关专业
        2. 精通C++编程语言，有C++开发经验
        3. 对软件架构有深刻的理解，有良好的代码规范
        4. 对飞行器有一定的项目经验，有一定钻研解决问题的能力
        5. 熟悉嵌入式RTOS系统、自动控制、飞行器原理的优先
        6. 熟悉Qt界面的开发
        7. 熟悉Mission Planner, QGC等地面站开发的优先
        工作职责：
        1. 负责无人机控制系统的代码编写
        2. 负责无人机控制系统的软件接口定义和硬件驱动开发
        3. 根据产品功能需求设计并完成软件实现
        4. 负责无人机地面站系统的开发`
    }, {
      name: '无人机硬件工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `岗位要求：
        1. 根据原型设计或产品方案，从事原理图设计、PCB布局，板级性能测试
        2. 协同软件及结构同事进行系统联合调试工作
        3. 项目的硬件模块选型，供应商沟通和管理
        工作职责：
        1. 通信电子及相关专业本科或以上学历，有2年以上硬件开发经验
        2. 有复杂高速系统的研发经验，例如X86主板电路、手机基带电路、基站电路等 
        3. 熟悉电子电路设计和测试方法及Debug能力（系统的SI/PI、ESD、 EMC…） 
        4. 熟悉硬件测试的各种仪器及相关的硬件设计工具
        5. 精通终端产品各模块（WIFI, camera, RF module等）的原理和关键器件选型、应用
        6. 有较强的动手能力和沟通能力，能对供应商进行很好的管理和沟通合作
        7. 良好的工作态度和团队合作精神，有责任心、上进心
        8. 有无人机开发经验、项目管理经验优先`
    }, {
      name: '激光点云算法工程师',
      salary: '面议',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `岗位要求：
        1. 根据原型设计或产品方案，从事原理图设计、PCB布局，板级性能测试
        2. 协同软件及结构同事进行系统联合调试工作
        3. 项目的硬件模块选型，供应商沟通和管理
        工作职责：
        1. 通信电子及相关专业本科或以上学历，有2年以上硬件开发经验
        2. 有复杂高速系统的研发经验，例如X86主板电路、手机基带电路、基站电路等 
        3. 熟悉电子电路设计和测试方法及Debug能力（系统的SI/PI、ESD、 EMC…） 
        4. 熟悉硬件测试的各种仪器及相关的硬件设计工具
        5. 精通终端产品各模块（WIFI, camera, RF module等）的原理和关键器件选型、应用
        6. 有较强的动手能力和沟通能力，能对供应商进行很好的管理和沟通合作
        7. 良好的工作态度和团队合作精神，有责任心、上进心
        8. 有无人机开发经验、项目管理经验优先`
    },  {
      name: '无人高级系统工程师',
      salary: '面议',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `岗位要求：
        1. 3年以上电子工程经验;
        2. 电子工程专业硕士或相关专业（拥有多学科综合工作经验可加分）; 
        3. 有模拟系统和数码设计的经验;
        4. 掌握沟通协议的知识;
        5. 具有传感器经验;
        6. 拥有驱动，马达和控制器的知识;
        7. 拥有定位系统的知识;
        8. 做事积极，细致，善于沟通
        工作职责：
        1. 设计发展机器的电子设计; 
        2. 迅速有效地更新技术;
        3. 参与新一代硬件的设计; 
        4, 设计测试工作装备以便展开大规模生产;
        5. 熟悉硬体电路设计;
        6. 参与设计工作，尤其是技术可行性研究;
        7. 编程理论知识扎实（侧重于微控器和终端使用者开发方向）;
        8. Linux运行系统知识扎实。`
    },
  ]
},
{
  name: '高仙机器人',
  intro: `高仙是一种高度，不求显达，但求无双。
  “高仙机器人”自2013年成立以来，一直致力于全栈全场景AI技术的研究，是全球最早从事自主移动技术研发和应用探索的机器人公司之一。高仙以“让服务机器人遍布世界每个角落”为目标，将220项专利申请融入清洁机器人领域，以6大产品线7个核心模块服务全球30多个国家和地区的客户，总运行里程超过1亿公里，成为商用移动机器人和无人驾驶领域市场落地能力最卓越的科技实业型企业。所以在清洁机器人这条赛道上，高仙是一种气度，不争先，却事事在先。

  高仙是一种广度，诞生于无华，深藏于远见。
  高仙将“人才战略”和研发、生产、销售一起融入自己的基因。高仙的科学家团队来自于清华、剑桥、新加坡国立大学等诸多名校，他们有思想、有智慧并且有趣，是高仙探索未知的动力。我们在上海、北京、苏州三城的研发中心源源不断的为机器人注入智慧和技能，张家港生产基地为机器人锻造身体，遍布亚洲、北美和欧洲的销售工程师集群正在让商用清洁机器人进入各种应用场景。所以，高仙也是一种信念，我们已经习惯了用不凡之志去丈量生命。

  和高仙一起俯瞰未知高度，是一种体验胜利的感觉。
  所以我们邀请你加入这场聚会，看着我们自己家的机器人遍布全球。从伦敦到阿联酋、从卡塔尔到赫尔辛基，从巴黎到墨尔本，从新加坡到伊斯坦布尔……不管是地铁还是商场，不管是机场还是医院，看着自己的“娃”在不同的空间里奔跑，肯定是一种让人崇尚的乐趣。`,
  img: true,
  desc: `改变传统服务行业，缔造智慧服务新时代。`,
  city: '上海/北京',
  field: '服务机器人、无人驾驶',
  scale: '300人-500人',
  financing: 'B轮',
  tags: ["五险一金", "定期体检", "年终奖", "带薪年假", "免费班车", "交通补助", "节日福利", "零食下午茶"],
  web: '',
  jds: [
    {
      name: '机器人软件开发架构师',
      salary: '25-40K 14薪',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `工作内容:
        根据客户需求和不同的硬件平台，结合算法团队输出，设计高可用的软件架构，实现相关业务功能，保证机器人和无人驾驶产品的长期稳定运行；具体工作内容包括但不限于架构设计、业务落地、性能优化、质量改善、团队管理等；
        职位要求:
        1. 本科以上学历，计算机、软件工程等相关专业
        2. 优秀的工程能力和解决问题的能力
        3. 熟练掌握C++及STL，熟悉常用的数据结构、算法
        4. 熟悉Linux编程，了解操作系统的基本原理
        5. 熟悉面向对象基本思想、了解常用设计模式
        6. 善于编写可靠的高质量代码，善于编写内容丰富的文档
        7. 工作细致，思维严谨，具有良好的表达能力、团队合作能力，具有较强的抗压能力
        8. 加分项
        1) 熟悉ROS/百度Apollo框架
        2) 有超强的软件工程、架构能力/解决问题的能力
        3) 对Linux系统的各个方面有深刻的认知和实战经验
        4) 有一定的技术团队/项目管理经验`
    }, {
      name: '传感器算法工程师',
      salary: '15-30K 14薪',
      type: '社招',
      edu: '硕士',
      city: '上海',
      content: `职位描述：
        1、参与新型传感器/摄像头/激光雷达等的创新研发和预研；
        2、针对适配的模组方案主导设计软硬件一体化方案以及数据和算法层面的迭代优化工作。
        任职要求：
        1、本科及以上学历（硕士优先），光学、机电、电子、电路、通信等相关专业，对硬件结构、光学、电子、软件等领域至少精通一项，其它几项要有较深的认知；
        2、有传感器/摄像头/激光雷达等实习经验或合作项目经验；
        3、了解常用传感器的工作原理和信号处理算法，例如IMU，雷达，超声，红外等 ；
        4、熟悉物联网常用网络通讯协议，例如WiFi, BLE, 802.15.4, NFC, RFID等；
        5、能熟练阅读英文技术文档和专业文献。`
    }, {
      name: 'SLAM算法工程师',
      salary: '22-40K 14薪',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `岗位职责：
        1、负责机器人通用平台机器人相关算法的研究与开发；
        2、负责机器人前沿科技相关算法的研究与开发。
        任职要求：
        1、硕士及以上学历，计算机相关专业毕业；
        2、熟悉数据结构，操作系统，计算机原理；
        3、对数理逻辑算法有浓厚的兴趣，逻辑思维清晰严谨；
        4、对机器人相关算法有较深的理解和认识，对机器视觉，SLAM，Machine Learning 相关领域有深入的研究；
        5、具备扎实的 C++语言基础和相关计算机语言编程能力优先；
        6、熟悉机器人定位导航 SLAM 算法优先。
        必备知识经验技能：
        1、具备C++工程能力；
        2、熟悉图像处理、特征点提取匹配、数值优化、C++或Python、计算机视觉几何等技能。
        优先项：
        1、具备扎实的 C++语言基础和相关计算机语言编程能力优先；
        2、熟悉机器人定位导航 SLAM 算法优先。`
    }, {
      name: '嵌入式软件工程师',
      salary: '15-30K 14薪',
      type: '社招',
      edu: '本科',
      city: '上海',
      content: `岗位职责：
        1、根据嵌入式软件系统的需求，独立完成嵌入式软件系统及模块的编码与测试；
        2、负责嵌入式软件系统的功能调试、集成测试工作，编写相关的测试方案及用例；
        3、按项目管理规范的要求编制、整理、提交相关的技术开发文档；
        4、负责相关文档的整理、编写和提供，以确保相关产品说明的正确性和可读性；
        5、积极完成部门其它工作事项及任务安排。
        任职要求：
        1、全日制统招本科及以上学历　计算机、电子、通信类相关专业；
        2、精通RTOS系统及其基本原理，对嵌入式软件有较深的理解；
        3、熟悉STM32单片机开发，熟悉I2C、SPI、UART、RS485、CAN等总线程序的开发；
        4、能看懂电路图、会使用万用表，示波器等仪器，分析解决硬件不良原因；
        5、有较强的分析和解决问题的能力，能承受一定强度的工作压力，认真负责、有良好的团队协作精神。
        必备知识经验技能：
        Stm32单片机开发；
        12C、SPI、UART、RS485、CAN等总线程序开发；
        能看懂电路图、会使用万用表，示波器等仪器。`
    }, {
      name: '感知算法工程师',
      salary: '25-40K 14薪',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `岗位职责：
        负责机器人感知算法研发和部署，实现机器人在结构化场景和复杂非结构化场景中的感知能力。
        任职要求：
        1、自动化、电子工程、计算机科学或相关专业硕士及以上学历，拥有机器人、汽车或相关行业经验；
        2、熟悉 Linux 知识及 Linux 系统开发，拥有 Linux 平台上优秀的 C/C++开发技能与经验；
        3、拥有仿真环境的经验，在传感器融合、概率感知、目标跟踪、机器人计算机视觉等领域拥有至少一个优秀的知识和经验；
        4、具备以下核心技能的一种或多种：毫米波雷达信号处理、激光雷达信号处理、图像处理、传感器信息融合算法、传感器标定、模式识别、机器人系统工程等；
        5、善于分析和解决问题, 具备较好的沟通表达能力和团队合作精神。
        必备知识经验技能：
        1、具备C++工程能力；
        2、具备机器人学、模式识别知识。
        优先项：
        1、熟悉 ROS；
        2、具备较好的工程能力和工程经验；
        3、具有自主驾驶系统工程设计经验优先。`
    }, {
      name: '路径规划算法工程师',
      salary: '18-35K 14薪',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `岗位职责：
        1、将机器人自动驾驶算法、机器人控制算法等相关技术应用到实际产品中；
        2、对现有产品的性能和架构进行改进以及新技术的研究与应用。
        任职要求：
        1、全日制硕士及以上学历，计算机、控制、自动化等相关专业；
        2、熟练掌握 C++及 STL；
        3、熟悉 Linux 编程，了解操作系统的基本原理；
        4、熟悉面向对象基本思想、了解常用设计模式；
        5、善于编写可靠的高质量代码，善于编写内容丰富的文档；
        6、工作细致，思维严谨，具有良好的表达能力、团队合作能力，具有较强的抗压能力。
        必备知识经验技能：
        1、具备C++工程能力；
        2、熟悉Dijkstra、A*、D*、RRT、PID、DWA、MPC等算法。
        优先项：
        1、熟悉状态机设计，熟悉 ROS；
        2、有丰富的PnC算法经验；
        3、有非常好的工程能力和工程经验。`
    }, {
      name: '资深硬件工程师',
      salary: '15-25K 14薪',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `岗位职责：
        1、负责机器人部分产品设计和维护工作,包括硬件电路的设计，产品的安规设计及验证及生产问题的解决和处理；
        2. 负责项目元器件选型、测试板的焊接、调试优化等工作；
        3. 完成各种文档和标准化资料的编写工作；
        4. 有较好的数字电路、模拟化电路等系统知识，熟悉PCB绘制，硬件语言编程、产品故障排查、分析等。
        任职要求：
        1、熟悉硬件研发基本流程，精通精通Cadence、CAM350绘图工具及相关开发软件；
        2、精通STM32、ARM等处理器的开发流程和方法，具有至少2款类似产品的开发调试经验；
        3、有一定的嵌入式调试能力，比如单片机程序设计调试经验实际经验；有电源设计能力和调试经验者优先考虑；
        4、有足够的动手能力，比如焊接器件，常用电子学仪器使用经验等，较强的电路原理图设计和电路调试经验；
        5、具有良好的团队沟通和协作能力，适应公司的工作文化和较强的执行力；
        6、CET-4及以上，熟练阅读各种芯片手册文档。`
    }
  ]
},
{
  name: '纵目科技',
  intro: `纵目科技(上海)股份有限公司成立于2013年1月，总部位于上海浦东张江高科技园区，另有北京、厦门研发中心，在上海和厦门拥有前装体系标准工厂。公司以技术创新为原点，致力于满足汽车前装厂商和后装消费者快速增长的车辆主动安全和智能辅助驾驶的需求，打造基于中国面向全球的世界一流汽车先进驾驶辅助系统（ADAS），并通过和国际主流车规芯片原厂的深度合作开发，以及和高校学术界的共同合作，以低成本、可量产的方案推动低速自动驾驶的场景落地。

  企业拥有强大的技术和研发人才优势。企业创始人及主要技术团队成员都具有在汽车电子行业10年以上的相关技术研发经历，曾担任欧美知名汽车电子半导体企业的技术研发团队负责人，在芯片底层技术，计算机视觉、导航、蓝牙、图形处理和多媒体等多个方面，拥有从算法到系统设计的丰富经验。目前公司70%以上成员具有研究生以上学历，已经拥有多项软件著作权和发明专利。同时，公司有着遍及国内各区域的业务合作网络，保证用户可以充分享用业界的最新技术成果，从而在市场竞争中获得成功。企业的先进技术可以直接为汽车原厂采购使用，亦可和汽车厂商的一级供应商或者方案商合作，将本公司方案集成于其产品和方案中。

  我们相信，ADAS系统将是未来汽车产业发展的一大趋势。我们目前已经成为中国最领先的环视ADAS解决方案供应商之一，能够提供最全面的环视ADAS功能。同时，公司与国内外顶尖高校实验室正在积极研发面向中国市场的自动驾驶平台。未来，我们将继续基于多传感器的融合技术，向中国最好的具有自主知识产权的自动驾驶方案供应商的目标迈进。

  纵目科技AVP（Autonomous Valet Parking）自主泊车系统，通过室内室外高精定位、室内室外导航、车位搜索、自动停车、L4低速自动驾驶等核心技术，帮助用户解决出行难题，实现了在室内室外停车场、园区的自动驾驶、寻找车位停车、远程接驾等功能。

  纵目愿景——安全驾驶，智慧生活
  纵目使命——成为基于中国面向世界的从辅助驾驶到自动驾驶的技术引领者
  纵目核心价值观——持续创新，品质第一，客户至上，团队合作

  `,
  img: true,
  desc: `安全驾驶，智慧生活`,
  city: '上海',
  field: '汽车生产',
  scale: '150-500人',
  financing: 'B轮',
  tags: ["补充公积金", "补充医疗保险", "五险一金", "绩效奖金", "年终奖金", "免费班车", "员工旅游", "定期体检", "扁平化管理"],
  web: '',
  enroll: 'https://docs.qq.com/doc/DUUd1WGtHRUpuUGtY',
  jds: [
    {
      name: 'ADAS算法/图像处理工程师 ',
      city: '上海',
      salary: '14-30K',
      type: '社招',
      edu: '本科',
      content: `工作内容：
        1、优化图像输入和输出质量保证adas系统的性能要求
        2、针对特定图像算法的优化和移植
        3、开创新的adas算法
        岗位要求：
        1、计算机或通信等相关专业本科及以上学历，2年及以上C/C++编程经验，有扎实的图像处理基础
        2、精通多种图像预处理和后处理的方法和原理
        3、熟悉常用DSP和ARM编程优化方法
        4、熟悉常用的摄像头输入和视频输出接口
        5、有计算机视觉和图像识别经验者优先`
    }, {
      name: '高级应用开发工程师',
      city: '上海',
      salary: '24-45K 15薪',
      type: '社招',
      edu: '本科',
      content: `工作职责:
        1、负责自动驾驶嵌入式平台的系统软件架构设计；
        2、负责自动驾驶相关的算法模块的集成和验证；
        3、负责自动驾驶嵌入式平台的调试和debug 工作；
        4、支持客户项目开发；
        5、支持演示项目的开发。
        任职资格:
        1、本科及以上学历，理工科专业优先，5年及以上相关开发经验；
        2、熟悉Linux kernel或应用开发，熟悉开源软件的评估、集成与调试；
        3、精通C/C++，熟悉Linux系统的进程、线程开发，各类IPC通讯及socket编程；
        4、熟练的使用GDB，精通linux 应用程序的异常和内存泄露的问题分析；
        5. 有应用程序软件框架设计的经验，精通OOP, 熟练掌握设计模式；
        6、具有良好的团队合作意识、沟通能力、协调能力，能够承担工作压力。`
    }, {
      name: '高精度地图导航研发工程师',
      city: '上海',
      salary: '18-35K 15薪',
      type: '社招',
      edu: '本科',
      content: `工作职责:
        1、参与自动驾驶嵌入式平台高精地图的渲染规划搜索引擎和算法的设计、实现，支持酷炫好看的3D高精地图渲染，支持在线实时更新，支持多种自动驾驶车载嵌入式平台，并提供统一的SDK接口以供用户使用；
        2、高精度地图数据处理与自动化的平台软件系统的研发；
        3、高精地图引擎在不同芯片不同操作系统平台上的集成和调试；
        4、LBS位置服务的系统研发。
        任职资格:
        1、本科及以上学历，计算机、软件或地理信息（GIS）相关专业；
        2、熟练掌握C++语言，具备扎实的基本功和良好的编程习惯；
        3、对java、postgresql数据库/SQL、python或bash脚本语言有相关了解和经验加分；
        4、有3D渲染、OpenGL等有相关项目经验加分；
        5、有开源项目的参与经验加分；
        6、有地图渲染、导航、路径规划、搜索相关数据结构和算法有了解加分；
        7、有Linux应用和项目开发经验或ROS相关经验加分；
        8、具备优秀的逻辑思维能力，对解决挑战性问题充满热情，能够承受一定的工作压力，善于分析问题和解决问题。`
    }, {
      name: '毫米波雷达感知算法工程师',
      city: '上海',
      salary: '25-35K',
      type: '社招',
      edu: '本科',
      content: `工作职责:
        1.目标跟踪与聚类算法开发
        2.确定算法的评估标准和检测方法，测试和优化雷达感知层性能。
        3.与上层算法结合，进行多传感器融合算法的开发
        任职资格:
        1.本科及以上学历，电子相关专业，2年或以上工作经验
        2.有雷达感知（Perception）算法开发经验，熟练并掌握Matlab。
        3.有嵌入式实时软件的设计开发经验，能够熟练使用C或C++语言进行嵌入式编程
        4.有较强的创新能力和团队合作精神`
    }, {
      name: '毫米波雷达信号处理算法工程师',
      city: '上海',
      salary: '15-25K 15薪',
      type: '校招/社招',
      edu: '本科',
      content: `工作内容：
        1.雷达DSP检测算法设计与实现；
        2.系统地建立雷达算法仿真系统，进行算法优化；
        3.确定算法的评估标准和检测方法，测试和优化雷达系统检测性能；
        4.与上层算法结合，进行多传感器融合算法的开发。
        任职资格：
        1.硕士及以上学历，电子相关专业；
        2.熟悉Matlab开发工具，C/C++编程；
        3.熟悉微波雷达发射、接收、信号处理；
        4.BSD/LCDA等相关开发经验者优先；`
    }, {
      name: 'SLAM算法工程师',
      city: '上海',
      salary: '20-40K 15薪',
      type: '校招/社招',
      edu: '硕士',
      content: `工作职责：
        1. 负责研究SLAM、多传感器融合、地图构建以及定位等算法；
        2. 负责算法在嵌入式平台的实现、优化以及产品化；
        任职资格：
        1. 硕士及以上学历，有相关工作经验
        2. 熟悉EKF、粒子滤波、g2o、BA等算法；
        3. 扎实的数学功底，精通线性代数、概率论、微积分；
        4. 具有良好的英文听说读写沟通能力，学习能力强，求知欲强烈；
        5. 具有良好的团队合作意识、沟通能力、协调能力，能够承担工作压力；
        6. 精通C++、Matlab或者Python；`
    }, {
      name: '毫米波雷达功能开发工程师',
      city: '上海',
      salary: '25-30K',
      type: '社招',
      edu: '本科',
      content: `工作职责: 
        1.使用多传感器融合后的数据进行场景分析
        2.雷达功能开发如BSD/LCA/RTCA
        3.确定功能算法的评估标准和测试方法，测试和优化雷达系统功能的性能。
        任职资格:
        1.本科及以上学历，电子相关专业，至少3年以上工作经验
        2.有雷达功能开发经验，熟悉车辆控制，熟练并掌握Matlab。
        3.有嵌入式实时软件的设计开发经验，能够熟练使用C或C++语言进行嵌入式编程
        4.有较强的创新能力和团队合作精神`
    }, {
      name: '嵌入式软件工程师',
      city: '北京',
      salary: '20-40K 15薪',
      type: '社招',
      edu: '本科',
      content: `工作内容：
        1、载平台开发板的bringup和系统移植
        2、嵌入式系统平台相关的bsp和驱动程序移植和开发
        3、嵌入式系统平台中间层程序的开发
        4、配合算法工程师进行算法集成工作
        岗位要求：
        1、两年以上在嵌入式Linux上的c++/c编程经验
        2、计算机或通信领域相关专业研究生学历
        3、踏实，具有良好的沟通能力和团队精神
        4、具有良好的英文读写沟通能力
        5、ARM处理器架构，一定的硬件知识基础`
    }
  ]
},
{
  name: '快仓智能科技',
  intro: `快仓以成为智能仓储机器人领导者为己任，致力于实现四面墙内智能驾驶-让人类不再搬运，为用户提供高效柔性的智能机器人系统解决方案-智能拣选、智能分拣、智能搬运。公司自主研发的智能机器拥有多项核心专利，产品性能达到国际一流水平。目前公司为菜鸟、邮政、唯品会、百世物流、国药、国电等重量级客户提供了综合解决方案，同时与国内外知名系统集成商开展了多个智能系统集成项目，取得了良好的行业口碑。
  快仓以技术驱动，研发团队均来自国内知名高校的博/硕士组成。`,
  img: true,
  desc: `四面墙内智能驾驶-让人类不再搬运`,
  city: '上海',
  field: '工业机器人、智能仓储、人工智能',
  scale: '300人以上',
  financing: 'C轮',
  tags: ['弹性工作', '股票期权', '扁平化管理'],
  web: 'http://www.flashhold.com/',
  jds: [
    {
      name: '高级SLAM算法工程师',
      salary: '20-40K',
      type: '校招/社招',
      edu: '硕士及以上',
      city: '上海',
      content: `岗位职责：
        1、研究和开发机器人在未知环境中的地图构建算法以及自主定位算法
        2、研究和开发基于视觉、超声波、里程计等多传感器融合的室内场景感知与建模算法
        3、将开发SLAM算法应用到搭载快仓智能驾驶平台的设备上
        4、评测SLAM算法，并提出相关优化指标的改进方案
        能力要求：
        1、基础知识要求：掌握SLAM基础理论和算法，比如坐标系变换，空间向量表示、四元数等基础知识
        2、编程能力要求：熟练使用C/C++编程，包括STL、Boost、GLOG等常见的工具库
        3、平台要求：熟练使用ROS开发相关topic、service，了解ROS平台的实现原理，熟练使用ROS相关命令，如roslaunch、rosmsg、rostopic、rosrun等
        4、数值计算库：熟练掌握基于Eigen的数值计算实现方法，能够利用Eigen计算矩阵乘法、逆矩阵、矩阵特征值和特征向量等操作
        5、模型优化库：熟练掌握基于Ceres的模型优化实现方法
        6、操作系统要求：Linux/Ubuntu系统使用精熟，对常用命令了如执掌，比如ls、cat、grep、sort、vim、awk、sed等
        7、算法要求：EKF、粒子滤波、ICP、RANSAC
        8、项目要求：熟悉Cartographer开源项目的代码，了解Cartographer的代码结构，系统设计架构，熟读Google对于Cartographer项目的算法介绍论文
        9、专业要求：计算机、自动化、数学、通讯、机电、电气、测控
        10、学历要求：硕士以上学历
        11、数学知识要求：微积分、数值计算、优化理论
        加分项：
        1、代码量：历史代码量超过10w行以上
        2、开源协作经验：拥有Github开源项目开发经验
        3、学术能力：曾经在计算机视觉或机器人相关领域发表论文
        4、开源项目：非常了解Gmapping开源项目，精读过相关代码
        5、点云处理：熟练掌握基于PCL库的点云处理实现
        6、行业经验：从事过自动驾驶、无人驾驶行业`
    }, {
      name: '资深SLAM导航算法工程师',
      salary: '20-40K',
      type: '校招/社招',
      edu: '硕士及以上',
      city: '上海',
      content: `工作职责：
        1. 负责激光SLAM导航、视觉SLAM导航等算法研发
        2. 负责相关部署工具、软件的开发；负责项目交付和技术支持
        3. 负责算法执行效率优化和精化
        4. 负责相关开发的文档撰写和归档
        岗位要求：
        1. 硕士及以上学历，计算机、自动化、机械电子工程等相关专业，三年以上相关工作经验；
        2. 有过至少1个激光、视觉SLAM移动机器人产品或项目开发、交付经验；
        3. 精通OpenCV, Matlab, C/C++，ROS等开发语言和平台；
        4. 精通Cartographer、Gmapping等主流SLAM导航技术；
        5. 有过用独立算法开发激光导航算法者尤佳
        6. 对行业主流产品、算法和技术进展有较深认识
        加分项：
        在计算机视觉、模式识别、自动驾驶、SLAM导航相关领域发表过高质量论文，例如：CVPR、ICCV、ECCV、NIPS等。`
    }
  ]
},
{
  name: '酷哇机器人',
  intro: `酷哇机器人（COWAROBOT）是国内无人驾驶领域的新锐企业，专注于低速动态场景下无人驾驶技术；公司服务于行业龙头，专注在垂直行业场景，用移动AI赋能行业。核心团队成员均来自于CMU、上海交大、百度等，创始人何弢曾师从机器人大师Hirose Shigeo，是特征驱动全局定位理论的提出者，资深无人驾驶技术专家；首席科学家为国际人工智能先驱， ETH人工智能实验室原主任Rolf Pfeifer；并且，公司得到CMU的战略支持，双方在无人驾驶的感知算法上展开联合研发。酷哇机器人自主研发的低速无人驾驶系统CO-MOVE PRO已经成功应用并布局于智慧环卫、物流等行业。目前与中联环境等多家环卫龙头合作，是首个实现无人路扫车真正产品化和商业化的企业；与埃夫特机器人等多家国内物流、工业机器人行业龙头合作并开发无人物流车。`,
  img: true,
  desc: `利用智能驾驶技术服务城市的毛细血管，打造未来出行场景`,
  city: '上海',
  field: '无人驾驶',
  scale: '100-499人',
  financing: 'B轮',
  tags: ["五险一金", "员工旅游", "带薪年假", "通讯补贴", "节日福利", "零食下午茶", "差补"],
  web: '',
  jds: [
    {
      name: 'SLAM工程师',
      salary: '20-40K',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `工作内容：
      工作内容：
      1. 研究并开发基于多种传感器融合的6DOF localization与精准3D mapping；
      2. 负责滤波方法实现传感融合；
      3. 将开发的新算法应用到新一代计算平台与智能机器人设备；
      职位要求：
      1. 具有增强现实、虚拟现实、计算机视觉、图形学、机器人等相关专业在读硕士及以上学历；
      2. 精通Pose Graph Based SLAM方法，熟悉立体视觉常用知识和算法；
      3. 掌握计算机视觉基础理论和算法，熟悉机器学习特别是图像、物体检索相关技术；
      4. 精通C/C++编程，熟悉Linux/PCL。
      5. 有计算优化经验优先考虑。`
    }, {
      name: '图像算法工程师',
      salary: '25-50K',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `岗位职责：
        1.负责自动驾驶系统中基于视觉的目标检测与跟踪；
        2.目标行为分析及预测（车辆、行人行为分析预测，姿态估计等）；
        3.进行场景的优化；
        4、负责已有视觉算法的优化和改进；
        技能要求：
        1.硕士及以上学历(优秀的本科学历者也可)；熟悉C、C++、Matlab
        2.数学基础好，掌握图像处理，模式识别的相关基础知识；
        3.有基于OpenCV开发项目经验者优先；有目标识别、图像配准、三 维测量、标定和重建方面经验者优先；
        4.具有良好的团队合作能力及英文文献阅读能力。
        5.有深度学习应用成功项目案例经验者优先。`
    }, {
      name: '规划算法工程师',
      salary: '15-30K',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `工作职责: 
        1、负责基于多传感器融合感知，定位数据，车辆模型及决策结果，进行自动驾驶轨迹规划算法的实现；
        2、负责自动驾驶轨迹规划领域先进算法的调研与实现；
        3、负责进行全路段（适配特殊场景）路径及速度规划算法的开发、调试和测试。
        任职资格: 
        1、具有自动驾驶车辆或机器人路径规划开发经验；
        2、熟悉车辆运动学或机器人运动学，对车辆控制理论有一定了解；
        3、熟悉C/C++，Linux，具有ROS相关机器人系统的设计开发经验；
        4、具备良好的逻辑沟通能力，解决实际问题的能力及团队合作意识。`
    }, {
      name: '决策算法工程师',
      salary: '15-30K',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `工作职责:
        1、负责基于感知，定位及高精度地图数据，进行自动驾驶决策算法的实现；
        2、负责自动驾驶决策领域先进算法的调研与实现；
        3、负责在适配交通规则和特殊场景的前提下，进行全路段决策算法的开发、调试和测试。
        任职资格:
        1、具有自动驾驶车辆或机器人决策领域相关开发经验；
        2、熟悉常用决策模型，如决策树，MDP等；
        3、熟悉C/C++，Linux，具有ROS相关机器人系统的设计开发经验；
        4、具备良好的逻辑沟通能力，解决实际问题的能力及团队合作意识。`
    }, {
      name: '嵌入式开发工程师',
      salary: '13-25K',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `工作职责：
        1、负责可编程设备(CPU)端的软件设计、功能实现及测试工作；
        2、参与Linux端的部分适配可编程设备的工具软件设计及编码；
        3、完善软件相关文档，包括设计说明、操作说明以及软件说明；
        4、协同电子硬件团队完成产品相关调试工作，协同产品开发或项目团队完成相关技术支持工作。
        任职资格：
        1、本科以上学历，电子、计算机、自动化等相关专业毕业；
        2、熟悉计算机原理，拥有扎实的C语言基础，有良好的编程素养，两年以上的编码经验；
        3、有一定的硬件基础，能看懂原理图接口，熟悉SPI，CAN，UART、定时器等常用的硬件外设；
        4、熟悉Python或Shell脚本语言优先；熟悉stm32及相机接口优先。`
    }, {
      name: '控制算法工程师',
      salary: '15-30K',
      type: '校招/社招',
      edu: '本科',
      city: '上海',
      content: `工作职责: 
        1.负责无人车运动规划与底盘控制的开发；
        2.参与无人车项目的控制、仿真、测试、分析及评价等相关工作；
        3.配合完成无人车自主驾驶系统的集成与测试；
        4.配合完成无人车全系统的外场调试。
        任职资格:
        1、计算机、自动化、机器人相关专业优先；
        2、有相关项目经验优先；
        3、专业基础扎实，熟悉掌握C、C++、python等语言，熟悉ROS开发，熟悉PID算法/AGV机器人底盘控制；
        4、熟悉自动控制原理；
        5、熟悉机器人运动规划与运动控制算法。`
    },
  ]
},
{
  name: '非夕机器人',
  intro: `你想要成为精英团队的一员，以前沿科技改变世界吗？

  秉承“研发和应用以人为本的机器人技术，实现对枯燥、令人劳累或损害健康的工作的自动化，同时创造更多有趣、有价值的机会”的组织愿景，非夕科技致力于打造第三代自适应智能机器人，为制造业和服务业提供智能柔性的自动化解决方案。

  非夕科技（Flexiv Ltd.）是一家全球技术领先的AI机器人公司，于2016年成立于硅谷，创始人团队均来自斯坦福大学机器人和人工智能实验室。非夕专注于研发、生产集高精度力控、计算机视觉和人工智能技术于一体的自适应机器人产品，为不同行业的客户提供基于非夕机器人系统的整体、创新性的解决方案和服务。在***风投的支持下，公司2年内完成1.5亿人民币的融资，参与投资的有：金沙江创投、高榕资本、真格基金、MFund、顺为资本等。非夕的首个自适应机器人产品拂晓（Rizon）分别于2019年4月份在德国汉诺威工业展和2019年9月在上海国际工业博览会上进行了产品发布，均引起了业内的广泛关注。

  除了在硅谷、上海、北京、深圳和佛山设有分支办公室。非夕已经建立起生产基地、物流枢纽中心及各种职能中心以确保企业的全速发展，从而更好地指向在4万亿工业自动化市场上占据重要地一席之地这个目标。

  我们想要寻找乐于接受挑战、在其专业领域能力突出、能与公司一同成长的卓越人才。在追求共同目标的同时，我们的企业文化对员工的个性化包容且支持。我们提供具有市场竞争力的薪酬福利待遇，同时，也希望能在我们的产品上留下您智慧的印记。

  你准备好了吗？现在就行动申请我们的职位吧！`,
  img: true,
  desc: ``,
  city: '上海',
  field: '机器人/人工智能/智能制造',
  scale: '100-499人',
  financing: 'B轮',
  tags: ["五险一金", "定期体检", "带薪年假", "员工旅游", "零食下午茶"],
  web: '',
  jds: [
    {
      name: 'AI应用工程师',
      salary: '20-40K 13薪',
      type: '社招',
      edu: '硕士',
      city: '上海',
      content: `工作职责：
        1. 深入分析公司各AI相关业务线，能够深入理解业务场景和关键需求；
        2. 负责AI相关项目的业务逻辑设计和实现开发工作，完成产品与需求的对接；
        3. 关注AI应用技术的发展，搭建基础工具链，进行代码优化与重构；
        4. 负责对项目组技术人员进行技术培训，负责整理和组织编写AI应用开发相关使用规范。
        任职要求: 
        1. 熟悉Linux操作系统，熟悉 Python ／C++／Bash开发，有扎实的编程功底；
        2. 熟悉工业相机选型，标定，传统图像处理等方法。
        3. 熟悉OpenCV/PCL/Open3D等视觉开源库
        4. 了解机器学习基础算法，计算机视觉和深度学习相关算法；
        优先录用：
        1. 熟悉工业场景2D/3D数据下的配准、识别、缺陷检测等。
        2. 对RGBD传感器有使用经验；
        3. 有完整工业AI项目的经验。
        4. 有过大型工业视觉系统开发的经验`
    }, {
      name: 'SLAM工程师',
      salary: '15-30K',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `职位描述：
        1. 与机器人工程师、计算机视觉工程师、机械工程师、测试工程师密切协作，开发计算机视觉应用；
        2. 使用C或C++在桌面系统或嵌入式平台上设计、实现、测试机器人/视觉算法。
        职位要求：
        1. 硕士及以上学历，计算机科学或机器人科学等相关专业；
        2. 具备丰富的在机器人平台上开发和部署SLAM算法的经验；
        3. 了解RGBD-SLAM，Vision-based SLAM, 点云的配准和定位技术；
        4. 熟悉计算机视觉算法开发；
        5. 熟悉使用C++进行实时系统软件开发，并且拥有丰富的调试经验；
        6. 熟悉商业软件开发过程：有良好的代码书写、注释、除错追踪、单元测试, 版本管理;
        7. 熟悉Opencv, PCL;
        8. 熟悉Linux系统；
        9. 熟悉Git；
        10. 熟悉CMake;
        加分项：
        1. 熟悉使用集成管理工具（如Jenkins）;
        2. 熟悉使用脚本语言（如Python）;
        3. 熟悉机器人操作系统ROS；
        4. 熟悉NVIDIA TK1, TX1/TX2;
        5. 熟悉工业相机的使用；
        6. 对开源SLAM框架有过贡献，或参加相关项目，发表有关论文`
    }, {
      name: '机器人软件工程师',
      salary: '20-40K 13薪',
      type: '校招/社招',
      edu: '硕士',
      city: '上海',
      content: `工作职责：
        1. 将与机器人工程师、AI 工程师、机械工程师、测试工程师以及机器人密切协作；
        2. 负责软件架构、组件通信、系统功能的开发、测试、调试以及维护软件模块；
        3. 参与软件研发，并与机械、电气团队共同开发世界领先的产品。
        任职要求：
        1. 本科及以上学历，计算机、机器人、自动化相关专业；
        2. 熟悉商业软件开发流程：编写软件设计文档、单元测试、除错追踪、版本管理；
        3. 熟练掌握 C/C++，Python；
        4. 熟悉机器人系统、自动化平台相关的软件开发；
        5. 熟悉 Linux 系统，熟悉shell脚本；
        6. 熟悉实时操作系统，有实时操作系统的相关开发经验；
        7. 熟悉网络通信技术；
        8. 熟悉基本的设备通信技术与总线通信技术；
        9. 熟悉版本管理工具 Git；
        10. 熟悉 CMake，熟悉交叉编译。
        优先录用：
        1. 熟悉机器人软件框架（如 ROS，OROCOS）；
        2. 熟悉 DDS，OpenUA，CORBA，OpenRTM；
        3. 熟悉 ECAT，ProfiNET，EtherNet/IP；
        4. 熟悉 POSIX 标准开发
        5. 广泛了解机器人系统，包括但不限于机器人运动控制、电机控制、实时系统构建。`
    },
  ]
},
{
  name: '蓝芯科技',
  intro: `蓝芯科技主要研发移动平台感知和控制系统，及相关核心技术。提供移动平台感知和控制系统的软、硬件产品，及整体解决方案。让移动平台提供商，能基于我们的系统做出更加智能、功能更强大的产品。
  公司以计算机视觉为核心技术，利用人工智能技术赋予机器人深度视觉感知能力，让机器人“能行走，会做事，更会思考”。公司专注于电商仓储和智慧工厂物流两大应用领域，提供智能搬运机器人、智能移动拣货机器人、3D视觉传感器，用于提高作业效率的智能调度软件等国际领先的产品和解决方案。公司现已申请专利32项，其中发明专利16项，并已获得软件著作权7项`,
  img: true,
  desc: `让机器人“看懂”世界，服务世界！`,
  city: '杭州',
  field: '电商仓储、智慧工厂物流',
  scale: '20-99人',
  financing: '未披露',
  tags: ["弹性工作", "五险一金", "团队聚餐", "领导nice", "午餐补助", "带薪年假"],
  web: '',
  jds: [
    {"name":"机械结构设计主管","type":"社招","city":"杭州","content":"职责描述：\n1.参与产品（AGV机器人自动化设备）的需求方案论证和方案设计，制定结构设计方案；\n2.负责设计和改进产品的结构，解决产品结构设计开发阶段与量产阶段的重要问题；\n3.负责与工业设计工程师相互协商解决产品整体外观方面问题。负责与硬件及电子工程师协调解决产品layout和其他问题；\n4.带领机械设计组完成产品设计文件的编写与归档；\n5.负责公司产品整机结构件、工装等设计、跟产、装配等；\n6.负责外协加工的跟踪及技术问题处理；\n7.负责机械设计团队的日常工作管理\n任职要求：\n1.机械设计、机电一体化、模具制造，飞行器设计，汽车设计等相关专业，本科及以上学历，3年以上产品的设计工作经验；\n2.具备熟练的机械结构设计和外观设计知识，熟悉各种传动方式，熟练使用AutoCAD、ProE、UG、CATIA、Solidworks等绘图软件的操作及其他三维、二维设计软件；\n3.熟悉塑胶钣金及复合材料的材料特性，熟悉材料加工流程，尤其是机加工、模具，钣金成型，铸造流程；还有相关表面处理工艺、生产工艺。\n4.熟悉强度计算方法，能结构进行理论强度校核及有限元优化设计（强度、振动、疲劳）；\n5.熟悉从设计，分析，优化到跟产、装配全过程，熟悉常规机械加工工艺及产品装配工艺；编制产品相关的技术文件、生产文件及BOM表；\n6.熟悉相关国家、行业标准，有工业级产品的型式试验的经验者优先；\n7.有AGV、机器人、汽车、自动化设备行业结构设计经验者优先；\n8.工作认真负责，具有团队合作精神，具备良好的沟通及表达能力，有一定的管理经验。","salary":"15-30k","edu":"大专"},{"name":"深度学习算法专家/工程师","type":"社招","city":"杭州","content":"职责描述：\n1.有良好对数学技术，熟悉CNN等深度学习基本概念； 2.熟悉一种或多种如TensorFlow、Caffe等主流深度学习框架； 3.有较强动手能力和学习能力，有相关开发经验者优先； 4.有相关科研经验、发表过相关论文者优先。 岗位职责： 1.负责机器人视觉模块的训练和深度学习； 2.将深度学习模块优化和工程化。","salary":"20-40k","edu":"硕士"},{"name":"机器人电气工程师","type":"社招","city":"杭州","content":"职责描述：\n1、协助完成参与新产品、新项目前期的可行性分析；\n2、负责项目电气及配电原理图设计；\n3、设计柜内接线图；\n4、电气元件的选型；\n5、根据元器件供货周期，确定采购计划，对周期长元器件下单；\n6、参与工程评审，提供电气方面的建议；\n7、为机械设计及二维出图提供电气方面建议。\n任职资格：\n1、电气自动化、机电一体化或相关专业，全日制本科2年以上相关工作经验；\n2、熟悉电气原理知识；了解电气元器件、单片机、人机界面、伺服控制基础知识；熟悉电子文件标准化知识；了解机械传动原理；了解非标或自动化设备项目管理流程。","salary":"6-10k","edu":"本科"},{"name":"嵌入式硬件工程师","type":"社招","city":"杭州","content":"职责描述：\n1. 负责产品电气部分研发、整机功能调试；\n2. 负责原理图设计、PCB绘制、硬件调试等相关工作；\n3. 负责嵌入式代码开发和维护（单片机平台）。\n任职要求：\n1. 熟悉cotex-M系列单片机的使用和开发，有arm平台开发优先；\n2. 熟悉常用的硬件调试设备；\n3. 具备大型项目开发经验，嵌入式硬件相关工作2年以上；\n4. 熟悉常见的电机及控制系统，有智能移动机器人相关开发经验者优先；\n5. 能够熟练使用CC++进行项目开发；\n6. 能够使用至少一款layout工具软件，能够进行BOM输出、geber文件输出等制板相关要求；\n7. 了解EMC电磁兼容/干扰相关处理措施；\n8. 熟悉阅读技术手册等英文文档；\n9. 具备良好的团队意识，沟通协调能力，工作态度端正，能够承受较大工作压力","salary":"10-15k","edu":"本科"},{"name":"机器人产品硬件测试工程师","type":"社招","city":"杭州","content":"职责描述：\n1.分析产品需求，制定产品硬件测试方案和测试计划、并设计测试用例；\n2.熟练使用仪器仪表对于硬件相关的功能、性能、一致性、可靠性等方面测试；\n3.确认定位，解决测试问题，评估测试效果并撰写测试报告；\n4.针对整机生产测试需求，制定整机生产测试作业指导书，并根据具体测试内容，指导测试治具的设计工作及指导生产进行整机出厂测试。\n任职要求：\n1.机械自动化、电子、精密仪器相关专业，本科及以上学历；\n2.有2年以上硬件测试工作经验，熟悉测试流程和相关规范，有AGV或其他工业机器人产品测试经验为佳\n3.熟悉工业自动化产品测试相关流程，熟悉测试治具的设计者为佳 ； \n4.熟练掌握各种测试仪器，比如综测仪、数字示波器、逻辑分析仪，频谱仪等；\n5.对电路设计、可靠性测试、电磁兼容测试有比较深的认识；\n6.学习能力强，工作细心，具有高度的责任心和敬业精神，良好的沟通能力和团队合作精神。","salary":"8-16k","edu":"本科"},{"name":"产品总监","type":"社招","city":"杭州","content":"职责描述：\n1. 负责物流机器人的市场调研、需求分析、产品规划、功能设计等；\n2. 负责协助研发团队理解产品需求内容和交互使用；\n3. 全程跟进产品开发，协调组织设计、研发、测试、生产资源并推动产品按时推出以及产品的版本管理和持续优化；\n4. 负责产品发布后的数据分析、用户反馈收集等工作，持续完善和迭代优化；\n5. 分析竞争对手的产品策略，进行市场研究和分析，保证产品的竞争优势。\n\n任职要求：\n1. 熟悉各类型机器人的基本原理及功能；\n2. 本科以上学历,计算机或者机器人相关专业毕业；\n3. 3年以上机器人行业产品经验，有完整的机器人产品生命周期经验；\n4. 熟悉物流行业、产品、常见硬件方案，对产品有自己的认识；\n5. 具备较强的独立提案能力、项目理解能力、客户沟通能力、文档撰写能力，能够主动深入一线业务现场，根据特定的业务场景与业务方向进行产品或者方案的规划；\n6. 具有良好的职业道德素质，思维敏锐活跃，能吃苦耐劳，工作细心，责任感强；\n7. 创新意识强，具有开放的心态、良好的沟通能力和协作精神，性格开朗，做事积极主动；\n8. 很强的学习能力、动手能力、善于思考、以及快速的执行力和独立解决问题的能力。","salary":"8-16k","edu":"本科"},{"name":"应用驱动软件开发","type":"社招","city":"杭州","content":"职责描述：\n1、负责机器人底层通讯模块的开发；\n2、负责机器人新硬件适配。\n任职要求：\n1. 本科以上学历，，具备面向对象的软件设计能力；\n2. 熟悉Qt/Boost，有Linux开发经验者优先；\n3. 了解串口通讯原理，设计过串口协议者的优先；\n4. 良好的编码习惯，文档规范能力；\n5. 团队协作能力强，熟悉git/svn等版本管理软件；\n6. 掌握其它脚本语言者（python/lua/javascript）优先。","salary":"10-20k","edu":"本科"}
  ]
},
{
  name: '博智林机器人',
  intro: `广东博智林机器人有限公司（简称“博智林机器人”）作为碧桂园集团的全资子公司，成立于2018年7月，是以机器人本体及其核心零部件、相关的机器人核心技术，智能机器人系统的研发、智造、运营为业务内容的科技型公司。目前，博智林机器人开发研制中的产品主要为应用于建筑业、餐饮、物业管理、医疗、农业、智能家居、制造业等领域的机器人、智能设备及系统。
  立足智慧城市建设、智能家居服务等应用场景，博智林机器人以人工智能技术为平台，打造覆盖机器人全产业链的生态圈。
  在核心技术和零部件方面，博智林机器人将从伺服控制器、运动控制器等各类传感器的研发试产切入，进而扩展到减速机、马达和编码器的研发生产。在完成前期的技术积累之后，公司将基于已有的硬件技术，开展伺服控制系统、运动控制系统的研发和AI系统的开发。在形成完善的研发体系后，公司将专注于减速机、视觉传感器、力觉传感器、芯片和AI等重点核心技术领域。
  博智林机器人目前已规划两个技术研发平台，分别为智能技术研究院和智能制造事业部。智能技术研究院下设建筑机器人研究院、餐厅机器人研究所、智能制造研究所、医疗机器人研究院、人工智能研究院等研发部门。智能制造平台下设智能工厂和制造技术开发部门。
  `,
  img: true,
  desc: `做世界一流的机器人高科技企业`,
  city: '佛山',
  field: '机器人、人工智能',
  scale: '1000人以上',
  financing: '不融资',
  tags: ["年底双薪", "岗位晋升", "弹性工作", "绩效奖金", "带薪年假", "股票期权", "定期体检", "扁平化管理", "午餐补贴"],
  web: '',
  jds: [
    {
      name: '高级管理(机器人方向)',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '博士及以上',
      content: `工作职责:
        1、协助上级主持研究总院的全面管理工作；
        2、参与负责技术团队的搭建，主导提出机器人相关领域的重大技术项目研发方向，对整体技术水平负责；
        3、参与负责公司外部技术交流、项目评审答辩等重大活动，代表公司参加行业、专家会议，提升公司技术形象；
        4、提供营销技术支持和内部技术培训，指导编制技术标准；
        5、参与负责外报项目（课题）申报材料、专利、论文以及内部立项和调研报告的审核指导，对审核指导意见的正确性负责；
        6、作为部分课题带头人，实施课题研究以及重点技术攻关能够独立完成相关行业研究工作，撰写研究报告；
        7、能够承担研究院重大战略咨询项目的研究课题，承接相关产业领域的研究和咨询任务；
        8、完成领导授权或安排的其他工作。

        任职要求:
        1、博士及以上学历，计算机、信息学、自动化、物联网等相关专业之一，并从事过智慧城市、物联网、人工智能、机器人相关方向研究，在国家一级刊物或国家知名刊物上发表过研究文 章，或者具有个人专利；
        2、具备10年以上深入的机器人相关行业经验，有系统的研究方法论和丰富的项目研究经验，视野开阔，技术功底扎实，职业稳定性高；
        3、具备5年以上大型研发团队、研究院、研究所全盘管理经验；
        4、在行业内具备较强的学术界或产业界影响力优先考虑。`
    },
    {
      name: '机械设计',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、独立完成复杂产品的结构设计：包括架构设计、方案设计、仿真、结构细节设计；
        2、负责2D产品图、爆炸图、零件明细表等产品生产文件的编写及提交工作；
        3、负责与供应商沟通，进行零部件的选型工作；
        4、具有产品后期供应链服务能力，如手板样机，开模指导，生产评估等；
        5、负责产品开发过程中，全程技术服务、项目辅助管控。

        任职要求:
        1、机械设计、机电一体化等专业本科及以上学历，具有机械设计、模具设计等专业背景；
        2、五年以上结构设计工作经验，有机器人结构设计经验者优先；
        3、具备移动机器人底盘设计经验，能对底盘进行CAE设计分析；
        4、具备多轴机械手臂设计经验.
        5、能够完成整套产品的塑胶、五金、橡胶、玻璃、机械传动的结构设计，熟悉产品加工工艺；熟悉钣金/金属材料/塑料材料性能，具备注塑模具及冲压模具的相关知识；
        5、熟练运用Solidworks等3D设计软件，具有建复杂曲面的能力。`
    },
    {
      name: '嵌入式软件开发',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、负责软件系统总体方案设计和详细设计，负责系统层、应用层软件架构定义，负责制定系统测试方案；
        2、负责产品嵌入式软件的开发；
        3、负责产品整体软件性能提升及架构优化；
        4、负责软件系统需求分解和集成调试组织；
        5、负责软件设计文档的编制；
        6、熟悉 bsp或软件驱动层開發；
        7、熟悉RTOS。

        任职要求:
        1、机械设计、机电一体化等专业本科及以上学历，具有机械设计、模具设计等专业背景；
        2、五年以上结构设计工作经验，有机器人结构设计经验者优先；
        3、具备移动机器人底盘设计经验，能对底盘进行CAE设计分析；
        4、具备多轴机械手臂设计经验.
        5、能够完成整套产品的塑胶、五金、橡胶、玻璃、机械传动的结构设计，熟悉产品加工工艺；熟悉钣金/金属材料/塑料材料性能，具备注塑模具及冲压模具的相关知识；
        5、熟练运用Solidworks等3D设计软件，具有建复杂曲面的能力。`
    },
    {
      name: '电气设计',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、非标自动化设备电气系统研发设计，包括电气原理、选型、布线和调试等；
        2、进行PLC软硬件或相关工业控制板软硬件设计；
        3、指导和协助完成项目的生产、调试、技术服务工作；
        4、负责设备技术文件编写、标准化等工作。

        任职要求:
        1、电气、自动化、仪器仪表、机电一体化、机械电子或相关专业本科及以上学历；
        2、熟练使用EPLAN等电气设计软件；
        3、熟练掌握至少一种品牌的PLC编程和使用或工业控制板嵌入式软硬件开发；
        4、拥有机器人相关项目研发经验；熟悉机器人常用坐标变换；
        5、拥有机器人配合视觉项目开发经验。`
    },
    {
      name: '电气控制',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、团队建设；
        2、平台体系建设。

        任职要求:
        1、全面负责电控方面的技术规划、开发流程与体系建设、软硬件平台开发及能力建设；
        2、在电控系统开发项目中总体负责产品平台化与模块化设计、系统功能安全设计、软硬件架构设计、系统接口定义、控制策略、技术评审等工作；
        3、自动化行业从业8年以上，至少5年机器人电控团队管理经验；
        4、指导解决开发过程中的技术问题；
        5、指导制定电控系统的设计流程及技术规范；
        6、指导、培训电控开发主管工程师、工程师和助理工程师。 `
    },
    {
      name: '运动控制算法',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `工作职责:
        1、负责智能机器人及自主移动底盘的运动学、动力学分析和运动控制算法的开发；
        2、负责建筑机器人控制系统的方案设计和相关性能分析；
        3、负责国内外先进控制算法的数学理论推导、工程应用以及试验；
        4、负责智能机器人运动控制算法和代码的优化相关工作。

        任职要求:
        1、985或者211硕士及其以上学历，自动化、机械电子工程等相关专业；
        2、有10年以上工作经验；
        3、 熟悉1-2门编程语言;
        4、 具备扎实的控制理论基础：有先进控制理论研究经验者优先；
        5、 具备机器人控制相关知识，具有运动控制/导航相关的研发经历，以及运动控制算法设计、建模等方面的研发经验；
        6、理解坐标空间变换原理，掌握物体运动学和动力学建模的基本方法。 `
    },
    {
      name: '视觉算法',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1.根据自研产品功能需求，负责机器视觉系统的软件架构；
        2.负责机器视觉软件识别、定位、检测等功能的开发与维护；
        3.负责工业视觉应用的硬件选型与方案设计。

        任职要求:
        1.计算机、软件、自动化等相关专业，本科及本科以上学历；
        2.具备3年以上机器视觉的实际软件开发经验；
        3.掌握图像处理相关算法，能够灵活运用相关算法进行图像匹配、定位、分割、边缘提取等处理;
        4.熟悉Halcon, VisionPro， Opencv其中一种软件定制化开发；
        5.精通数字图像分析与处理算法，单目、双目和深度相机的工作原理，校准和计算；
        6.编程功底扎实，精通C/C++、OpenCV。`
    },
    {
      name: '系统架构',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、负责物联网联接管理平台架构规划及设计（包含软硬件及组网方案），对产品的整体系统架构负责；
        2、负责物联网联接管理平台运行设计工作，及主导关键框架代码编写；
        3、负责研究相关解决方案技术发展方向，了解、掌握系统架构技术。

        任职要求:
        1、全日制大学本科及以上学历，计算机、通信等相关专业，8年以上软件开发经验，3年以上大型软件系统分析、架构设计经验，主持过云上构建大型云服务系统，具备可靠性容灾架构，智能运维系统架构设计能力；
        2、熟悉掌握常用的Java类库及框架，如多线程、并发处理、I/O与网络通讯，Spring、iBatis等，对Java虚拟机有较深了解，有JVM分析及调优的实际经验。
        3、精通MySQL应用开发，熟悉数据库原理和常用性能优化技术，以及NoSQL、Hive的原理、使用场景以及限制。
        4、擅长分布式、缓存、JVM调优、序列化、NIO、RPC调用框架等，并且有相关实践经验。
        5、参与过大型复杂分布式互联网WEB系统，掌握微服务架构设计，熟悉主力的服务化框架和分布式中间件技术的设计开发者优先，拥有和工作年限相称的广度和（或）深度；
        6、熟悉设计模式，具有丰富的系统设计和重构经验；
        7、熟悉业界流行技术，有中大型平台规划和设计经验者优先，优先考虑。
        8、 有物联网工作经验优先考虑；
        9、 具备较强的学习能力和基本沟通能力。`
    },
    {
      name: '农业机器人',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、部门全面管理工作，包含团队组建；
        2、负责制定部门技术发展的路线及产品产品战略；
        3、参与负责技术团队的搭建，主导提出农业机器人相关领域的重大技术项目研发方向，对整体技术水平负责；

        任职要求:
        1、40岁以内，统招本科以上，农业机械领域10年以上工作经验；
        2、农业机械无人驾驶、自动导航控制等方面研发经验优先；
        3、具备先进农业智能设备研发思维；`
    },
    {
      name: '非标自动化机械设计',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1. 负责前期非标自动化项目可行性评估；
        2. 负责非标自动化项目的整体方案设计；
        3. 负责公司非标自动化项目的设计方案评审；
        4. 负责大型非标自动化设备、线体的机械设计开发工作；
        5. 负责非标自动化项目主要元器件，核心部件/系统的选型；
        6. 负责培训、管理机械工程师团队。

        任职要求:
        1. 本科以上学历；
        2. 7年以上非标自动化机械设计经验，能独立承担非标设备开发、设计及调试任务；
        3. 熟练掌握Solidworks、AutoCAD、UG、Pro/E等机械设计软件；
        4. 熟悉小家电或军工或汽车零部件行业的自动化装配技术、生产流程、质量体系要求及其他相关知识者优先，有大型企业任职经历者优先；
        5. 对控制系统有一定了解。`
    },
    {
      name: '装配式工厂自动化',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1. 负责前期非标自动化项目可行性评估；
        2. 负责非标自动化项目的整体方案设计；
        3. 负责公司非标自动化项目的设计方案评审；
        4. 负责大型非标自动化设备、线体的机械设计开发工作；
        5. 负责非标自动化项目主要元器件，核心部件/系统的选型；
        7. 负责培训、管理机械工程师团队。

        任职要求:
        1. 本科以上学历；
        2. 7年以上非标自动化机械设计经验，能独立承担非标设备开发、设计及调试任务；
        3. 熟练掌握Solidworks、AutoCAD、UG、Pro/E等机械设计软件；
        4. 熟悉装配式产线自动化装配技术、生产流程、质量体系要求及其他相关知识者优先；
        6. 对控制系统有一定了解。`
    },
    {
      name: '物联网平台架构师',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、负责工业物联网平台架构，系统软硬件设计，核心组件开发，微服务开发设计，技术可行性方案评审等；
        2、负责架构设计、方案讨论和技术路线调研，编写系统总体架构、业务架构、数据架构及技术架构文档，负责关键技术研究及技术预研；
        3、主持和参与系统逻辑模型和物理模型设计并实现原型，负责设计开发系统核心代码；
        4、制订系统实施质量标准体系，建设相关的质量保障与监管系统，执行质量管理；
        5、通过开发工具或开发方法的改进，提高开发效率，并对开发人员进行技术培训；
        6、负责新技术的研究与技术积累，跟进技术发展，研究各种新技术在公司业务中的应用前景，并为业务模式的发展与创新提供参考。

        任职要求:
        1、8年以上软件开发经验，3年以上物联网软件、产品、系统集成项目架构师经验；
        2、精通 Java 开发，熟悉 Spring 框架，掌握 J2EE 体系结构；
        3、掌握微服务架构设计，熟悉主力的服务化框架和分布式中间件技术；
        4、在边缘计算、平台数据采集、数据存储、数据分析服务、用户管理和安全管理方面有过统筹规划和开发的经验；
        5、高度的抽象设计能力，思路清晰，善于思考，能独立分析和解决问题，责任心强，具备良好的团队合作精神和承受压力的能力。`
    },
    {
      name: '机器人自动化电气控制',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、 熟练使用C++进行上位机编程；
        2、 熟悉机器人应用案例，能够编写机器人应用程序；
        3、 熟悉电气控制原理，懂PLC编程；
        4、 能够运用CCD进行视觉识别方面应用，例如：有无判定、尺寸测量、定位、条码识别，外观检查等；
        5、 工作经验8年以上，学历本科。

        任职要求:
        1、 根据业务需求开发机器人应用项目，导入机器人自动化设备，
        2、 熟悉控制系统架构原理，控制箱电器组件，具备机器人与电控箱之集成经验优先。
        3、 熟练使用电气设计软件（CAD或Eplan等）绘制电气原理图，根据项目需求开发上位机控制软件以及设备交互软件。
        4、 新技术研究，技术标准化建设。`
    },
    {
      name: '装配式机械',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '本科及以上',
      content: `工作职责:
        1、负责装配式建筑机器人、装配式建筑PC设备项目需求调研，参与项目方案设计；
        2、负责装配式建筑机器人的机械结构设计；
        3、负责运动仿真，并制作三维动画；
        4、负责跟进样品的试制、确认，BOM表核对，以及部分图样的绘制及输出。

        任职要求:
        1、本科及以上学历，机械工程、机械电子工程、机械工程及自动化、机电一体化等相关专业；
        2、八年以上特种机器人、非标设备或相关自动化设备公司工作经验；
        3、熟练使用Solidworks/ProE/UG、AUTOCAD软件，能用三维建模软件制作动画;
        4、工作认真负责，严谨细致，有良好的创新能力和团队协作精神。`
    },
    {
      name: '装配式工艺(总监/副总监)',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `工作职责:
        1、统筹混凝土装配式建筑主体结构施工、装配式装修施工等施工技术研究工作；
        2、指导装配式建筑施工机器人施工工艺设计；
        3、指导和协助完成机器人的测试等技术服务工作；
        4、负责设备技术文件编写、标准化等工作。

        任职要求:
        1、十年以上施工技术及管理经验，其中至少三年以上装配式建筑主体结构施工、装配式装修施工等施工一线工作经验；
        2、 精通装配式混凝土主体结构、装配式装修施工技术；
        3、土建类硕士以上学历；
        4、工作认真，严谨细致，有良好的团队精神和沟通能力，工作效率高、条理性强。`
    },
    {
      name: '装配式工艺(主任工程师/副主任工程)',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `工作职责:
        1、负责混凝土装配式建筑主体结构施工、装配式装修施工等施工技术研究；
        2、指导装配式建筑施工机器人施工工艺设计；
        3、指导和协助完成机器人的测试等技术服务工作；
        4、负责设备技术文件编写、标准化等工作。

        任职要求:
        1、五年以上施工技术及管理经验，其中至少两年以上装配式建筑主体结构施工、装配式装修施工等施工一线工作经验；
        2、 熟悉装配式混凝土主体结构、装配式装修施工技术；
        3、土建类硕士以上学历；
        4、工作认真，严谨细致，有良好的团队精神和沟通能力，工作效率高、条理性强。`
    },
    {
      name: 'BIM设计',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `工作职责:
        1、BIM正向设计项目管控、业务管理流程梳理、设计成果审核；
        2、族库制作、模型标准编写、业务数据分析；
        3、配合做成本应用研究、配合做工程应用研究；
        4、配合插件、平台开发梳理业务需求；
        5、制作汇报、培训文件，组织汇报、培训活动；
        6、研发及项目的招投标组织工作，分包管理工作。

        任职要求:
        1、建筑学专业（建筑方向），建筑给排水、暖通、电气相关专业（机电方向），环艺等相关专业（精装方向），全日制本科及以上学历（211/985院校优先）；
        2、知名设计院/设计公司工作8年以上，从事BIM工作4年以上，若有甲方工作经验，可适当放宽；
        3、乙方作为项目负责人或专业负责人完成过住宅、商业、酒店类的BIM正向设计项目不少于3个；或甲方设计负责人管控BIM正向设计项目不少于1个；
        4、熟练应用Revit等BIM相关软件。
        5、有BIM算量、施工模拟等成本、工程方面的应用经验优先考虑；
        6、有设计、成本、工程等业务信息分类梳理工作经验优先考虑；
        7、有过软件、平台开发的产品或需求工作经验优先考虑；
        8、有建筑实施过程中的工艺深化（保温、涂料、幕墙等，可以是非BIM项目）经验者优先考虑。`
    },
    {
      name: 'BIM设计（建筑、精装、结构方向）',
      city: '佛山',
      salary: '面议',
      type: '社招/校招',
      edu: '硕士及以上',
      content: `工作职责:
        1、负责项目/专业的内外部管理及技术协调工作；
        2、对设计成果进行审核及质量管理，提出合理建议并组织解决问题，进行模型维护；
        3、负责各专业的综合协同工作，BIM项目工作进度的管控；
        4、负责管理BIM团队，确定人员工作职责，日常工作评估、培训等；
        5、负责BIM技术标准制定、相关数据库定制管理；
        6、负责项目的BIM模型建立、建筑分析、正向出图等相关应用工作；
        7、根据项目需求进行BIM可持续设计；
        8、BIM正向设计项目管控、业务管理流程梳理；
        9、辅助族库制作、业务数据分析；
        10、辅助配合做成本应用研究、配合做工程应用研究；
        11、辅助配合插件、平台开发梳理业务需求；
        12、辅助研发及项目的招投标组织工作，分包管理工作。

        任职要求:
        1、建筑学专业（建筑方向）、土木工程、建筑给排水、暖通、电气相关专业（机电方向）等相关专业，全日制本科及以上学历（211/985院校优先）；
        2、5-8年以上甲级设计院相关设计工作，从事BIM工作2年以上；
        3、熟悉相关专业技术设计规范，担任过3个以上项目负责人或专业负责人完成过住宅、商业、酒店类的BIM正向设计项目不少于2个；
        4、工作积极主动，团队意识强，有较强的沟通和表达能力；
        5、对工作认真负责、善于沟通善于发现、分析和解决问题，有较强的学习能力；
        6、熟练应用Revit、Navisworks等BIM软件；
        7、熟练应用word、excel、ppt等office办公软件；
        8、有BIM算量、施工模拟等成本、工程方面的应用经验优先考虑；
        9、有设计、成本、工程等业务信息分类梳理工作经验优先考虑；
        10、有过软件、平台开发的产品或需求工作经验优先考虑；
        11、有建筑实施过程中的工艺深化（保温、涂料、幕墙等，可以是非BIM项目）经验者优先考虑。`
    }
  ]
},
{
  name: '斯坦德机器人',
  intro: `斯坦德机器人（深圳）有限公司，专注于工业级移动机器人的研发与生产，实现了从机器人底层定位算法、操作系统、控制器等核心元素的自主研发全覆盖，主要产品为激光导航AGV及其调度系统。斯坦德机器人(Standard Robots)致力于为优秀的系统集成商及终端制造工厂寻找标准化、可复制的算法应用场景，实现其柔性化、敏捷化的厂内物流需求，为客户践行轻资产、回报快的初期物流投入，为行业构建信息化、数据化的物流基础设施，是全球真正践行把激光导航AGV应用于华为、中兴、富士康等实际工业物流领域的高科技企业。
  `,
  img: true,
  desc: ``,
  city: '深圳',
  field: '移动机器人/激光slam',
  scale: '50-100人',
  financing: 'Pre-A轮',
  tags: ["年底双薪", "岗位晋升", "弹性工作", "绩效奖金", "带薪年假", "股票期权", "定期体检", "扁平化管理", "午餐补贴"],
  web: '',
  jds: [
    {"name":"计算机视觉算法工程师（VSLAM方向）","type":"社招","city":"深圳","content":"工作职责:\n1、负责室内环境下，2D visual inertial odometry算法研发工作\n2、负责在室内环境，基于单目摄像头/双目景深摄像头/IMU/GPS/轮速计等多传感器滤波融合算法的开发；\n3、负责视觉算法的研发和产品化\n\n岗位要求:\n1、两年以上VIO、SLAM、SFM、定位算法经验，熟悉KF、EKF、ICP、图优化理论等\n2、熟悉目前主流的视觉VIO/VO/SLAM算法(如MSCKF、SVO、DSO、ORB-SLAM等)\n3、具有机器视觉、多传感器信息融合、惯导等组合导航专业知识\n4、熟练掌握C/C++/Python/Matlab等一门或多门编程语言\n5、熟悉在Linux系统上的开发工作，对ROS系统、机器人导航等领域有深入研究\n6、具备良好的自学能力和沟通能力，具有较强的学习能力","edu":"本科","salary":"20-40k"},{"name":"控制算法工程师","type":"社招","city":"深圳","content":"工作职责：\n1、开发和测试各种移动机器人底盘控制算法。\n2、负责各种机器人运动控制算法的开发调试。\n3、编写详细的控制软件开发文档。\n\n岗位要求：\n0、计算机、自动化、机器人相关专业大学本科毕业，研究生优先。\n1、有扎实的控制论基础和控制算法实现能力。\n2、熟悉嵌入式软件开发。\n3、熟练使用仿真工具，如matlab或mathematics等。\n4、具备较好的编程功底，熟练使用C及C++编程。\n5、熟练阅读机器人相关英文文献。\n6、具备独立思考能力和良好的沟通能力以及团队合作精神。\n7、大学期间有机器人比赛相关经历者优先。","edu":"本科","salary":"15-40k"},{"name":"嵌入式软件工程师","type":"社招","salary":"15-35k","content":"工作职责： \n1.负责嵌入式系统开发和验证，MCU/CPU驱动和外围器件驱动程序开发；\n2.负责产品嵌入式功能开发、通讯功能开发以及协助产品整体调试； \n3.负责协助功能、算法开发，解决遇到的嵌入式的问题； \n4.负责嵌入式系统的维护和升级。 \n\n岗位要求： \n1. 3年以上开发经验（项目经验丰富者时间不限），本科及以上学历，计算机、电子、 通信、自动化或机电相关专业，具有扎实的数字电路、模拟电路、微机原理、数据结构 等专业理论基础知识； \n2. 精通C/C++编程语言，具有良好的开发习惯、文档规范及编码习惯； \n3. 精通至少一款RTOS操作系统的移植、裁剪、驱动开发或者应用开发； \n4. 精通单片机裸奔程序的驱动开发或者应用开发； \n5. 精通ARM处理器，精通UART、SPI、IIC、CSI、CAN、Ethernet、USB等外设驱动开发； \n6. 有较强的阅读理解所驱动的传感器或设备英文文档能力； \n7. 具有较强逻辑分析能力、学习能力和独立解决问题的能力； \n8. 有CAN open/Modbus/EtherCAT开发移植经验者优先； \n9. 有FPGA/DSP开发经验者优先； \n10. 有计算机视觉算法开发经验者优先； \n11. 熟悉Linux操作系统的移植、裁剪、驱动开发或者应用开发，对操作系统运行机制、设备驱动模型有深刻理解者优先； \n12. 熟悉嵌入式软件设计方法，有程序架构设计经验，对软件的模块化、可移植性有深入的理解，精通计算机原理，能对代码进行面积优化或者性能优化者优先；","city":"深圳","edu":"本科"},{"name":"项目应用工程师","type":"社招","content":"基本要求： 机电及软件类相关专业，本科 1 年以上工作经验，或者优秀应届生 \n岗位职责： \n1. 精通产品应用，负责产品在客户现场部署实施以及客户培训，负责项目售后支持； \n2. 解决在产品应用中遇到的技术问题，编制常见问题处理指导文档； \n3. 收集产品现场应用出现的问题反馈给项目经理； \n4. 分析和整合客户的需求，协助研发提高产品应用体验。 \n岗位要求： \n1. 有扎实的软件或机械结构或电气知识基础； \n2. 可以独立拆装产品机械结构，具备电气系统接线与调试能力； \n3. 具备较强的学习能力，优秀的表达沟通能力； \n4. 具有较好的责任心，积极的工作态度和团队合作精神； \n5. 能够适应短期国内出差。 \n加分项： \n1. 可熟练运用编程语言（C#）、熟练编程者优先；\n2. 有 AGV/或类似机器人技术类工作经验者优先。","city":"深圳","edu":"本科","salary":"8-15k"},{"name":"机械工程师","type":"社招","content":"基本要求： 机械或机电类相关专业，本科 3 年以上，大专 5 年以上机械设计经验。 \n岗位职责： \n1. 根据产品功能需求，制定结构设计方案和制造成本估算； \n2. 独立完成机器人结构、机械部件的设计出图，及 BOM 编制； \n3. 参与产品加工装配过程中的质量和进度跟踪，持续优化产品设计； \n4. 完成相关机械技术文档和图纸的归档工作。 \n岗位要求： \n1. 熟悉减速机、伺服电机、传动机构选型并精通相关知识，了解周边传感器应用； \n2. 熟悉焊接件、钣金件、机加件设计要点及加工工艺，能够独立完成机械结构设计； \n3. 熟练使用 AUTOCAD、SOLIDWORKS 等工具； \n4. 对项目认真负责，执行力强，按时完成上级安排的工作； \n5. 具备严谨的设计理念和对细节的把控能力，有追求完美产品的心态。 \n加分项：\n1. 有非标自动化设计 /AGV 设计经验者优先 ； \n2. 有独立设计产品经验者优先。","city":"深圳","edu":"大专","salary":"8-20k"},{"name":"销售经理","type":"社招","content":"基本要求：2年以上自动化、3C、半导体、汽配等行业从业经验（任一行业即可）。 \n岗位职责： \n1. 负责市场的调研、销售和客户开发；\n2、负责合同的正确签订及合同评审的填写； \n3、负责货款的回收；\n4、负责搜集、反馈市场信息；\n5、及时准确的反馈客户的投诉和建议；\n6、依据客户要求，清晰、完整的向生产部提供客户订货、质量、发货信息；\n7、 负责客户稿件的初审及校对；\n8、完成部门负责人下达的各项工作\n岗位要求： \n1.为人正直、有原则、品行良好；\n2、专科及以上学历，最好是理工科背景；\n3、有2年以上，物流、自动化行业销售经验；\n4、热爱销售工作，思维敏捷，良好的口才和市场开拓经验；\n5、较强的沟通、协调能力和团队协作能力；\n6、基本工资+销售提成","city":"深圳","edu":"不限","salary":"17-40k"},{"name":"售前技术支持","type":"社招","content":"岗位职责： \n根据客户需求提供工厂物料搬运的解决方案；\n了解需求中方案组成及软硬件系统架构；\n配合销售做好售前、售中技术支持，\n主导招标的策划工作。\n岗位要求： \n理工科本科以上学历，\n2年以上物流自动化、非标自动化行业工作经验\n有良好的演说能力。","city":"深圳","edu":"本科","salary":"8-15k"}
  ]
},
{
  name: '科大智能',
  intro: `科大智能科技股份有限公司于2002年成立。2011年5月，在深圳证券交易所创业板成功上市（股票代码：300222）。
  科大智能专注行业细分领域核心技术的创新研发与应用，致力于工业智能化相关领域，机器人应用、配用电自动化、通信与信息技术产品的研发、生产与技术服务，是国家高新技术企业、软件企业，承担国家火炬计划项目1项，科技部中小企业创新基金1项，拥有自主创新产品和重点新产品多项，多次获得国家和省市的科技进步奖，其中实用型配电自动化关键技术研究与应用获得了国家电网公司科学技术进步二等奖。 依托在智能电网配用电设备和智能装备制造领域形成的技术优势，公司联合中国科技大学、上海交通大学、合肥工业大学等相关科研院所，采用科研与生产结合、技术开发、转化等方面的有效形式和高效的公司运行机制，已发展成为“工业4.0”时代智能电网设备和国产智能制造装备系统解决方案的提供者和创新者。截至目前，公司拥有科大智能电气技术有限公司、上海永乾机电有限公司、烟台科大正信电气有限公司、科大智能（合肥）科技有限公司四个子公司，主要产品及服务：配用电自动化、工业机器人、自动化生产线、通信与信息技术产品的设计、制造、销售、服务等。 科大智能以“智能科技，智慧未来”为愿景，将“领先应用技术，创造客户价值”作为经营理念，以质量体系、环境体系、职业健康三大体系作为公司的运行标准，以科技为先导，持续改进，为客户提供有价值的产品和最满意的服务。
  `,
  img: true,
  desc: `引领智能科技，开创智慧未来`,
  city: '上海',
  field: '机器人 人工智能 物联网',
  scale: '1000人以上',
  financing: '已上市',
  tags: ["带薪年假", "午餐补助", "定期体检", "免费班车", "技能培训", "岗位晋升等"],
  web: '',
  jds: [
    {
      name: '视觉应用工程师',
      salary: '9-15K',
      type: '社招',
      edu: '本科',
      city: '上海松江',
      content: `职责描述：
      1､负责公司2D/3D视觉类项目的现场实施和调试；
      2､负责客户的培训/负责客户的售前和售后技术支持；
      3､负责公司视觉系统或产品的应用开发；
      4､配合公司视觉类新产品、新技术和新项目的研究、方案设计和落地；
      5､配合集团或分子公司完成其他支持工作；

      任职要求：
      1、教育背景：电气自动化、机械电子、自动控制、计算机、机器人相关专业，工作1-3年； 
      2、有视觉应用类工程项目实施经历者优先（汽车行业经历优先）； 
      3、有ISRA、VMT、易思维、perceptron、康耐视等视觉产品应用经验或工作经历者优先； 
      4、有opencv、halcon、visionpro等软件开发经验者优先； 
      5、有ABB、fanuc、kuka、UR等机器人，西门子、AB等PLC应用经验或培训证明者优先； 
      6、能够接受长期出差和客户现场陪产；`
    },
    {
      name: '软件开发工程师（C/C++）',
      salary: '12-20K',
      type: '社招',
      edu: '硕士',
      city: '上海松江',
      content: `岗位职责：
      1、 负责agv导航路径编辑及规划； 
      2、 负责agv中各个模块间的数据交互，以及逻辑处理； 
      3、 负责地图后期编辑及维护； 
      4、 负责地图UI界面设计。 
      任职资格：
      1、 熟悉C、C++编程和常用数据结构算法； 
      2、 具备AGV相关工作经验者优先； 
      3、 具备良好的逻辑沟通能力和解决实际问题的能力； 
      4、 211院校，机械电子、计算机、自动控制、电子信息类等专业，硕士以上学历，1年以上相关工作经验，1-3年经验。
      `
    }
  ]
}
]

componys = componys.map(v => {
  v.field = v.field.replace(/ /g, '、')
  v.city = v.city.replace(/ /g, '、')
  for (let jd of v.jds) {
    jd.salary = jd.salary.toLocaleUpperCase()
    if (jd.salary.includes('K')) {
      // jd.salary = jd.salary.replace(/K/g, '').replace('~', '-') + 'K'
      if (jd.edu) {
        jd.edu = jd.edu.replace('本科及以上', '本科')
      }
    }
  }
  return v
})

export default componys
